import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import DatePicker from "react-datepicker";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { ddlSearchWithTab as SingleSearchDropdownList } from "../../Common/Components/ddlSearchWithTab";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import Dropzone from "react-dropzone";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FiChevronDown } from "react-icons/fi";
import "./slideout.scss";
import $ from "jquery";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../Common/Services/Register";
import { ToastContainer, toast } from "react-toastify";
import PDFViewer from "./pdf-viewer";
import { confirmAlert } from "react-confirm-alert";
import { VendorSearchTypeahead as VendorSearch } from "../../Common/Components/VendorSearchTypeahead";
import { SingleSelectSearchDDL } from "../../Common/Components/SingleSelectSearchDDL";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import { CreditCardStatementImport } from "./creditCardStatement/CreditCardStatementImport";
import { TransactionLogHistory } from "./TransactionLogHistory";
import { CommentBox } from "../../Common/Components/CommentBox";
import { CommentWithoutList } from "../../Common/Components/CommentWithoutList";
import { Utils } from "../../Common/Utilis";
import { TextractMapping } from "./TextractMapping";
import ScrollContainer from "react-indiana-drag-scroll";
import OutsideClickHandler from "react-outside-click-handler";
import { InvoiceApprovalS } from "../../Common/Services/InvoiceApprovals";
import { UnApproveModal } from "../../Common/Components/UnApproveModal";
import { User } from "../../Common/Services/User";
import Autocomplete from "../../Common/Components/AutoComplete";
import moment from 'moment';

let routeLeavingGuard: any = null;
let docViewerFiles: any = [];
export class InvoiceEntrySlideout extends React.Component<any, any> {
  private vendorSearch: any;
  private pageName = "InvoiceEntry";
  private footerchk: any;
  private trDate: any;
  private scrollheight: any;
  private trdueDate: any;
  private trpaymentdate: any;
  private singleSerch: any;
  private ChildComment: any;
  private parentScroll: any;
  private notesTextAreaRef: any;

  private iconFormatter = (column, colIndex) => {
    return (
      <Dropdown className="more-action bg-blue dropdown rolePermissiondropdown d-flex justify-content-end align-items-center">
        <Dropdown.Toggle
          tabIndex={this.state.tabDisable}
          id="colList"
          className="d-flex align-items-center"
        >
          <div className="icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16.3914 2H3.60861C2.72146 2 2 2.79733 2 3.77778V16.2222C2 17.2027 2.72146 18 3.60861 18H16.3914C17.2785 18 18 17.2027 18 16.2222V6.44356V5.55467V4.66578V3.77778V3.77689C17.9992 2.79644 17.2769 2 16.3914 2ZM6.82582 16.2222H3.60861V6.44356H6.82582V16.2222ZM11.6516 16.2222H8.43442V6.44356H11.6516V16.2222ZM13.2602 16.2222V6.44356H16.3914L16.3922 16.2222H13.2602Z" />
            </svg>
          </div>
          <div className="arrow-icon">
            <FiChevronDown />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="rolePermissionSelector">
          <div className="header">Columns</div>
          <div className="dropdownItems">
            {this.state.tableColumnList.map((items, index) => (
              <div className="dropdown-item" key={index}>
                <EllipsisWithTooltip placement="bottom">
                  <Form.Check
                    type="checkbox"
                    id={`list_${items.id}`}
                    name={items.name.toLowerCase()}
                    label={items.name}
                    value={items.id}
                    onChange={(event) =>
                      this.onChangeStatus(event, items, index)
                    }
                    checked={items.isChecked}
                    disabled={items.disabled}
                  />
                </EllipsisWithTooltip>
              </div>
            ))}
          </div>
          <button
            className="mr-auto btn  wht-bg default-view"
            onClick={this.handleSaveColumn}
            disabled={this.state.isdefaultColDisabled}
          >
            Save as Default View
          </button>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  private transactionsColumns = [
    {
      dataField: "lettercode",
      text: "EHID",
      headerClasses: "ehid",
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" &&
              this.state.formData.adj.toString() !== "Y" &&
              row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={this.state.splitHIDList}
              handleSelectedItem={this.handleSelectedItem.bind(
                row,
                1 + "_" + rowIndex
              )}
              defaultItem={row.defaultEhid}
              defaultText={"Search EHID"}
              defaultName={row.defaultEhid}
              controlID="1"
              id={"ddlEHID-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(
                this,
                "ddlEHID-" + rowIndex + "ddl",
                rowIndex
              )}
              disabled={disable}
            />
          </div>
        );
      },
    },

    {
      dataField: "coaName",
      text: "COA",
      headerClasses: "coa",
      classes: "coa-col",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "COA" + rowIndex + "btn";
        let id = "coa" + rowIndex + "ddl";
        const defaultCoa = row.coa + " " + row.coaName;
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <div>
            <div
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                  "active" &&
                this.state.formData.adj.toString() !== "Y" &&
                row.isCOAPer === "Yes"
                  ? ""
                  : "disabled-area"
              }
            >
              <>
                <div
                  id={id}
                  style={
                    row.isCOA === "Yes"
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  className="more-action single-select-image dropdown coa-select"
                >
                  <Typeahead
                    inputProps={{
                      className: "coa" + rowIndex + "ddl",
                      title: defaultCoa,
                    }}
                    id={"coa" + rowIndex + "ddl"}
                    options={this.state.coaList}
                    placeholder={"Enter COA"}
                    disabled={disable}
                    renderMenu={(results: any, menuProps) => (
                      <Menu {...menuProps}>
                        {results.map((result: any, index: any) => (
                          <>
                            {this.state.coaList.length > 0 &&
                              results[index - 1]?.orderno === 1 &&
                              result?.orderno === 2 && <Dropdown.Divider />}
                            {result.label !== "" && (
                              <MenuItem
                                option={result}
                                position={index}
                                onWheel={() => this.hoverOutEllipsis()}
                              >
                                <EllipsisWithTooltip placement="bottom">
                                  {result.label}
                                </EllipsisWithTooltip>
                              </MenuItem>
                            )}
                            {result.label === "" && (
                              <MenuItem
                                className="load-more"
                                option={result}
                                position={index}
                              >
                                Load More
                              </MenuItem>
                            )}
                          </>
                        ))}
                      </Menu>
                    )}
                    onChange={this.handleSelectedItem.bind(
                      this,
                      2 + "_" + rowIndex
                    )}
                    selected={row.defaultCoa}
                    onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                    onKeyDown={this.onTAB.bind(
                      this,
                      "ddlCOA-" + rowIndex.toString() + "ddl",
                      rowIndex
                    )}
                  />
                </div>

                <button
                  className={
                    row.coaName === "" ? "custom-btn placeholder" : "custom-btn"
                  }
                  id={btnId}
                  style={
                    row.isCOA === "Yes"
                      ? { display: "none", width: "100%" }
                      : { display: "block", width: "100%" }
                  }
                  onClick={() => {
                    this.handleCOAFocus(
                      btnId,
                      id,
                      "rbt-input-main form-control rbt-input coa" +
                        rowIndex +
                        "ddl",
                      rowIndex
                    );
                  }}
                  onFocus={() => {
                    this.handleCOAFocus(
                      btnId,
                      id,
                      "rbt-input-main form-control rbt-input coa" +
                        rowIndex +
                        "ddl",
                      rowIndex
                    );
                  }}
                >
                  {row.coaName === "" && (
                    <EllipsisWithTooltip placement="bottom">
                      {"Enter COA"}
                    </EllipsisWithTooltip>
                  )}
                  {row.coaName !== "" && (
                    <EllipsisWithTooltip placement="bottom">
                      {defaultCoa}
                    </EllipsisWithTooltip>
                  )}
                </button>
              </>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "subVendor",
      text: "Sub Vendor",
      headerClasses: "subVendor",
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" &&
              this.state.formData.adj.toString() !== "Y" &&
              row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={row.subVendorlist}
              handleSelectedItem={this.handleSelectedItem.bind(
                this,
                3 + "_" + rowIndex
              )}
              defaultItem={row.defaultVendor}
              defaultText={"Search sub vendor"}
              defaultName={row.defaultVendor}
              controlID="3"
              id={"ddlSubVendor-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(
                this,
                "ddlSubVendor-" + rowIndex + "ddl",
                rowIndex
              )}
              disabled={disable}
            />
          </div>
        );
      },
    },
    {
      dataField: "projectName",
      text: "Project",
      headerClasses: "project",
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" &&
              this.state.formData.adj.toString() !== "Y" &&
              row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={row.projectlist}
              handleSelectedItem={this.handleSelectedItem.bind(
                this,
                4 + "_" + rowIndex
              )}
              defaultItem={row.defaultProject}
              defaultText={"Search Project"}
              defaultName={row.defaultProject}
              controlID="4"
              id={"ddlProject-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(
                this,
                "ddlProject-" + rowIndex + "ddl",
                rowIndex
              )}
              disabled={disable}
            />
          </div>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerClasses: "description",
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdesc" + rowIndex + "txt";
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <>
            <div
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                  "active" &&
                this.state.formData.adj.toString() !== "Y" &&
                row.isCOAPer === "Yes"
                  ? ""
                  : "disabled-area"
              }
            >
              <Autocomplete
                id={id}
                selected={row.description}
                data={this.state.descCOAMapping}
                rowId={rowIndex}
                onBlurDesc={this.handleDescChange.bind(this)}
                disabled={disable}
                handleDescFocus={this.handleDescriptionFocus.bind(this)}
              />
            </div>
          </>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      headerClasses: "amount",
      classes: "amount",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtamt" + rowIndex + "txt";
        let isBedgeProcessing = this.state.invoiceBedge
          .toString()
          .toLowerCase()
          .includes("processing");
        let disable = isBedgeProcessing
          ? true
          : this.state.isPermission === "No" ||
            this.state.formData.vendorID === 0 ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
              "active" ||
            row.isCOAPer !== "Yes" ||
            this.state.formData.adj.toString() === "Y" ||
            this.state.formData.ispayment === "Yes"
          ? true
          : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" &&
              this.state.formData.adj.toString() !== "Y" &&
              row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Amount"
              value={row.amount}
              onChange={(e) => this.updateState(e, rowIndex, "amt", id)}
              onKeyDown={(e: any) => this.handleBlur(e, rowIndex)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex)}
              onFocus={(e: any) => this.onSplitAmountFocus(e, rowIndex, id)}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },
    {
      dataField: "Attachment",
      text: "",
      headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        if (this.state.splitData.length === 1) {
          return <div></div>;
        } else {
          return (
            <Dropdown
              className="more-action confirmation-modal"
              alignRight
              tabIndex={this.state.tabDisable}
            >
              <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary more fa-trash"
                id="dropdown-more-delete"
                tabIndex={this.state.tabDisable}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={confirmModalContent}
                  ishandleDeletePosition={this.ishandleDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      },
    },
  ];

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.vendorSearch = React.createRef();
    this.footerchk = React.createRef();
    this.scrollheight = React.createRef();
    this.trDate = React.createRef();
    this.trdueDate = React.createRef();
    this.trpaymentdate = React.createRef();
    this.singleSerch = React.createRef();
    this.ChildComment = React.createRef();
    this.notesTextAreaRef = React.createRef<HTMLTextAreaElement>();
    this.state = {
      statusTypeList: [
        { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
        { id: 2, name: "Needs Review", eventName: "Needs Review" },
        { id: 3, name: "Reviewed", eventName: "Reviewed" },
        { id: 4, name: "Review Complete", eventName: "Review Complete" },
      ],
      isReviewed: false,
      showReviewBanner: false,
      showCommentModal: false,
      commentModalTitle: "",
      reviewStatus: "Flag for Review",
      selectedReviewStatus: "",
      reviewCurrentDescription: "",
      savedPaymentType: "",
      autoCompleteData: ["Pay BY Phone Payment", "Payment from Net banking"],
      islimited: "No",
      somechange: false,
      mpaymentOprID: "",
      mpaymentDate: "",
      movebuttonDisable: false,
      copyData: "No",
      firstSelctedCheckboxYPos: 0,
      moveselected: false,
      vendorApproval: "App",
      isAccount: true,
      isextractShow: false,
      ispdfExtract: "No",
      IsEditInvoiceExtractionMapping: "No",
      IsGearIconWillShow: "No",
      isextractShowbuttonNew: false,
      isGearicoSettingbuttonNew: false,
      isMappingSettingBanner: false,
      isPreTraAttachment: false,
      emailPdfID: 0,
      isHtmlBody: "No",
      emailLink: "",
      activeToggle: true,
      mapData: [],
      LinemapData: [],
      textractMap: false,
      selectedExtractFile: [],
      PdfExtractList: [],
      totalAmountdiff: 0.0,
      isAmountDiff: "No",
      currentZoom: 1.0,
      isvendorShow: true,
      htmlcomment: [],
      isComment: false,
      updatedAccountName: "",
      selectdefaultperiod: "Accounting Period",
      isSave: false,
      selectedChk: [],
      uploadedBy: "",
      uploadedDate: "",
      associatedPayments: [],
      associatedInvoice: [],
      modalOpen: "",
      isSpinner: false,
      trDateOpen: true,
      scrollAreaHeight: 0,
      chkIds: [],
      showInvoiceModal: false,
      bulkSelect: false,
      ispopupshow: false,
      saveentryType: "",
      saverequest: [],
      isStateChanged: false,
      hotelName: "",
      hotelValue: this.props.hidValue,
      isdefaultColDisabled: false,
      totalCount: 0,
      CopyisPermission: "No",
      isPermission: "No",
      isCCImportPermission: "No",
      isInvoiceEntry: "No",
      isMovePermission: "No",
      isPerviousPermission: "No",
      canReview: "No",
      canFlag: "No",
      isDelete: "No",
      isEdit: "No",
      digitalLimit: 0,
      isDigitalEnable: "No",
      defaultView: "doc-view",
      defaultEntry: "all-entry",
      isduplicateInvoice: false,
      isduplicateEHIDInvoice: false,
      fileSelect:
        "data:application/pdf;base64,JVBERi0xLjMNCiXi48/TDQoNCjEgMCBvYmoNCjw8DQovVHlwZSAvQ2F0YWxvZw0KL091dGxpbmVzIDIgMCBSDQovUGFnZXMgMyAwIFINCj4+DQplbmRvYmoNCg0KMiAwIG9iag0KPDwNCi9UeXBlIC9PdXRsaW5lcw0KL0NvdW50IDANCj4+DQplbmRvYmoNCg0KMyAwIG9iag0KPDwNCi9UeXBlIC9QYWdlcw0KL0NvdW50IDINCi9LaWRzIFsgNCAwIFIgNiAwIFIgXSANCj4+DQplbmRvYmoNCg0KNCAwIG9iag0KPDwNCi9UeXBlIC9QYWdlDQovUGFyZW50IDMgMCBSDQovUmVzb3VyY2VzIDw8DQovRm9udCA8PA0KL0YxIDkgMCBSIA0KPj4NCi9Qcm9jU2V0IDggMCBSDQo+Pg0KL01lZGlhQm94IFswIDAgNjEyLjAwMDAgNzkyLjAwMDBdDQovQ29udGVudHMgNSAwIFINCj4+DQplbmRvYmoNCg0KNSAwIG9iag0KPDwgL0xlbmd0aCAxMDc0ID4+DQpzdHJlYW0NCjIgSg0KQlQNCjAgMCAwIHJnDQovRjEgMDAyNyBUZg0KNTcuMzc1MCA3MjIuMjgwMCBUZA0KKCBBIFNpbXBsZSBQREYgRmlsZSApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY4OC42MDgwIFRkDQooIFRoaXMgaXMgYSBzbWFsbCBkZW1vbnN0cmF0aW9uIC5wZGYgZmlsZSAtICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjY0LjcwNDAgVGQNCigganVzdCBmb3IgdXNlIGluIHRoZSBWaXJ0dWFsIE1lY2hhbmljcyB0dXRvcmlhbHMuIE1vcmUgdGV4dC4gQW5kIG1vcmUgKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NTIuNzUyMCBUZA0KKCB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDYyOC44NDgwIFRkDQooIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjE2Ljg5NjAgVGQNCiggdGV4dC4gQW5kIG1vcmUgdGV4dC4gQm9yaW5nLCB6enp6ei4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjA0Ljk0NDAgVGQNCiggbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDU5Mi45OTIwIFRkDQooIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNTY5LjA4ODAgVGQNCiggQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA1NTcuMTM2MCBUZA0KKCB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBFdmVuIG1vcmUuIENvbnRpbnVlZCBvbiBwYWdlIDIgLi4uKSBUag0KRVQNCmVuZHN0cmVhbQ0KZW5kb2JqDQoNCjYgMCBvYmoNCjw8DQovVHlwZSAvUGFnZQ0KL1BhcmVudCAzIDAgUg0KL1Jlc291cmNlcyA8PA0KL0ZvbnQgPDwNCi9GMSA5IDAgUiANCj4+DQovUHJvY1NldCA4IDAgUg0KPj4NCi9NZWRpYUJveCBbMCAwIDYxMi4wMDAwIDc5Mi4wMDAwXQ0KL0NvbnRlbnRzIDcgMCBSDQo+Pg0KZW5kb2JqDQoNCjcgMCBvYmoNCjw8IC9MZW5ndGggNjc2ID4+DQpzdHJlYW0NCjIgSg0KQlQNCjAgMCAwIHJnDQovRjEgMDAyNyBUZg0KNTcuMzc1MCA3MjIuMjgwMCBUZA0KKCBTaW1wbGUgUERGIEZpbGUgMiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY4OC42MDgwIFRkDQooIC4uLmNvbnRpbnVlZCBmcm9tIHBhZ2UgMS4gWWV0IG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NzYuNjU2MCBUZA0KKCBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY2NC43MDQwIFRkDQooIHRleHQuIE9oLCBob3cgYm9yaW5nIHR5cGluZyB0aGlzIHN0dWZmLiBCdXQgbm90IGFzIGJvcmluZyBhcyB3YXRjaGluZyApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY1Mi43NTIwIFRkDQooIHBhaW50IGRyeS4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NDAuODAwMCBUZA0KKCBCb3JpbmcuICBNb3JlLCBhIGxpdHRsZSBtb3JlIHRleHQuIFRoZSBlbmQsIGFuZCBqdXN0IGFzIHdlbGwuICkgVGoNCkVUDQplbmRzdHJlYW0NCmVuZG9iag0KDQo4IDAgb2JqDQpbL1BERiAvVGV4dF0NCmVuZG9iag0KDQo5IDAgb2JqDQo8PA0KL1R5cGUgL0ZvbnQNCi9TdWJ0eXBlIC9UeXBlMQ0KL05hbWUgL0YxDQovQmFzZUZvbnQgL0hlbHZldGljYQ0KL0VuY29kaW5nIC9XaW5BbnNpRW5jb2RpbmcNCj4+DQplbmRvYmoNCg0KMTAgMCBvYmoNCjw8DQovQ3JlYXRvciAoUmF2ZSBcKGh0dHA6Ly93d3cubmV2cm9uYS5jb20vcmF2ZVwpKQ0KL1Byb2R1Y2VyIChOZXZyb25hIERlc2lnbnMpDQovQ3JlYXRpb25EYXRlIChEOjIwMDYwMzAxMDcyODI2KQ0KPj4NCmVuZG9iag0KDQp4cmVmDQowIDExDQowMDAwMDAwMDAwIDY1NTM1IGYNCjAwMDAwMDAwMTkgMDAwMDAgbg0KMDAwMDAwMDA5MyAwMDAwMCBuDQowMDAwMDAwMTQ3IDAwMDAwIG4NCjAwMDAwMDAyMjIgMDAwMDAgbg0KMDAwMDAwMDM5MCAwMDAwMCBuDQowMDAwMDAxNTIyIDAwMDAwIG4NCjAwMDAwMDE2OTAgMDAwMDAgbg0KMDAwMDAwMjQyMyAwMDAwMCBuDQowMDAwMDAyNDU2IDAwMDAwIG4NCjAwMDAwMDI1NzQgMDAwMDAgbg0KDQp0cmFpbGVyDQo8PA0KL1NpemUgMTENCi9Sb290IDEgMCBSDQovSW5mbyAxMCAwIFINCj4+DQoNCnN0YXJ0eHJlZg0KMjcxNA0KJSVFT0YNCg==",
      isDisabled: false,
      tabEnable: 0,
      tabDisable: -1,
      incompleteFiles: [],
      incompleteFilesCopy: [],
      savedfiles: [],
      newSelectfiles: [],
      files: [],
      isPreviousTransactions: false,
      isOpenViewer: false,
      selectedCoa: 0,
      selectedVendor: 0,
      selectedProject: 0,
      selectedEhid: 0,
      selectedpaymentType: "",
      selectedaccountingPeriod: 0,
      selectedPeriod: "",
      defaultCoa: [],
      defaultVendor: "Select Sub Vendor",
      defaultProject: "Select Project",
      defaultEhid: "EHID",
      coaList: [],
      splitHIDList: [],
      subVendorList: [],
      projectList: [],
      vendorList: [],
      accPeriodList: [],
      PeriodList: [],
      previousTransactionsData: [],
      transactionsColumns: this.transactionsColumns,
      totalAmount: "$0.00",
      amountTotal: 0.0,
      isRepeat: false,
      createOther: false,
      vendorSelected: [],
      defaultpaymentType1: "Select Type",
      defaultpaymentType2: "Select Type",
      defaultpaymentType: "Select Type",
      defaultaccountingPeriod: "Accounting Period",
      defaultPeriod: "Accounting Period",
      defaultaccountType: "Select Account",
      accountlist: [],
      paymentType: [],
      isPaymentChange: "no",
      paymentTypePaid: [
        { id: "ACH", name: "Manual ACH" },
        { id: "Credit Card", name: "Credit Card" },
      ],
      defaulttranscationDate: null,
      defaultduedate: null,
      HIDColumn: false,
      vendorDays: 0,
      fileSize: 5242880,
      tableColumnList: [
        { id: "ehid", name: "EHID", isChecked: true, disabled: true },
        { id: "coa", name: "COA", isChecked: true, disabled: true },
        {
          id: "sub vendor",
          name: "Sub Vendor",
          isChecked: false,
          disabled: false,
        },
        { id: "project", name: "Project", isChecked: false, disabled: false },
        {
          id: "description",
          name: "Description",
          isChecked: true,
          disabled: false,
        },
        { id: "amount", name: "Amount", isChecked: true, disabled: true },
      ],
      CopytableColumnList: [
        { id: "ehid", name: "EHID", isChecked: true, disabled: true },
        { id: "coa", name: "COA", isChecked: true, disabled: true },
        {
          id: "sub vendor",
          name: "Sub Vendor",
          isChecked: false,
          disabled: false,
        },
        { id: "project", name: "Project", isChecked: false, disabled: false },
        {
          id: "description",
          name: "Description",
          isChecked: true,
          disabled: false,
        },
        { id: "amount", name: "Amount", isChecked: true, disabled: true },
      ],
      moreAction: [
        { name: "Delete", eventKey: "delete" },
        { name: "Move", eventKey: "move" },
      ],
      moreActionFileUpload: [{ name: "Delete", eventKey: "delete" }],
      moreActionFileUpload1: [
        { name: "Delete", eventKey: "delete" },
        { name: "Download", eventKey: "download" },
      ],
      requestlist: {
        hotelID: 0,
        oprID: "-1",
        etype: "invoice",
        vid: 0,
        recordCount: 5,
      },
      defaultSplitData: [],
      splitData: [
        {
          rno: 1,
          lettercode: "",
          spiltHoteID: "",
          coa: "",
          coaName: "",
          description: "",
          amount: "",
          srno: 1,
          clMonth: "",
          clYear: "",
          subVID: "0",
          subVendor: "",
          pID: "0",
          projectName: "",
          splitoprID: "0",
          defaultCoa: [],
          defaultVendor: "Select Sub Vendor",
          defaultProject: "Select Project",
          defaultEhid: "EHID",
          subVendorlist: [],
          projectlist: [],
          isCOAPer: "Yes",
          isCOA: "No",
          isDescription: "No",
          isHideRow: 0,
          isSplitChecked: 0,
        },
        {
          rno: 2,
          lettercode: "",
          spiltHoteID: "",
          coa: "",
          coaName: "",
          description: "",
          amount: "",
          srno: 2,
          clMonth: "",
          clYear: "",
          subVID: "0",
          subVendor: "",
          pID: "0",
          projectName: "",
          splitoprID: "0",
          defaultCoa: [],
          defaultVendor: "Select Sub Vendor",
          defaultProject: "Select Project",
          defaultEhid: "EHID",
          subVendorlist: [],
          projectlist: [],
          isCOAPer: "Yes",
          isCOA: "No",
          isDescription: "No",
          isHideRow: 0,
          isSplitChecked: 0,
        },
      ],
      newRow: {
        rno: 1,
        lettercode: "",
        spiltHoteID: "",
        coa: "",
        coaName: "",
        description: "",
        amount: "",
        srno: 1,
        clMonth: "",
        clYear: "",
        subVID: "",
        subVendor: "",
        pID: "",
        projectName: "",
        splitoprID: "0",
        defaultCoa: [],
        defaultVendor: "Select Sub Vendor",
        defaultProject: "Select Project",
        defaultEhid: "EHID",
        subVendorlist: [],
        projectlist: [],
        isCOAPer: "Yes",
        isCOA: "No",
        isDescription: "No",
        isHideRow: 0,
        isSplitChecked: 0,
      },
      formData: {
        cardUniqueno: 0,
        gDate: null,
        approved: "",
        uniqueno: 0,
        isAttachment: "no",
        hotelID: -1,
        invoiceno: "",
        transcationDate: null,
        dueDate: null,
        endDate: null,
        accPeriod: "",
        vendorID: 0,
        vendorName: "",
        internalNotes: "",
        checkNo: "",
        transactionTotal: "",
        tenantID: 0,
        pageType: "",
        paymenttype: "",
        oprID: -1,
        entryType: "",
        accountType: "",
        isRepeat: "No",
        repeatDate: "",
        accPeriodstatus: "Active",
        concilestatus: "No",
        saletax: "",
        vendorContract: "",
        aid: 0,
        incompleteUniqueno: 0,
        series: "",
        actionType: "",
        adj: "N",
        postFix: "",
        vendorDays: "0",
        vendorStatus: "Active",
        contractStatus: "Active",
        fileCopyfromUniqueno: "0",
        fileCopyfrom: "",
        ispayment: "No",
        readyForPayment: "No",
        paymentNotes: "",
        isPaid: "Unpaid",
        groupID: 0,
        ccType: "",
        bypassTo: "",
      },
      moveHID: {
        hidValue: -1,
        hidName: "",
      },
      creditCardStatementModal: false,
      importaccPeriodList: [],
      isError: "",
      digitalAchStatus: "",
      isbank: "No",
      splitActualList: [],
      isExtractOption: false,
      isMapped: "No",
      isMappedShow: false,
      invoiceBedge: "",
      showRuleModal: false,
      rulesArray: [],
      saveAction: this.props.saveAction,
      invoiceUniqueNo: this.props.uniqueNo,
      isNextInvoice: false,
      approveInvoiceStatus: [],
      oldapproveInvoiceStatus: [],
      isFootershow: false,
      isApproveButton: false,
      paymentModal: false,
      showBulkSelectCoa: false,
      bulkSelectedSplitRows: [],
      showAssignCOABtn: false,
      bulkSelectedCOA: [],
      invoicePaid: {
        account: "",
        paymentDate: null,
        paymentType: "",
        paymentNotes: "",
      },
      isPaidClick: false,
      hasUnApproved: false,

      paymentTypelist: [],
      isPaidButtonDisabled: false,
      oldVendorId: 0,
      hotelCurrentTime: "",
      hotelCurrentDate: "",
      hotelDate: "",
      isAllIncomplete: false,
      descCOAMapping: [],
      selectedRow: [],
      isExtractionBtnClicked: false,
      defaultpaymentType2Change: false,
      pageType: this.props.pageType,
      ePayMethod: "",
      epayCheckNo: "",
      paymentSentDT: "",
      epayDigitalID: "",
      isInvoiceLoading: false,
      COAData: [],
      intervalId: -99,
      COADataCount: 0,
      isShowAttchmntInvLstMdl: false,
      filterInvoiceInput: "",
      isMarkAsPaidClicked: false,
      isPostTrx: "no",
      isACHBypassApproval: "no",
      isACHBypassPayment: "no",
      isCCBypassApproval: "no",
      isCCBypassPayment: "no",
      trxTypeList: [
        { id: 1, name: "Debit", eventName: "CCDEBIT" },
        { id: 2, name: "Credit", eventName: "CCCREDIT" },
      ],
      isPaidDB: "Unpaid",
      isShowTypeChangeAlert: true,
      vendorSelectedDB: [],
      isAzureExtraction: "no",
      selectedTableItemList: [],
      isApproveClicked: false,
      isPropsReload:false
    };

    this.Previoustransactions = this.Previoustransactions.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    this.loadPreviousData = this.loadPreviousData.bind(this);
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.handleNewRow = this.handleNewRow.bind(this);
    this.ishandleDeleteRow = this.ishandleDeleteRow.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveInvoice = this.saveInvoice.bind(this);
    this.closeSlideOut = this.closeSlideOut.bind(this);
    this.handleSaveColumn = this.handleSaveColumn.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.handlePreviewfromblob = this.handlePreviewfromblob.bind(this);
    this.handleSaveFiles = this.handleSaveFiles.bind(this);
    this.handleDiscard = this.handleDiscard.bind(this);
    this.isHandleAction = this.isHandleAction.bind(this);
    this.hideBulkselect = this.hideBulkselect.bind(this);
    this.handleUpdatedFile = this.handleUpdatedFile.bind(this);
    this.handleincompleteFile = this.handleincompleteFile.bind(this);
    this.saveSplitFile = this.saveSplitFile.bind(this);
    this.moveInvoiceEHID = this.moveInvoiceEHID.bind(this);
    this.handleRotate = this.handleRotate.bind(this);
    this.handlePageRemove = this.handlePageRemove.bind(this);

    this.handleBulkRotate = this.handleBulkRotate.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
    this.pdfExtract = this.pdfExtract.bind(this);
    this.onAmountFocus = this.onAmountFocus.bind(this);
  }

  handleDescChange = (value, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].description = value;
    splitData[rowIndex].isDescription = "Yes";
    this.setState({ splitData, isStateChanged: true }, () => {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      if (
        splitData[rowIndex]?.description !== "" &&
        splitData[rowIndex]?.description !== null
      ) {
        if (splitData[rowIndex].coa.trim().length === 0) {
          if (
            this.state.descCOAMapping.filter(
              (x) =>
                x.label.trim().toLowerCase() ===
                splitData[rowIndex]?.description.trim().toLowerCase()
            ).length > 0
          ) {
            const index = this.state.descCOAMapping.findIndex(
              (x) =>
                x.label.trim().toLowerCase() ===
                splitData[rowIndex]?.description.trim().toLowerCase()
            );
            if (
              this.state.coaList.filter(
                (x) => x.id === this.state.descCOAMapping[index].coa
              ).length > 0
            ) {
              const coaListIndex = this.state.coaList.findIndex(
                (x) => x.id === this.state.descCOAMapping[index].coa
              );
              splitData[rowIndex].coa = this.state.coaList[coaListIndex].id;
              splitData[rowIndex].coaName =
                this.state.coaList[coaListIndex].coAname;
              let defaultCoaArray: any = [];
              defaultCoaArray.push(this.state.coaList[coaListIndex]);
              splitData[rowIndex].defaultCoa = defaultCoaArray;
            }
          }
        }
      }
      this.setState({ splitData, isStateChanged: true });
    });
  };

  importedStatementData = (result) => {
    let splitData: any = [];
    let isAmount: any = [];
    let formData = { ...this.state.formData };
    if (result.length > 0) {
      result.forEach((items: any, index: any) => {
        let splitRow: any = {};
        let coaName = Array.from(new Set(items.coaName.split(" ")))
          .join(" ")
          .toString();
        splitRow.rno = index;
        splitRow.lettercode = items.ehid;
        splitRow.spiltHoteID = this.state.hotelValue;
        splitRow.coa = items.coa;
        splitRow.coaName = coaName;
        splitRow.description = items.Description;
        splitRow.amount = Utils.currencyFormatWithOutdoller(items.Amount);
        splitRow.srno = index;
        splitRow.clMonth = "";
        splitRow.clYear = "";
        splitRow.subVID = items.vid !== null ? items.vid : 0;
        splitRow.subVendor = items.SubVendor;
        splitRow.pID = "0";
        splitRow.isCOAPer = "Yes";
        splitRow.projectName = "";
        splitRow.splitoprID = "0";
        splitRow.defaultCoa = [
          {
            id: items.coa,
            coAname: coaName,
            name: coaName,
            tenantID: items.TenantID,
            label: coaName,
          },
        ];
        splitRow.defaultVendor =
          items.SubVendor === "" ? "Select Sub Vendor" : items.SubVendor;
        splitRow.defaultProject = "Select Project";
        splitRow.defaultEhid = items.ehid;
        splitRow.subVendorlist = [];
        splitRow.projectlist = [];
        isAmount.push(Number(items.Amount));
        splitData.push(splitRow);
      });
      let requestlist = { ...this.state.requestlist };
      requestlist.hotelID = this.state.hotelValue;
      requestlist.oprID = this.state.formData.oprID;
      requestlist.vid = splitData[0].subVID;
      formData.adj = "N";
      formData.accPeriodstatus = "active";
      formData.transactionTotal = Utils.currencyFormat(
        isAmount.reduce((a, b) => a + b, 0)
      );
      this.state.CopytableColumnList.map(
        (item) => item.name === "Sub Vendor" && (item.isChecked = true)
      );
      const transactionsColumns = this.transactionsColumns.map((item) => {
        if (item.text?.toUpperCase() === "Sub Vendor".toUpperCase()) {
          item.hidden = false;
        }
        return item;
      });

      setTimeout(() => {
        this.setState(
          {
            transactionsColumns,
            accPeriodList: [],
            defaultaccountingPeriod: result[0].Accper,
            splitData,
            totalAmount: Utils.currencyFormat(
              isAmount.reduce((a, b) => a + b, 0)
            ),
            formData,
          },
          () => {
            this.GetHotelCOAlistForImport(requestlist);
            this.handleSelectedItem("6.0", result[0].Accper);
            setTimeout(() => {
              this.setState({ accPeriodList: this.state.importaccPeriodList });
            }, 1000);
          }
        );
      }, 1000);
    }
  };

  GetHotelCOAlistForImport = (requestlist: any) => {
    requestlist.etype = "Invoice";
    let splitData: any = [];
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newRow = this.state.newRow;
    registersevice
      .GetHotelCOAlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (
            this.state.invoiceUniqueNo === 0 ||
            this.state.formData.actionType === "move"
          ) {
            splitData.forEach((element) => {
              element.subVendorlist = result.vendorBYHIDList.filter(
                (x) => x.hid === this.state.hotelValue
              );
              element.projectlist = result.projectBYHIdList.filter(
                (x) => x.hid === this.state.hotelValue
              );
            });
          } else {
            if (splitData[0].lettercode === "") {
              splitData.forEach((element) => {
                element.subVendorlist = result.vendorBYHIDList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
                element.projectlist = result.projectBYHIdList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
              });
            }
          }
          newRow.subVendorlist = result.vendorBYHIDList.filter(
            (x) => x.hid === this.state.hotelValue
          );
          newRow.projectlist = result.projectBYHIdList.filter(
            (x) => x.hid === this.state.hotelValue
          );
          this.setState({ splitData: [] }, () => {
            this.setState({
              splitData: splitData,
            });
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };
  scrollToBottom = () => {
    this.parentScroll.current.scrollTo({
      top: this.parentScroll.current.scrollHeight,
      behavior: "smooth",
    });
  };
  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.totalAmount;
    return updatedItem;
  };

  returnEHIDList = (item: any) => {
    let moveHID = { ...this.state.moveHID };
    moveHID.hidValue = item.hotelID;
    moveHID.hidName = item.lettercode;
    this.setState(
      {
        moveHID,
        PeriodList: [],
        defaultPeriod: "Accounting Period",
        selectedPeriod: "",
        moveselected: true,
      },
      () => {
        this.GetInvoicePaymentType(item.hotelID);
        this.GetAccountingPeriod(item.hotelID, 2);
      }
    );
  };

  moveInvoiceEHID() {
    if (
      this.state.moveHID.hidValue.toString() === "-1" ||
      this.state.moveHID.hidValue.toString() === ""
    ) {
      Utils.toastError("Please EHID!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      return false;
    } else if (this.state.selectedPeriod.length === 0) {
      Utils.toastError("Please select accounting period.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      return false;
    }
    // else if (this.state.formData.readyForPayment == "Paid") {
    //   if (this.state.defaultaccountType === "Select Account") {
    //     Utils.toastError("Please select Account.", {
    //       position: toast.POSITION.BOTTOM_RIGHT,
    //       containerId: "InvoiceSlideout",
    //     });
    //     return false;
    //   }
    // }
    if (
      this.state.formData.readyForPayment == "Paid" ||
      this.state.pageType.toLowerCase() === "incompleteinvoice"
    ) {
      this.moveInvoiceEHIDDataDB();
    } else {
      confirmAlert({
        title: "Move Invoice",
        message:
          this.state.formData.isPaid === "Paid" &&
          this.state.formData.approved.toLowerCase() != "App"
            ? "This invoice is already marked as paid. Do you want to mark as unpaid to move the invoice?"
            : "Are you sure you want to move this invoice? Moving the invoice to a new EHID will result in all approvals being removed.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.moveInvoiceEHIDDataDB(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
  }

  moveInvoiceEHIDDataDB() {
    let vendorSelected: any = [];
    let formData = { ...this.state.formData };
    if (
      this.state.formData.readyForPayment != "Paid" ||
      this.state.formData.isPaid === "Paid"
    ) {
      formData.isPaid = "Unpaid";
    }

    formData.actionType = "move";
    formData.hotelID = this.state.moveHID.hidValue;
    formData.accPeriod = this.state.selectedPeriod;
    this.setState(
      {
        updatedAccountName: "",
        defaultaccountType: "Select Account",
        formData,
        hotelName: this.state.moveHID.hidName,
        hotelValue: this.state.moveHID.hidValue,
        vendorList: [],
        isStateChanged: true,
        isvendorShow: false,
        isPaidDB: "Unpaid", // Added for NW-36347
      },
      () => {
        this.getReviewPermissions(this.state.hotelValue, "move");
        this.setState({ showInvoiceModal: false, isvendorShow: true }, () => {
          let requestlist = { ...this.state.requestlist };
          requestlist.hotelID = this.state.moveHID.hidValue;
          requestlist.etype = this.state.pageType;
          if (this.state.formData.vendorID > 0) {
            let vendorItem: any = {};
            vendorItem.id = this.state.formData.vendorID;
            vendorItem.accountNo = "";
            vendorItem.aid = 0;
            vendorItem.salestax = "";
            vendorItem.vendorName = this.state.formData.vendorName;
            vendorSelected.push(vendorItem);
            if (vendorSelected[0].vendorName.length > 0) {
              this.VendorSearchlistWithKey(
                vendorSelected[0].vendorName,
                this.state.moveHID.hidValue
              );
            }
            this.GetAccountingPeriod(this.state.moveHID.hidValue, 1);
            let formData = { ...this.state.formData };
            requestlist.oprID = this.state.formData.oprID;
            requestlist.vid = formData.vendorID;

            let splitData: any = [];
            splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );
            splitData.forEach((element) => {
              element.isHideRow = 0;
              element.isSplitChecked = 0;
            });

            this.setState(
              {
                coaList: [],
                splitHIDList: [],
                subVendorList: [],
                projectList: [],
                splitData,
                bulkSelectedSplitRows: [],
                showAssignCOABtn: false,
                defaultEntry: "all-entry",
                isAllIncomplete: false,
              },
              () => {
                this.GetHotelCOAlist(requestlist);
                this.handleMultiContract(this.state.moveHID.hidValue);
              }
            );
          } else {
            let splitData: any = [];
            splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );
            splitData.forEach((element) => {
              element.defaultEhid = this.state.hotelName;
              element.lettercode = this.state.hotelName;
              element.spiltHoteID = this.state.hotelValue;
              element.isHideRow = 0;
              element.isSplitChecked = 0;
            });
            this.setState({
              splitData,
              bulkSelectedSplitRows: [],
              showAssignCOABtn: false,
              defaultEntry: "all-entry",
              isAllIncomplete: false,
            });
          }

          let defaultpaymentType: string;
          if (this.state.paymentTypelist.length > 0) {
            let paymenttypeExist = this.state.paymentTypelist.filter(
              (x) =>
                x.name.toLowerCase() ===
                  formData.paymenttype.toString().toLowerCase() ||
                x.id.toLowerCase() ===
                  formData.paymenttype.toString().toLowerCase()
            ).length;

            if (paymenttypeExist == 0) {
              defaultpaymentType = "Check";
              formData.paymenttype = "Check";
              this.setState({
                defaultpaymentType,
                defaultpaymentType1: defaultpaymentType,
                formData,
              });
            }
          } else {
            this.setState({
              defaultpaymentType: "Select Type",
              defaultpaymentType1: "Select Type",
            });
          }
        });
      }
    );
  }

  handleOutsideClick = (rowIndex: any, e: any) => {
    let relatedTargetID = e.relatedTarget?.id;
    let relatedTargettagName = e.relatedTarget?.tagName;

    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (splitData[rowIndex].coaName.length === 0) {
      splitData[rowIndex].coaName = "";
      splitData[rowIndex].coa = "";
      splitData[rowIndex].defaultCoa = [];
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("txtamt")) {
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("ddlSubVendor")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("ddlProject")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else {
            if (relatedTargettagName === "TEXTAREA") {
              $("textarea[id^='" + relatedTargetID + "']").focus();
            }
          }
        })
      );
    } else {
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("txtamt")) {
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("ddlSubVendor")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("ddlProject")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else {
            if (relatedTargettagName === "TEXTAREA") {
              $("textarea[id^='" + relatedTargetID + "']").focus();
            }
          }
        })
      );
    }
  };

  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  pageClose = () => {
    this.setState({ isSave: false }, () => {
      this.handleDiscard(this.state.invoiceUniqueNo);
    });
  };

  isValidateModelPoupTab() {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.pageClose(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  handleDescriptionFocus = (value, txtID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isDescription = "Yes";
    splitData[rowIndex].description = value;
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        setTimeout(() => {
          $("#tblSplit")
            .find("input[id^='" + txtID + "']")
            .focus();
        }, 50);
      })
    );
  };

  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isCOA = "Yes";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        $("input[class^='" + ddlID + "']").focus();
      })
    );
  };

  onTAB = (control, rowIndex1, event) => {
    let isSubvendor = this.state.tableColumnList.filter(
      (e) => e.id === "sub vendor"
    )[0].isChecked;
    let isProject = this.state.tableColumnList.filter(
      (e) => e.id === "project"
    )[0].isChecked;
    let isDescription = this.state.tableColumnList.filter(
      (e) => e.id === "description"
    )[0].isChecked;
    if (event.key.toLowerCase() === "tab") {
      let controlID = control.split("-")[0];
      let rowIndex = Number(rowIndex1);
      let selectedCOA = event?.target?.value;
      if (controlID === "ddlCOA" && rowIndex >= 1 && selectedCOA === "") {
        let txtID = "btnInvoice";
        $("button[id^='" + txtID + "']").focus();
        setTimeout(() => {
          $("button[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "ddlCOA") {
        if (isSubvendor) {
          let txtID = "ddlSubVendor-" + rowIndex + "ddl";
          setTimeout(() => {
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else if (isProject) {
          let txtID = "ddlProject-" + rowIndex + "ddl";
          setTimeout(() => {
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else if (isDescription) {
          let txtID = "txtdesc" + rowIndex + "txt";
          setTimeout(() => {
            $("#tblSplit")
              .find("input[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else {
          let txtID = "txtamt" + rowIndex + "txt";
          setTimeout(() => {
            $("#tblSplit")
              .find("input[id^='" + txtID + "']")
              .focus();
          }, 50);
        }
      } else if (controlID === "ddlEHID") {
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "txttrDate") {
        let txtID = "txtdueDate";
        setTimeout(() => {
          this.trDate.current.setOpen(false);
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "txtdueDate") {
        if (this.state.accountlist.length > 0) {
          let txtID = "paymentdate";
          setTimeout(() => {
            this.trdueDate.current.setOpen(false);
            $("input[id^='" + txtID + "']").focus();
          }, 50);
        } else {
          let txtID = "accountingPeriod";
          setTimeout(() => {
            this.trdueDate.current.setOpen(false);
            $("button[id^='" + txtID + "']").focus();
          }, 50);
        }
      } else if (controlID === "paymentdate") {
        let txtID = "accountingPeriod";
        setTimeout(() => {
          this.trpaymentdate.current.setOpen(false);
          $("button[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "btnIncompleteInvoice") {
        let txtID = "btnInvoice";
        setTimeout(() => {
          $("button[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "btnInvoice") {
        let txtID = "rbt-input-main form-control rbt-input my-Vendor";
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      }
    }
  };

  handleBlur = (event, rowIndex) => {
    if (event.key.toLowerCase() === "tab") {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      splitData[rowIndex].amount =
        event.target.value === ""
          ? ""
          : !isNaN(event.target.value)
          ? Number(event.target.value).toFixed(2)
          : 0;
      this.setState({ splitData }, () => {
        if (splitData.length === rowIndex + 1) {
          this.handleNewRow();
        }
      });
    }
  };

  onSplitAmountFocus = (e, rowIndex, txtID) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newval = Utils.removecurrencyFormat(e.target.value);
    splitData[rowIndex].amount = newval;
    this.setState({ splitData }, () => {
      $("#tblSplit")
        .find("input[id^='" + txtID + "']")
        .focus();
    });
  };

  amountBlur = (e, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        splitData[rowIndex].amount = Utils.currencyFormatWithOutdoller(
          timeArray[0]
        );
      } else {
        splitData[rowIndex].amount = Utils.currencyFormatWithOutdoller(
          e.target.value
        );
      }

      this.setState({ splitData });
    } else {
      splitData[rowIndex].amount =
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
          ? Utils.currencyFormatWithOutdoller(e.target.value)
          : e.target.value;
      this.setState({ splitData });
    }
  };

  IsTransactionRolePermission = (requestlist) => {
    let request: any = {};
    request.etype = "Invoice";
    registersevice
      .IsTransactionRolePermission(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            this.setState(
              {
                isPermission: result[0].isPermission,
                isInvoiceEntry: result[0].isInvoiceEntry,
                isCCImportPermission: result[0].isCCImportPermission,
                isMovePermission: result[0].isMovePermission,
                isPerviousPermission: result[0].isPerviousPermission,
                hasUnApproved: result[0].isUnapproveInvoicePermission,
                CopyisPermission: result[0].isPermission,
                isInvoiceLoading: false,
                // canReview: result[0].canReview,
                // canFlag: result[0].canFlag,
                isComment: true,
                isACHBypassApproval: result[0].isACHBypassApproval,
                isACHBypassPayment: result[0].isACHBypassPayment,
                isCCBypassApproval: result[0].isCCBypassApproval,
                isCCBypassPayment: result[0].isCCBypassPayment,
                isAzureExtraction: result[0]?.isAzureExtraction,
              },
              () => {
                // this.getReviewPermissions(this.state.hotelValue, "");  // API to get review permissions based on bookkeeping subscription
                if (this.state.invoiceUniqueNo === 0) {
                  this.GetAccountingPeriod(this.state.hotelValue, 1);
                }
                if (this.state.invoiceUniqueNo > 0) {
                  this.GetTranToUpdate(requestlist);
                  this.GetTransactionComment(this.state.invoiceUniqueNo);
                  this.GetUploadFileList(this.state.invoiceUniqueNo, 3);

                  this.GetCOADatalist(requestlist);
                  let intervalId = setInterval(() => {
                    if (
                      this.state.isInvoiceLoading &&
                      this.state.COADataCount > 0
                    ) {
                      this.loadCOADataList();
                    }
                  }, 500);

                  this.setState({ intervalId: intervalId });
                }
              }
            );
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  getBypassStatus = () => {
    let formData = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    let isCC = formData.paymenttype.toLowerCase() === "credit card";
    let isMach =
      formData.paymenttype.toLowerCase() === "ach" ||
      formData.paymenttype.toLowerCase() === "manual ach";
    let bypassTo = "";
    if (
      (this.state.isACHBypassApproval.toLowerCase() === "yes" &&
        this.state.isACHBypassPayment.toLowerCase() === "yes" &&
        isMach) ||
      (this.state.isCCBypassApproval.toLowerCase() === "yes" &&
        this.state.isCCBypassPayment.toLowerCase() === "yes" &&
        isCC)
    ) {
      bypassTo = "register";
    } else if (
      (this.state.isACHBypassApproval.toLowerCase() === "yes" &&
        this.state.isACHBypassPayment.toLowerCase() === "no" &&
        isMach) ||
      (this.state.isCCBypassApproval.toLowerCase() === "yes" &&
        this.state.isCCBypassPayment.toLowerCase() === "no" &&
        isCC)
    ) {
      bypassTo = "payments";
    } else if (
      (this.state.isACHBypassApproval.toLowerCase() === "no" &&
        this.state.isACHBypassPayment.toLowerCase() === "yes" &&
        isMach) ||
      (this.state.isCCBypassApproval.toLowerCase() === "no" &&
        this.state.isCCBypassPayment.toLowerCase() === "yes" &&
        isCC)
    ) {
      bypassTo = "approval";
    } else {
      bypassTo = "";
    }
    return bypassTo;
  };

  handleMultiContract = (newhidValue: any) => {
    this.contractDetails(
      newhidValue,
      this.state.formData.vendorName,
      this.state.formData.vendorID,
      "Current",
      "App"
    );
  };

  componentDidMount() {
    this.GetHotelCurrentDateTime();
    this.onLoadData();
    let isBankSyncInvoice =
      this.props?.selectedRow?.callFrom === "BankSyncInvoice";
    if (isBankSyncInvoice) {
      this.renderSlideFromBankSyncInvoice();
    }
  }

  renderSlideFromBankSyncInvoice = () => {
    let isWithdrawal =
      this.props?.selectedRow?.slideType === "invoicewithdrawal";
    let isDebitAcc = this.props?.selectedRow?.slideType === "invoiceDebit";
    let isCreditAcc = this.props?.selectedRow?.slideType === "invoiceCredit";
    let isPaymentType = "";
    if (isDebitAcc) {
      isPaymentType = "Debit Card";
    } else if (isCreditAcc) {
      isPaymentType = "Credit Card";
    } else if (isWithdrawal) {
      isPaymentType = "Manual ACH";
    }
    let formData = { ...this.state.formData };
    formData.gDate = this.props?.selectedRow?.transDate;
    formData.transactionTotal = Utils.currencyFormat(
      this.props?.selectedRow?.amount
    );
    formData.oprID = this.props?.selectedRow?.oprId;
    formData.hotelID = this.props?.selectedRow?.hid;
    formData.isPaid = "Paid";
    let reqForSharedAcct: any = {};
    reqForSharedAcct.UserUniqueno = 0;
    reqForSharedAcct.OprID = this.props?.selectedRow?.oprId;
    reqForSharedAcct.Type = "Invoice";
    this.setState({ isStateChanged: true });
    this.checkSharedAccountExist(
      reqForSharedAcct,
      this.props?.selectedRow?.oprId
    );
    this.GetAccountList(isPaymentType, this.props?.hidValue, "", "updateAPI");
    let isAmountDiff =
      this.props?.selectedRow?.amount?.toString().includes("-") ||
      Number(this.props?.selectedRow?.amount) > 0
        ? "Yes"
        : "No";
    this.setState(
      {
        defaultpaymentType: isWithdrawal
          ? "Manual ACH"
          : isDebitAcc || isCreditAcc
          ? "Credit Card"
          : "Select Type",
        isAccount: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            formData,
            isAmountDiff,
            totalAmountdiff: formData.transactionTotal,
          });
        }, 100);
      }
    );
  };

  GetHotelCurrentDateTime = () => {
    let request: any = {};

    let requestlist = { ...this.state.requestlist };
    requestlist.hotelID = this.state.hotelValue;
    request.HID = requestlist.hotelID;
    User.GetHotelCurrentDateTime(request).then(async (response: any | null) => {
      if (response !== null) {
        let currentDate = new Date(response.result);
        let dateDay: any = currentDate.getDate();
        let mnth: any = currentDate.getMonth() + 1;
        let nyear: any = currentDate.getFullYear();
        let ndate: any = mnth + "/" + dateDay + "/" + nyear;
        this.setState({
          hotelCurrentTime: ndate,
          hotelCurrentDate: ndate,
          hotelDate: currentDate,
        });
      } else {
        this.setState({
          hotelCurrentDate: new Date().toISOString(),
          hotelDate: new Date(),
        });
      }
    });
  };
  onLoadData() {
    let requestlist = { ...this.state.requestlist };
    requestlist.hotelID = this.state.hotelValue;
    requestlist.etype = this.state.pageType;
    this.setState({ isOpenViewer: false });
    let formData = { ...this.state.formData };
    formData.hotelID = this.state.hotelValue;
    this.GetInvoicePaymentType(this.state.hotelValue);
    this.getReviewPermissions(this.state.hotelValue, ""); // API to get review permissions based on bookkeeping subscription
    this.GetAdvanceFeatureFlagPermission(this.state.hotelValue);
    this.IsTransactionRolePermission(requestlist);
    if (this.state.saveAction === "AllInvoices") {
      this.GetInvoiceDataAllInvoices("load");
    } else if (this.state.saveAction === "WaitingOnMe") {
      this.GetInvoiceWaitingOnMe("load");
    }
    if (this.state.invoiceUniqueNo === 0) {
      formData.accPeriodstatus = "Active";
      formData.concilestatus = "No";
      this.setState({ formData, requestlist });
      let txtID = "rbt-input-main form-control rbt-input my-Vendor";
      if (this.state.isInvoiceEntry === "Yes") {
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 1000);
      }
      this.setState({ hotelName: this.props.hotelName });
    }
    this.getFileSize();
    if (this.state.pageType.toString().toUpperCase() === "INCOMPLETEINVOICE") {
      this.GetPostToInvoice();
    }
  }

  GetAdvanceFeatureFlagPermission(hotelValue: any) {
    registersevice
      .GetHotelFeatureFlagPermission("InvoiceExtraction", hotelValue)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ ispdfExtract: result.featureFlagPermission });
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }
  GetCheckEditInvoiceExtractionMapping() {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID;
    let { formData } = this.state;

    registersevice
      .GetCheckEditInvoiceExtractionMapping(
        this.state.hotelValue,
        formData.vendorID,
        tenantID
      )
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            IsEditInvoiceExtractionMapping:
              result[0].isEditInvoiceExtractionMapping,
          });
          this.setState({ IsGearIconWillShow: result[0].isGearIconWillShow });

          if (
            this.state.IsEditInvoiceExtractionMapping.toString().toLowerCase() ==
            "yes"
          ) {
            this.setState({ isMappingSettingBanner: true });
          }
          if (
            this.state.IsGearIconWillShow.toString().toLowerCase() == "no" &&
            this.state.IsEditInvoiceExtractionMapping.toString().toLowerCase() ==
              "no"
          ) {
            this.setState({ isextractShowbuttonNew: false });
            this.setState({ isGearicoSettingbuttonNew: false });
          }
          if (
            this.state.IsGearIconWillShow.toString().toLowerCase() == "yes" &&
            this.state.IsEditInvoiceExtractionMapping.toString().toLowerCase() ==
              "no"
          ) {
            this.setState({ isextractShowbuttonNew: true });
            this.setState({ isGearicoSettingbuttonNew: false });
          }
          if (
            this.state.IsGearIconWillShow.toString().toLowerCase() == "yes" &&
            this.state.IsEditInvoiceExtractionMapping.toString().toLowerCase() ==
              "yes"
          ) {
            this.setState({ isextractShowbuttonNew: true });
            this.setState({ isGearicoSettingbuttonNew: true });
          }
          if (
            this.state.IsGearIconWillShow.toString().toLowerCase() == "no" &&
            this.state.IsEditInvoiceExtractionMapping.toString().toLowerCase() ==
              "yes"
          ) {
            this.setState({ isextractShowbuttonNew: true });
            this.setState({ isGearicoSettingbuttonNew: true });
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }
  GetInvoicePaymentType(hotelValue: any) {
    let requestlist: any = {};
    requestlist.hotelID = hotelValue;

    let Typelist: any = [];

    registersevice
      .GetInvoicePaymentType(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          result.forEach((element) => {
            let item: any = {};
            item.id = element.id;
            item.name = element.name;
            Typelist.push(item);
          });

          this.setState({ paymentTypelist: Typelist, paymentType: Typelist });
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }
  GetInvoiceDataAllInvoices = (mode: any) => {
    let request: any = {};
    request.EHID =
      this.props.mainHidValue === "Select" ? "All" : this.props.mainHidValue;
    InvoiceApprovalS.GetInvoiceDataAllInvoices(request)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          result = result.filter((e) => e.viewType === 1);
          let stateIndex = 0;

          if (mode !== "reload" && result.length > 0) {
            let index = result.findIndex(
              (c) => c.uniqueno === this.state.invoiceUniqueNo
            );
            this.setState({ indexofUniqueNo: index });
          }

          if (mode === "reload") {
            if (result.length === this.state.indexofUniqueNo) {
              stateIndex = 0;
            } else {
              let invoiceUniqueNoExist = result.filter(
                (e) => e.uniqueno === this.state.invoiceUniqueNo
              ).length;
              if (invoiceUniqueNoExist > 0) {
                stateIndex = this.state.indexofUniqueNo;
                stateIndex = stateIndex + 1;
                if (stateIndex === result.length) {
                  stateIndex = 0;
                }
              } else {
                stateIndex = this.state.indexofUniqueNo;
              }
            }
          }

          if (result.length === 1) {
            this.setState(
              {
                isNextInvoice: false,
              },
              () => {
                if (mode === "reload") {
                  this.setState(
                    {
                      invoiceUniqueNo: result[0].uniqueno,
                      hotelValue: result[0].hid,
                    },
                    () => {
                      this.onLoadData();
                    }
                  );
                }
              }
            );
          } else if (result.length > 1) {
            this.setState(
              {
                isNextInvoice: true,
              },
              () => {
                if (mode === "reload") {
                  this.setState(
                    {
                      invoiceUniqueNo: result[stateIndex].uniqueno,
                      hotelValue: result[stateIndex].hid,
                    },
                    () => {
                      this.onLoadData();
                    }
                  );
                }
              }
            );
          } else {
            if (mode === "reload") {
              this.props.hideSlideOut(true);
            }
          }
        } else {
          if (mode === "reload") {
            this.props.hideSlideOut(true);
          }
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error ${err}`);
        reject();
      });
  };

  GetInvoiceWaitingOnMe = (mode: any) => {
    let request: any = {};
    request.EHID =
      this.props.mainHidValue === "Select" ? "All" : this.props.mainHidValue;
    InvoiceApprovalS.GetInvoiceWaitingOnMe(request)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          result = result.filter((e) => e.viewType === 1);
          let stateIndex = 0;

          if (mode !== "reload" && result.length > 0) {
            let index = result.findIndex(
              (c) => c.uniqueno === this.state.invoiceUniqueNo
            );
            this.setState({ indexofUniqueNo: index });
          }

          if (mode === "reload") {
            if (result.length === this.state.indexofUniqueNo) {
              stateIndex = 0;
            } else {
              let invoiceUniqueNoExist = result.filter(
                (e) => e.uniqueno === this.state.invoiceUniqueNo
              ).length;
              if (invoiceUniqueNoExist > 0) {
                stateIndex = this.state.indexofUniqueNo;
                stateIndex = stateIndex + 1;
                if (stateIndex === result.length) {
                  stateIndex = 0;
                }
              } else {
                stateIndex = this.state.indexofUniqueNo;
              }
            }
          }

          if (result.length === 1) {
            this.setState(
              {
                isNextInvoice: false,
              },
              () => {
                if (mode === "reload") {
                  this.setState(
                    {
                      invoiceUniqueNo: result[0].uniqueno,
                      hotelValue: result[0].hid,
                    },
                    () => {
                      this.onLoadData();
                    }
                  );
                }
              }
            );
          } else if (result.length > 1) {
            this.setState(
              {
                isNextInvoice: true,
              },
              () => {
                if (mode === "reload") {
                  this.setState(
                    {
                      invoiceUniqueNo: result[stateIndex].uniqueno,
                      hotelValue: result[stateIndex].hid,
                    },
                    () => {
                      this.onLoadData();
                    }
                  );
                }
              }
            );
          } else {
            if (mode === "reload") {
              this.props.hideSlideOut(true);
            }
          }
        } else {
          if (mode === "reload") {
            this.props.hideSlideOut(true);
          }
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error ${err}`);
        reject();
      });
  };

  contractDetails = (newhidValue, vendorName, vid, vendorType, approval) => {
    let vendorContractRequest: any = {};
    vendorContractRequest.hotelID = newhidValue;
    vendorContractRequest.vendorType = vendorType;
    vendorContractRequest.VendorId = vid;
    registersevice
      .GetVendorContract(vendorContractRequest)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          if (result.length === 1) {
            let formData = { ...this.state.formData };
            formData.vendorContract = result[0].accountNo;
            formData.aid = result[0].aid;
            this.setState({ formData: formData });
            let vendorSelected: any = [];
            let vendorItem: any = {};
            vendorItem.id = this.state.formData.vendorID;
            vendorItem.accountNo = result[0].accountNo;
            vendorItem.aid = result[0].aid;
            vendorItem.salestax = result[0].salestax;
            vendorItem.vendorName = this.state.formData.vendorName;
            vendorSelected.push(vendorItem);
            this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
            this.DwollaServiceIsEnable(
              this.state.formData.vendorID,
              "New",
              "move"
            );
          } else {
            this.vendorSearch?.current.contractDetails(
              vendorName,
              vid,
              vendorType,
              approval
            );
            this.DwollaServiceIsEnable(vid, "New", "move");
          }
        } else {
          this.vendorSearch.current.addNewContract(
            vendorName,
            vid,
            vendorType,
            newhidValue
          );
          this.DwollaServiceIsEnable(vid, "New", "move");
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  getFileSize() {
    registersevice.GetFileSize().then(async (result: any | null) => {
      if (result > 0) {
        this.setState({ fileSize: result });
      }
    });
  }

  closeSlideOut(postID) {
    let isInvapp=(this.props?.saveAction==="WaitingOnMe" || this.props?.saveAction==="AllInvoices")
    if (this.state.isStateChanged) {
      if (this.state.formData.actionType === "copy") {
        this.props.hideSlideOut(true);
      } else {
        this.isValidateModelPoupTab();
      }
    } else if(isInvapp){
      this.props.hideSlideOut(this.state.isPropsReload);
    } else {
      if (
        Number(this.state.formData.incompleteUniqueno) > 0 &&
        this.state.pageType === "INCOMPLETEINVOICE"
      ) {
        this.props.hideSlideOut(this.state.isSave);
      } else {
        let pagePath = window.location.href.toString().toLowerCase();
        if (pagePath.includes("search")) {
          this.props.hideSlideOut(this.state.somechange);
        } else {
          this.props.hideSlideOut(this.state.isSave);
        }
      }
    }
  }

  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut(Number(postID));
    });
  }

  CommentModalClose = () => {
    let uniqueno = this.state.formData.uniqueno;
    this.handleDiscard(uniqueno);
  };

  onFileChange = (event: any, mode) => {
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles, mode);
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  onDrop = (filelist: any, mode: any) => {
    this.GetCheckEditInvoiceExtractionMapping();
    let size = this.state.fileSize; //5242880//5MB
    let newfiles: any = [];
    let files: any = [];
    let isReturn = true;
    let filestext = "";
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }
    let isInvalidFile = false;
    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
        files.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }

    this.setState({ files, newSelectfiles: newfiles, isSave: true }, () => {
      if (mode === 2) {
        this.isHandleAction();
      } else {
        if (files.length > 0) {
          this.handleSaveFiles(files);
        }
      }
    });
  };

  GetPostToInvoice() {
    let request: any = {};
    request.hotelId = this.state.hotelValue;
    registersevice
      .GetInvoiceToPost(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState(
            { incompleteFiles: result, incompleteFilesCopy: result },
            () => {}
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  GetAccountingPeriod = (hidValue: any, srno) => {
    let requestlist: any = {};
    requestlist.hotelID = hidValue;
    requestlist.etype = "ApActive";
    let accPeriod: any = [];
    registersevice
      .GetAccountingPeriod(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          result.forEach((element) => {
            let item: any = {};
            item.id = element.accperiod;
            item.name = element.accperiod;
            accPeriod.push(item);
          });
          if (srno === 1) {
            this.setState({ accPeriodList: [] }, () => {
              let isBankSyncInvoice =
                this.props?.selectedRow?.callFrom === "BankSyncInvoice";
              let defaultper: any = "";
              let BSDate = this.props?.selectedRow?.transDate;
              let getMonth =
                BSDate !== "" &&
                new Date(
                  new Date(BSDate).getFullYear(),
                  new Date(BSDate).getMonth(),
                  1
                ).toLocaleDateString();
              let getActivePer = result.filter(
                (o: any) =>
                  new Date(o.accperiod).toLocaleDateString() === getMonth &&
                  o.status.toString().toLocaleLowerCase() === "active"
              );
              if (isBankSyncInvoice && getActivePer.length > 0) {
                defaultper = getActivePer[0].accperiod;
              } else {
                defaultper =
                  accPeriod.length > 0 ? result[0].defaultPeriod : "";
              }
              if (
                accPeriod.length > 0 &&
                (this.state.defaultaccountingPeriod === "Accounting Period" ||
                  this.state.defaultaccountingPeriod.length === 0)
              ) {
                let formData = { ...this.state.formData };
                formData.accPeriod = defaultper;
                this.setState({
                  defaultaccountingPeriod: defaultper,
                  formData,
                  selectedaccountingPeriod: defaultper,
                });
              }

              if (this.state.formData.actionType === "move") {
                let formData = { ...this.state.formData };
                formData.accPeriod = this.state.selectedPeriod;
                this.setState({
                  defaultaccountingPeriod: this.state.selectedPeriod,
                  formData,
                  selectedaccountingPeriod: this.state.selectedPeriod,
                });
              }
              this.setState({
                accPeriodList: accPeriod,
                importaccPeriodList: accPeriod,
                selectdefaultperiod: defaultper,
              });
            });
          } else {
            this.setState({ PeriodList: [] }, () => {
              setTimeout(() => {
                if (
                  accPeriod.filter(
                    (e) => e.id === this.state.formData.accPeriod
                  ).length === 0
                ) {
                  this.setState({
                    PeriodList: accPeriod,
                    defaultPeriod: "Accounting Period",
                    selectedPeriod: "",
                  });
                } else {
                  this.setState({
                    PeriodList: accPeriod,
                    defaultPeriod: this.state.formData.accPeriod,
                    selectedPeriod: this.state.formData.accPeriod,
                  });
                }
              }, 100);
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  updateVendorList = (result: any) => {
    this.setState({ vendorList: [] }, () => {
      this.setState({ vendorList: result });
    });
  };

  GetTransactionEntryColoumn = (formData: any) => {
    let saveRequest: any = {};
    saveRequest.hotelID = formData.hotelID;
    saveRequest.vid = formData.vendorID;
    registersevice
      .GetTransactionColoumn(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            let activeCol = result[0].columnname.split(",");
            let data = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.tableColumnList))
            );
            data.map((item) => (item.isChecked = false));
            data.forEach((element) => {
              let x = activeCol.filter((e) => e === element.id);
              if (x.length > 0) {
                element.isChecked = true;
              }
            });
            let splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );
            let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
            let projectNameExist = splitData.filter((e) => e.pID > 0).length;
            let descriptionExist = splitData.filter(
              (e) => e.description !== ""
            ).length;
            let chekedColumns = data
              .filter((item) => item.isChecked)
              ?.map((item) => item.name?.toUpperCase());
            const transactionsColumns = this.transactionsColumns.map((item) => {
              if (
                subVendorExist > 0 &&
                item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
              ) {
                item.hidden = false;
              } else if (
                projectNameExist > 0 &&
                item.text?.toUpperCase() === "Project".toUpperCase()
              ) {
                item.hidden = false;
              } else if (
                descriptionExist > 0 &&
                item.text?.toUpperCase() === "Description".toUpperCase()
              ) {
                item.hidden = false;
              } else {
                item.hidden =
                  chekedColumns.includes(item.text?.toUpperCase()) || !item.text
                    ? false
                    : true;
              }
              return item;
            });
            this.setState({ transactionsColumns: [] }, () => {
              this.setState({
                tableColumnList: data,
                HIDColumn: true,
                transactionsColumns,
              });
            });
          } else {
            let splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );

            let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
            let projectNameExist = splitData.filter((e) => e.pID > 0).length;

            let data = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.CopytableColumnList))
            );
            data
              .filter((item) => item.isChecked)
              ?.map((item) => item.name?.toUpperCase());
            const transactionsColumns = this.transactionsColumns.map((item) => {
              if (
                subVendorExist === 0 &&
                item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
              ) {
                item.hidden = true;
              } else if (
                projectNameExist === 0 &&
                item.text?.toUpperCase() === "Project".toUpperCase()
              ) {
                item.hidden = true;
              } else {
                item.hidden = false;
              }
              return item;
            });
            this.setState({ tableColumnList: data, transactionsColumns });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetAccountList = (paymentType: any, hotelID: any, markStatus, callFrom) => {
    this.setState({ accountlist: [], isAccount: false }, () => {
      let request: any = {};
      request.hotelID = hotelID;
      request.paymentType =
        paymentType.toString().toLowerCase() === "Manual ACH".toLowerCase()
          ? "ACH"
          : paymentType;
      let defaultaccountType = "Select Account";
      let updatedAccount = "";
      registersevice
        .GetAccountList(request)
        .then(async (result: any | null) => {
          if (result.length > 0) {
            let accountlist: any = [];

            let isupdatedAcExist = result.filter(
              (y) => y.name === this.state.updatedAccountName
            );
            if (isupdatedAcExist.length > 0) {
              updatedAccount = this.state.updatedAccountName;
            }

            result.forEach((element, index) => {
              let item: any = {};
              item.id = element.oprID;
              item.name = element.name;
              accountlist.push(item);

              if (
                this.state.formData.oprID === -1 ||
                this.state.formData.oprID === ""
              ) {
                if (
                  element.setDefault === "Yes" &&
                  element.orderBy === 1 &&
                  this.state.formData.ispayment !== "Yes" &&
                  (paymentType.toString().toLowerCase() ===
                    "ACH".toLowerCase() ||
                    paymentType.toString().toLowerCase() ===
                      "Manual ACH".toLowerCase())
                ) {
                  let formData = { ...this.state.formData };

                  defaultaccountType = element.name;
                  formData.oprID = element.oprID;
                  formData.cardUniqueno = element.oprID;

                  this.setState({ formData });
                } else if (this.state.formData.ispayment === "Yes") {
                  let formData = { ...this.state.formData };
                  let mpaymentOprID = this.state.mpaymentOprID;
                  if (mpaymentOprID === element.oprID) {
                    defaultaccountType = element.name;
                    formData.oprID = mpaymentOprID;
                  }
                  this.setState({ formData });
                }

                if (result.length === 1) {
                  defaultaccountType = element.name;
                  let formData = { ...this.state.formData };
                  formData.oprID = element.oprID;
                  formData.cardUniqueno = element.oprID;
                  this.setState({ formData });
                }

                // if (
                //   paymentType.toString().toLowerCase() ===
                //   "Credit Card".toLowerCase()
                // ) {
                //   defaultaccountType = result[0].name;
                //   let formData = { ...this.state.formData };
                //   formData.oprID = result[0].oprID;
                //   formData.cardUniqueno = result[0].oprID;
                //   this.setState({ formData });
                // }

                if (
                  element.setDefault === "Yes" &&
                  this.state.formData.ispayment !== "Yes" &&
                  paymentType.toString().toLowerCase() ===
                    "Credit Card".toLowerCase()
                ) {
                  let formData = { ...this.state.formData };

                  defaultaccountType = element.name;
                  formData.oprID = element.oprID;
                  formData.cardUniqueno = element.oprID;

                  this.setState({ formData });
                }

                if (
                  paymentType.toString().toLowerCase() ===
                    "Credit Card".toLowerCase() &&
                  this.state.formData.ispayment !== "Yes" &&
                  index === result.length - 1
                ) {
                  if (
                    result.filter((item) => item.setDefault === "Yes").length ==
                    0
                  ) {
                    defaultaccountType = result[0].name;
                    let formData = { ...this.state.formData };
                    formData.oprID = result[0].oprID;
                    formData.cardUniqueno = result[0].oprID;
                    this.setState({ formData });
                  }
                }
              }
            });

            let invoicePaid = { ...this.state.invoicePaid };
            if (this.state.invoiceUniqueNo > 0) {
              invoicePaid.account =
                updatedAccount.length > 0 ? updatedAccount : defaultaccountType;
              this.setState(
                {
                  invoicePaid,
                  isAccount: true,
                  accountlist: accountlist,
                  defaultaccountType:
                    this.state.isPaidDB.toLowerCase() === "paid" &&
                    this.state.updatedAccountName != ""
                      ? this.state.updatedAccountName
                      : updatedAccount.length > 0
                      ? updatedAccount
                      : defaultaccountType,
                },
                () => {
                  if (markStatus === "mark as paid") {
                    this.onChangeMarkAsPaid();
                  }
                }
              );
            } else {
              let isBankSyncInvoice =
                this.props?.selectedRow?.callFrom === "BankSyncInvoice";
              let data = result.filter(
                (o: any) => o.oprID === this.props?.selectedRow?.oprId
              );
              let formData = { ...this.state.formData };
              if (isBankSyncInvoice && data.length > 0) {
                defaultaccountType = data[0].name;
                formData.oprID = data[0].oprID;
                formData.cardUniqueno = data[0].oprID;
                this.setState({ formData });
              }
              invoicePaid.account = defaultaccountType;
              this.setState(
                {
                  invoicePaid,
                  isAccount: true,
                  accountlist: accountlist,
                  defaultaccountType,
                },
                () => {
                  if (markStatus === "mark as paid") {
                    this.onChangeMarkAsPaid();
                  }
                }
              );
            }
          } else {
            let invoicePaid = { ...this.state.invoicePaid };
            invoicePaid.account = defaultaccountType;
            this.setState({
              invoicePaid,
              isAccount: true,
              accountlist: [],
              defaultaccountType:
                this.state.formData.actionType.length === 0 &&
                this.state.formData.isPaid.toLowerCase() == "paid" &&
                this.state.updatedAccountName !== ""
                  ? this.state.updatedAccountName
                  : defaultaccountType,
            });
            if (callFrom === "markPaid") {
              let formData = { ...this.state.formData };
              formData.isPaid = "Unpaid";
              this.setState({ formData });
            }
            if (callFrom === "markPaid" || callFrom === "typeChange") {
              if (
                paymentType.toString().toLowerCase() ===
                "Credit Card".toLowerCase()
              ) {
                Utils.toastError(
                  "There are no accounts available for the selected payment type. Please select a different Payment method.",
                  {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "InvoiceSlideout",
                  }
                );
              } else if (
                paymentType.toString().toLowerCase() ===
                "Digital ACH".toLowerCase()
              ) {
                Utils.toastError(
                  "There are no accounts available for the selected payment type. Please select a different Payment method.",
                  {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "InvoiceSlideout",
                  }
                );
              } else if (
                paymentType.toString().toLowerCase() === "ACH".toLowerCase()
              ) {
                Utils.toastError(
                  "There are no accounts available for the selected payment type. Please select a different Payment method.",
                  {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "InvoiceSlideout",
                  }
                );
              }
            }
          }

          resolve();
        })
        .catch((error) => {
          if (markStatus === "mark as paid") {
            setTimeout(() => {
              this.setState({ isPaidButtonDisabled: false });
            }, 2000);
          }
          reject();
        });
    });
  };

  DwollaServiceIsEnable = (vid, invoiceType, mode) => {
    let request: any = {};
    request.vendorID = vid;
    request.invoiceEntryType = invoiceType;
    request.hotelID = this.state.hotelValue;
    let paymenttypeExist = this.state.paymentTypelist.filter(
      (x) => x.name === "Digital ACH"
    ).length;

    if (paymenttypeExist == 0) {
      let item: any = {};
      item.id = "Digital ACH";
      item.name = "Digital ACH";
      this.state.paymentTypelist.push(item);
    }

    let paymentType: any = this.state.paymentTypelist;
    let paymentType1: any = this.state.paymentTypelist;
    if (this.state.formData.ispayment === "Yes") {
      paymentType = this.state.paymentTypelist;
      let paymenttypeExist = this.state.paymentTypelist.filter(
        (x) => x.name === "Credit Card"
      ).length;
      let item: any = {};
      item.id = "Credit Card";
      item.name = "Credit Card";
      if (paymenttypeExist > 0) {
        this.state.paymentTypelist.remove(item);
      }

      paymentType1 = this.state.paymentTypelist;
    }

    let formData = { ...this.state.formData };
    registersevice
      .DwollaServiceIsEnable(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            if (result[0].isvendor.toLowerCase() === "yes") {
              if (mode === "new") {
                this.setState({ paymentType: [] }, () => {
                  this.setState({
                    isDigitalEnable: result[0].isvendor,
                    paymentType,
                    digitalLimit: result[0].digitalLimit,
                    isbank: result[0].isbank,
                  });
                });
              } else if (mode === "move") {
                if (
                  result[0].isbank.toLowerCase() === "no" &&
                  formData.paymenttype.toLowerCase() ===
                    "digital ACH".toLowerCase()
                ) {
                  formData.paymenttype = "Check";
                  this.setState(
                    {
                      paymentType: [],
                      accountlist: [],
                      formData,
                      defaultpaymentType: "Check",
                    },
                    () => {
                      this.setState({
                        isDigitalEnable: result[0].isvendor,
                        isbank: result[0].isbank,
                        isvendor: result[0].isvendor,
                        paymentType: paymentType,
                      });
                    }
                  );
                } else {
                  this.setState(
                    { paymentType: [], accountlist: [], formData },
                    () => {
                      this.setState({
                        isDigitalEnable: result[0].isvendor,
                        isbank: result[0].isbank,
                        isvendor: result[0].isvendor,
                        paymentType: paymentType,
                      });
                    }
                  );
                }
              } else {
                this.setState({ paymentType: [] }, () => {
                  this.setState({
                    isDigitalEnable: result[0].isvendor,
                    isbank: result[0].isbank,
                    digitalLimit: result[0].digitalLimit,
                    paymentType: paymentType,
                  });
                });
              }
            } else {
              if (
                formData.paymenttype.toLowerCase() ===
                "digital ACH".toLowerCase()
              ) {
                formData.paymenttype = "Check";
                this.setState(
                  {
                    paymentType: [],
                    accountlist: [],
                    formData,
                    defaultpaymentType: "Check",
                  },
                  () => {
                    this.setState({
                      paymentType: paymentType1.filter(
                        (x) => x.name != "Digital ACH"
                      ),
                    });
                  }
                );
              } else {
                this.setState({ paymentType: [] }, () => {
                  this.setState({
                    isDigitalEnable: result[0].isvendor,
                    digitalLimit: result[0].digitalLimit,
                    isbank: result[0].isbank,
                    paymentType: paymentType1.filter(
                      (x) => x.name != "Digital ACH"
                    ),
                  });
                });
              }
            }
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetCOADatalist = (requestlist: any) => {
    registersevice
      .GetCOADatalist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ COAData: result, COADataCount: 1 });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  loadCOADataList = () => {
    let splitData: any = [];

    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newRow = this.state.newRow;
    let result: any = [];
    result = this.state.COAData;

    let dtarr = result?.selectedHotelList?.filter(
      (e) => e.id === this.state.hotelValue
    );
    if (
      this.state.invoiceUniqueNo === 0 ||
      this.state.formData.actionType === "move"
    ) {
      splitData.forEach((element) => {
        element.defaultEhid = this.state.hotelName;
        element.lettercode = this.state.hotelName;
        element.spiltHoteID = this.state.hotelValue;
        element.splitoprID = dtarr[0]?.splitOprID;
        element.defaultVendor = "Select Sub Vendor";
        element.defaultProject = "Select Project";
        element.subVID = "0";
        element.subVendor = "";
        element.pID = "0";
        element.projectName = "";
        element.subVendorlist = result?.vendorBYHIDList?.filter(
          (x) => x.hid === this.state.hotelValue
        );
        element.projectlist = result?.projectBYHIdList?.filter(
          (x) => x.hid === this.state.hotelValue
        );
      });
    } else {
      if (splitData[0].lettercode === "") {
        splitData.forEach((element) => {
          element.defaultEhid = this.state.hotelName;
          element.lettercode = this.state.hotelName;
          element.spiltHoteID = this.state.hotelValue;
          element.splitoprID = dtarr[0]?.splitOprID;
          element.defaultVendor = "Select Sub Vendor";
          element.defaultProject = "Select Project";
          element.subVID = "0";
          element.subVendor = "";
          element.pID = "0";
          element.projectName = "";
          element.subVendorlist = result?.vendorBYHIDList?.filter(
            (x) => x.hid === this.state.hotelValue
          );
          element.projectlist = result?.projectBYHIdList?.filter(
            (x) => x.hid === this.state.hotelValue
          );
        });
      }
    }

    if (this.state.invoiceUniqueNo > 0) {
      splitData.forEach((element) => {
        element.subVendorlist = result?.vendorBYHIDList?.filter(
          (x) => x.hid === element.spiltHoteID
        );
        element.projectlist = result?.projectBYHIdList?.filter(
          (x) => x.hid === element.spiltHoteID
        );
      });
    }

    newRow.defaultEhid = this.state.hotelName;
    newRow.lettercode = this.state.hotelName;
    newRow.spiltHoteID = this.state.hotelValue;
    newRow.splitoprID = dtarr[0]?.splitOprID;
    newRow.subVendorlist = result?.vendorBYHIDList?.filter(
      (x) => x.hid === this.state.hotelValue
    );
    newRow.projectlist = result?.projectBYHIdList?.filter(
      (x) => x.hid === this.state.hotelValue
    );

    this.setState({ splitData: [], defaultSplitData: [] }, () => {
      this.setState(
        {
          splitData: splitData,
          defaultSplitData: splitData,
          newRow: newRow,
          coaList: result?.transactionChartList,
          splitHIDList: result?.selectedHotelList,
          subVendorList: result?.vendorBYHIDList,
          projectList: result?.projectBYHIdList,
        },
        () => {
          this.setState({ isInvoiceLoading: false, COADataCount: 0 });
          window.clearInterval(this.state.intervalId);
        }
      );
    });
  };

  GetHotelCOAlist = (requestlist: any) => {
    requestlist.etype = "Invoice";
    let splitData: any = [];

    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newRow = this.state.newRow;
    this.setState({ isSpinner: true });
    registersevice
      .GetHotelCOAlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          let dtarr = result.selectedHotelList.filter(
            (e) => e.id === this.state.hotelValue
          );
          if (
            this.state.invoiceUniqueNo === 0 ||
            this.state.formData.actionType === "move"
          ) {
            splitData.forEach((element) => {
              element.defaultEhid = this.state.hotelName;
              element.lettercode = this.state.hotelName;
              element.spiltHoteID = this.state.hotelValue;
              element.splitoprID = dtarr[0].splitOprID;
              element.defaultVendor = "Select Sub Vendor";
              element.defaultProject = "Select Project";
              element.subVID = "0";
              element.subVendor = "";
              element.pID = "0";
              element.projectName = "";
              element.subVendorlist = result.vendorBYHIDList.filter(
                (x) => x.hid === this.state.hotelValue
              );
              element.projectlist = result.projectBYHIdList.filter(
                (x) => x.hid === this.state.hotelValue
              );
            });
          } else {
            if (splitData[0].lettercode === "") {
              splitData.forEach((element) => {
                element.defaultEhid = this.state.hotelName;
                element.lettercode = this.state.hotelName;
                element.spiltHoteID = this.state.hotelValue;
                element.splitoprID = dtarr[0]?.splitOprID;
                element.defaultVendor = "Select Sub Vendor";
                element.defaultProject = "Select Project";
                element.subVID = "0";
                element.subVendor = "";
                element.pID = "0";
                element.projectName = "";
                element.subVendorlist = result.vendorBYHIDList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
                element.projectlist = result.projectBYHIdList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
              });
            }
          }

          if (this.state.invoiceUniqueNo > 0) {
            splitData.forEach((element) => {
              element.subVendorlist = result.vendorBYHIDList.filter(
                (x) => x.hid === element.spiltHoteID
              );
              element.projectlist = result.projectBYHIdList.filter(
                (x) => x.hid === element.spiltHoteID
              );
            });
          }

          newRow.defaultEhid = this.state.hotelName;
          newRow.lettercode = this.state.hotelName;
          newRow.spiltHoteID = this.state.hotelValue;
          newRow.splitoprID = dtarr[0]?.splitOprID;
          newRow.subVendorlist = result.vendorBYHIDList.filter(
            (x) => x.hid === this.state.hotelValue
          );
          newRow.projectlist = result.projectBYHIdList.filter(
            (x) => x.hid === this.state.hotelValue
          );

          this.setState({ splitData: [], defaultSplitData: [] }, () => {
            this.setState(
              {
                splitData: splitData,
                defaultSplitData: splitData,
                newRow: newRow,
                coaList: result.transactionChartList,
                splitHIDList: result.selectedHotelList,
                subVendorList: result.vendorBYHIDList,
                projectList: result.projectBYHIdList,
              },
              () => {
                this.setState({ isSpinner: false });
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  VendorSearchlistWithKey = (name, HID) => {
    let request: any = {};
    request.etype = "Invoice";
    request.searchKey = name;
    request.hotelID = HID;
    registersevice
      .VendorSearchlistWithKey(request) //Vendor list service method
      .then(async (result: any | null) => {
        if (result !== null) {
          this.vendorSearch?.current.handleArrayFromParent(result);
          this.vendorSearch?.current.handleSelectFromParent(
            this.state.vendorSelected
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetPreviousTransactionList = (requestlist: any) => {
    requestlist.vid = this.state.formData.vendorID;
    requestlist.etype = "Invoice";
    requestlist.hotelID = this.state.hotelValue;
    requestlist.oprID = this.state.formData.oprID;
    registersevice
      .GetPreviousTransactionList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          let totalCount = 0;
          if (result.length > 0) {
            totalCount = result[0].totalCount;
          }
          this.setState({ previousTransactionsData: result, totalCount });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetTranToUpdate = (requestlist: any) => {
    this.setState({ isSpinner: true });
    this.setState({
      bulkSelectedSplitRows: [],
      showAssignCOABtn: false,
      defaultEntry: "all-entry",
      isAllIncomplete: false,
    });
    requestlist.uniqueNo = this.state.invoiceUniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";
    let splitData: any = [];
    let vendorSelected: any = [];
    let invEntryType = requestlist.etype;
    registersevice
      .GetInvoiceList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.invoiceEntryToUpdateList[0] !== undefined) {
            let splitArray: any = [];
            let mainArray = result.invoiceEntryToUpdateList[0];
            splitArray = result.invoiceSplitToUpdateList;
            let uploadFiles = result.uploadFileList;
            let isError = mainArray.isError;
            let digitalAchStatus = mainArray.digitalAchStatus;
            let vendorApproval = mainArray.vendorApproval;

            this.setState({ isError, digitalAchStatus });
            if (isError === "Yes") {
              window.location.href = "/unauthorize-access?Error=NotFound";
            } else {
              for (let i = 0; i < uploadFiles.length; i++) {
                this["myRef" + i] = React.createRef();
              }
              let formData = { ...this.state.formData };
              let invoicePaid = { ...this.state.invoicePaid };
              let islimited = mainArray.islimited;
              let isDelete = mainArray.isDelete;
              let isEdit = mainArray.isEdit;
              let isHtmlBody = mainArray.isHtmlBody;
              let emailLink = mainArray.emailLink;
              let emailPdfID = mainArray.emailPdfID;
              if (this.state.pageType === "Invoice") {
                formData.uniqueno = mainArray.uniqueno;
                formData.fileCopyfromUniqueno = mainArray.uniqueno;
                formData.fileCopyfrom = "Invoices";
                formData.incompleteUniqueno = 0;
              } else {
                formData.incompleteUniqueno = mainArray.uniqueno;
                formData.fileCopyfromUniqueno = mainArray.uniqueno;
                formData.uniqueno = 0;
                formData.fileCopyfrom = "IncompleteInvoice";
              }
              let bedgeStatus = mainArray.bedgeStatus;
              let hotelName = mainArray.letterCode;
              let uploadedDate =
                mainArray.createdDate === null ? "" : mainArray.createdDate;
              uploadedDate = uploadedDate === "" ? "" : moment.utc(uploadedDate).local().format("MM/DD/YY");
              let uploadedBy =
                mainArray.createdUser === null ? "" : mainArray.createdUser;
              formData.hotelID = mainArray.hotelID;
              formData.oprID = mainArray.oprID;
              let mpaymentOprID = mainArray.oprID;

              formData.invoiceno = mainArray.invoiceno;
              if (mainArray.vid > 0) {
                formData.transcationDate =
                  mainArray.billDate === "" ? null : mainArray.billDate;
                formData.dueDate =
                  mainArray.dueDate === "" ? null : mainArray.dueDate;
                this.getInvoiceCOAMapping(mainArray.vid);
              } else {
                formData.transcationDate = null;
                formData.dueDate = null;
              }
              formData.approved =
                mainArray.approved === null ? "" : mainArray.approved;
              formData.accPeriod = mainArray.accper;
              formData.vendorID = mainArray.vid;
              let oldVendorId = mainArray.vid;
              formData.vendorName = mainArray.vendor;
              formData.vendorContract = mainArray.contract;
              formData.aid = mainArray.aid;
              formData.saletax = mainArray.saleTax;
              formData.internalNotes = mainArray.internalnotes;
              formData.checkNo =
                mainArray.paymentType.toString().toLowerCase() ===
                "Digital ACH".toLowerCase()
                  ? ""
                  : mainArray.ckNo;
              formData.transactionTotal =
                mainArray.transTotal === ""
                  ? ""
                  : !isNaN(mainArray.transTotal)
                  ? Utils.currencyFormat(mainArray.transTotal)
                  : mainArray.transTotal;
              formData.entryType = mainArray.entryType;
              formData.accPeriodstatus = mainArray.accPerStatus;
              formData.concilestatus = mainArray.isReconcile;
              formData.paymenttype = mainArray.paymentType;
              formData.series = mainArray.series;
              formData.adj = mainArray.adj;
              formData.postFix = mainArray.invPostFix;

              formData.vendorDays = mainArray.vendorDays;
              formData.vendorStatus = mainArray.vendorStatus;
              formData.contractStatus = mainArray.contractStatus;
              formData.ispayment = mainArray.isPayment;
              formData.readyForPayment = mainArray.readyForPayment;
              formData.isPaid = mainArray.isPaid;
              formData.paymentNotes = mainArray.paymentNotes;
              formData.groupID = mainArray.groupID;

              let today = Utils.getHotalCurrentDate();
              let dateNew =
                today.getMonth() +
                1 +
                "/" +
                today.getDate() +
                "/" +
                today.getFullYear();
              let gdatevar = mainArray.gdate === "" ? null : mainArray.gdate;
              formData.gDate = gdatevar === null ? dateNew : gdatevar;
              let mpaymentDate = gdatevar === null ? dateNew : gdatevar;
              formData.cardUniqueno = mainArray.cardUniqueno;

              invoicePaid.account = mainArray.acctName;
              invoicePaid.paymentDate = gdatevar === null ? dateNew : gdatevar;
              invoicePaid.paymentType = mainArray.paymentType;
              invoicePaid.paymentNotes = mainArray.paymentNotes;

              let vendorItem: any = {};
              vendorItem.id = mainArray.vid;
              vendorItem.accountNo = mainArray.contract;
              vendorItem.aid = mainArray.aid;
              vendorItem.salestax = mainArray.saleTax;
              vendorItem.vendorName = mainArray.vendor;
              vendorItem.vendorAddress = {
                street: mainArray.street,
                city: mainArray.city,
                state: mainArray.state,
                pCode: mainArray.pCode,
              };
              vendorItem.vendorDays = mainArray.vendorDays;
              vendorItem.vendorContract = mainArray.contract;
              vendorSelected.push(vendorItem);
              this.setState({
                vendorSelected: vendorSelected,
                vendorSelectedDB: vendorSelected,
              });

              let associatedPayments: any = [];
              let elemnt: any = {};
              elemnt.date = mainArray.gdate;
              elemnt.type =
                mainArray.paymentType === "Check"
                  ? "Check # " + mainArray.ckNo
                  : mainArray.paymentType.toString().toLowerCase() ===
                    "Digital ACH".toLowerCase()
                  ? "D-ACH # " + mainArray.ckNo
                  : mainArray.paymentType.toString().toLowerCase() ===
                    "ACH".toLowerCase()
                  ? "M-ACH"
                  : mainArray.paymentType;
              elemnt.account = mainArray.acctName;
              elemnt.amount = Utils.currencyFormatWithOutdoller(
                mainArray.transTotal
              );
              elemnt.paymentNotes = mainArray.paymentNotes;
              associatedPayments.push(elemnt);

              let associatedInvoice: any = [];
              let elem: any = {};
              elem.date = mainArray.ckDate;
              elem.type =
                mainArray.paymentType === "Check"
                  ? "Check # " + mainArray.ckNo
                  : mainArray.paymentType.toString().toLowerCase() ===
                    "Digital ACH".toLowerCase()
                  ? "D-ACH # " + mainArray.ckNo
                  : mainArray.paymentType.toString().toLowerCase() ===
                    "ACH".toLowerCase()
                  ? "M-ACH"
                  : mainArray.paymentType;
              elem.account = mainArray.acctName;
              elem.amount = Utils.currencyFormatWithOutdoller(
                mainArray.checkTotal
              );
              elem.paymentNotes = mainArray.paymentNotes;

              associatedInvoice.push(elem);

              let splitlist: any = [];
              if (splitArray.length > 0) {
                splitArray.forEach((element) => {
                  let defaultCOA: any = [];
                  let objCOA: any = {};
                  objCOA.id = element.coa;
                  objCOA.label = element.defaultCoa;
                  defaultCOA.push(objCOA);
                  element.defaultCoa = defaultCOA;
                  element.amount =
                    element.amount === ""
                      ? ""
                      : !isNaN(element.amount)
                      ? Utils.currencyFormatWithOutdoller(element.amount)
                      : element.amount;

                  element.subVendorlist = [];
                  element.projectlist = [];
                  splitData.push(element);
                  let splitlistItem: any = [];

                  splitlistItem.coa = element.coa;
                  splitlistItem.spiltHoteID = element.spiltHoteID;
                  splitlistItem.subVID = element.subVID;
                  splitlistItem.pID = element.pID;
                  splitlistItem.description = element.description;
                  splitlistItem.amount =
                    element.amount === ""
                      ? ""
                      : !isNaN(element.amount)
                      ? Utils.currencyFormatWithOutdoller(element.amount)
                      : element.amount;

                  splitlist.push(splitlistItem);
                });
              } else {
                splitData = Object.assign(
                  [],
                  JSON.parse(JSON.stringify(this.state.splitData))
                );
                splitData.forEach((element) => {
                  element.defaultCoa = [];
                  element.subVendorlist = [];
                  element.projectlist = [];
                });
              }

              let paymentType1: any = [];

              paymentType1 = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.paymentType))
              );

              let isPaymentTypeFound = paymentType1.filter(
                (o) =>
                  o.name.toLowerCase() === mainArray.paymentType.toLowerCase()
              ).length;

              if (
                mainArray.paymentType.toLowerCase() ===
                "Digital ACH".toLowerCase()
              ) {
                let paymenttypeExist = this.state.paymentTypelist.filter(
                  (x) => x.name === "Digital ACH"
                ).length;

                if (paymenttypeExist == 0) {
                  let item: any = {};
                  item.id = "Digital ACH";
                  item.name = "Digital ACH";
                  this.state.paymentTypelist.push(item);
                }

                paymentType1 = this.state.paymentTypelist;
              } else if (mainArray.isPayment === "Yes") {
                this.setState({
                  paymentTypelist: this.state.paymentTypelist.filter(
                    (x) =>
                      x.id.toString().toLowerCase() === "ach" ||
                      x.id.toString().toLowerCase() === "check"
                  ),
                });
                paymentType1 = this.state.paymentTypelist;
              }

              let requestlist = { ...this.state.requestlist };
              requestlist.hotelID = mainArray.hotelID;
              requestlist.oprID = mainArray.oprID;
              this.setState(
                {
                  invoiceBedge: bedgeStatus,
                  isEdit: isEdit,
                  hotelValue: mainArray.hotelID,
                  requestlist: requestlist,
                  splitData: [],
                  paymentType: [],
                  defaultpaymentType: "",
                  defaultpaymentType1: "",
                  isComment: false,
                },
                () => {
                  this.setState(
                    {
                      isApproveClicked: false,
                      savedPaymentType: mainArray.paymentType,
                      islimited,
                      oldVendorId: oldVendorId,
                      mpaymentOprID,
                      mpaymentDate,
                      vendorApproval,
                      isHtmlBody,
                      emailPdfID,
                      emailLink,
                      activeToggle:
                        this.state.formData.approved.toLowerCase() !==
                        "App".toLowerCase()
                          ? true
                          : false,
                      splitActualList: splitlist,
                      updatedAccountName: mainArray.acctName,
                      isComment: true,
                      isDelete: isDelete,
                      isPermission:
                        this.state.pageType === "Invoice"
                          ? isEdit
                          : this.state.isPermission,
                      isInvoiceEntry:
                        this.state.pageType === "Invoice"
                          ? isEdit
                          : this.state.isInvoiceEntry,
                      vendorDays: mainArray.vendorDays,
                      uploadedDate: uploadedDate,
                      uploadedBy: uploadedBy,
                      associatedInvoice: associatedInvoice,
                      associatedPayments,
                      hotelName: hotelName,
                      splitData: splitData,
                      formData: formData,
                      isPaidDB: formData.isPaid,
                      invoicePaid: invoicePaid,
                      selectedpaymentType: mainArray.paymentType,
                      defaultaccountingPeriod: mainArray.accper,
                      totalAmount: Number(mainArray.transTotal).toFixed(2),
                      amountTotal: Number(mainArray.transTotal).toFixed(2),
                      defaultpaymentType:
                        mainArray.paymentType === ""
                          ? "Select Type"
                          : mainArray.paymentType,
                      defaultpaymentType1:
                        mainArray.paymentType === ""
                          ? "Select Type"
                          : mainArray.paymentType,
                      defaultpaymentType2:
                        mainArray.defaultPaymentType === "Manual ACH"
                          ? "ACH"
                          : mainArray.defaultPaymentType,
                      defaultpaymentType2Change:
                        invEntryType === "INCOMPLETEINVOICE"
                          ? isPaymentTypeFound > 0
                            ? false
                            : true
                          : false,
                      accountlist: [],
                      ePayMethod: mainArray.ePayMethod,
                      paymentSentDT: mainArray.sentdate,
                      epayDigitalID: mainArray.digitalID,
                      epayCheckNo: mainArray.epayCheckNo,
                      isInvoiceLoading: true,
                    },
                    () => {
                      this.notesTextAreaRef.current.style.height = "0px";
                      let scrollHeight =
                        this.notesTextAreaRef.current.scrollHeight;
                      this.notesTextAreaRef.current.style.height =
                        scrollHeight + "px";

                      if (this.state.isOpenViewer) {
                        setTimeout(() => {
                          const innerWidthSec = this.scrollheight.current
                            .getElement()
                            .getBoundingClientRect().height;
                          this.setState({ scrollAreaHeight: innerWidthSec });
                        }, 100);
                      }
                      this.setState({ paymentType: paymentType1 });
                      this.GetAccountList(
                        this.state.formData.paymenttype,
                        this.state.formData.hotelID,
                        "",
                        "updateAPI"
                      );
                      this.GetTransactionEntryColoumn(formData);
                      this.GetAccountingPeriod(this.state.hotelValue, 1);
                      let request: any = {};
                      request.uniqueNo = mainArray.uniqueno;
                      request.hotelId = mainArray.hotelID;
                      request.vid = mainArray.vid;
                      request.invoiceno = mainArray.invoiceno;
                      request.status = "new";
                      this.checkDuplicateInvoice(request);
                      this.approveInvoiceStatus("old");
                      if (
                        this.state.formData.approved.toLowerCase() !==
                        "App".toLowerCase()
                      ) {
                        this.checkInvoiceApproval("");
                      }

                      setTimeout(() => {
                        this.setState({
                          isSpinner: false,
                          isSaveSpinner: false,
                        });
                      }, 1000);
                    }
                  );
                }
              );
              if (this.state.vendorSelected[0].vendorName.length > 0) {
                this.VendorSearchlistWithKey(
                  this.state.vendorSelected[0].vendorName,
                  mainArray.hotelID
                );
              }

              this.DwollaServiceIsEnable(mainArray.vid, "New", "edit");
              this.CalculateTotalAmount(splitData);
              this.GetCheckEditInvoiceExtractionMapping();

              if (
                this.state.invoiceUniqueNo > 0 &&
                this.state.formData.uniqueno > 0
              ) {
                $(".disabled-area")
                  .find("input, textarea, button, select")
                  .attr("disabled", "disabled");
              }
            }
          } else {
            window.location.href = "/unauthorize-access?Error=NotFound";
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  approveInvoiceStatus = (mode: any) => {
    let { formData } = this.state;
    let oldAppStatus = formData.approved;
    registersevice
      .ApproveInvoiceStatus(formData.uniqueno)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            let IsUnapprove =
              result.filter((x) => x.status === 0).length > 0 ? "Not" : "App";
            this.setState({ approveInvoiceStatus: [] }, () => {
              if (mode === "old") {
                this.setState({
                  approveInvoiceStatus: result,
                  oldapproveInvoiceStatus: result,
                });
              } else if (mode === "new") {
                formData.approved = IsUnapprove;
                this.setState(
                  { approveInvoiceStatus: result, formData },
                  () => {
                    if (
                      this.state.oldapproveInvoiceStatus.length !==
                      result.length
                    ) {
                      this.setState({
                        isApproveButton: true,
                        invoiceBedge: "Pending approval",
                      });
                    } else if (IsUnapprove != oldAppStatus) {
                      this.setState({
                        isApproveButton: true,
                        invoiceBedge: "Pending approval",
                      });
                    } else if (this.state.formData.actionType === "move") {
                      this.props.hideSlideOut(true);
                    } else {
                      if (oldAppStatus.toString().toLowerCase() != "app") {
                        this.setState(
                          { isApproveButton: false, isStateChanged: false },
                          () => {
                            if (this.state.formData.actionType === "copy") {
                              this.props.hideSlideOut(true);
                            }
                          }
                        );
                      } else {
                        this.setState(
                          { isApproveButton: false, isStateChanged: false },
                          () => {
                            this.props.hideSlideOut(true);
                          }
                        );
                      }
                    }
                  }
                );
              }
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  checkInvoiceApproval = (mode) => {
    let { rulesArray, formData } = this.state;
    this.setState({
      isSpinnerLoader: true,
      isComment: true,
      isFootershow: true,
    });
    let request: any = {};
    request.InvoiceUniqueNo = formData.uniqueno;
    InvoiceApprovalS.GetApproveInvoiceRule(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            // no rule
            result.forEach((item) => {
              if (result.length === 1) {
                result.forEach((item) => {
                  let obj: any = {};
                  item["isCheck"] = true;
                  rulesArray.push(obj);
                });
              } else if (result.length > 1) {
                let obj: any = {};
                if (item.appLavel === 1) {
                  item["key"] = "primary";
                  item["isCheck"] = true;
                } else {
                  item["key"] = "secondary";
                  item["isCheck"] = false;
                }
                rulesArray.push(obj);
              }
            });
            this.setState(
              { rulesArray: [], isSpinnerLoader: false, isComment: true },
              () => {
                this.setState({ rulesArray: result }, () => {
                  if (mode === "new") {
                    this.approveInvoiceStatus("new");
                  }
                });
              }
            );
          } else {
            if (mode === "new") {
              this.approveInvoiceStatus("new");
            }
          }
        } else {
          Utils.toastError("Something went wrong.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          this.setState({ isSpinnerLoader: false });
        }
        resolve();
      })
      .catch((err: any) => {
        this.setState({ isSpinnerLoader: false });
        Utils.toastError(`Server Error ${err}`);
        reject();
      });
  };

  GetUploadFileList = (uniqueNo, type) => {
    let requestlist: any = {};
    requestlist.hotelID = this.state.hotelValue;

    requestlist.etype =
      this.state.formData.actionType === "copy"
        ? "INCOMPLETEINVOICE"
        : this.state.pageType === "Invoice"
        ? "Invoices"
        : "INCOMPLETEINVOICE";
    requestlist.uniqueNo = uniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";

    registersevice
      .GetUploadFileList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          this.setState({ savedfiles: [] }, () => {
            this.setState(
              { savedfiles: result, files: [], newSelectfiles: [] },
              () => {
                if (type === 2) {
                  let request = Object.assign(
                    {},
                    JSON.parse(JSON.stringify(this.state.formData))
                  );
                  if (
                    this.state.savedfiles.length === 0 &&
                    request.vendorID === 0
                  ) {
                    this.handleDiscard(request.uniqueno);
                  }
                  if (
                    this.state.savedfiles.length === 0 &&
                    request.vendorID != 0
                  ) {
                    this.OpenViewer();
                  }
                }

                if (type === 3) {
                  this.setState(
                    { isOpenViewer: result.length > 0 ? true : false },
                    () => {
                      setTimeout(() => {
                        const innerWidthSec = this.scrollheight?.current
                          ?.getElement()
                          .getBoundingClientRect().height;
                        this.setState({ scrollAreaHeight: innerWidthSec });
                      }, 100);
                    }
                  );
                }
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleVendorChange = (e: any) => {
    let paymentType1: any = [];
    let isBankSyncInvoice =
      this.props?.selectedRow?.callFrom === "BankSyncInvoice";
    paymentType1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );

    let isStateChanged = true;
    if (e.length > 0) {
      if (e[0]?.approval !== null && e[0]?.approval !== undefined) {
        this.setState({ vendorApproval: e[0]?.approval });
      }
      let paymenttypeExist = this.state.paymentTypelist.filter(
        (x) =>
          x.name.toLowerCase() === e[0].paymentType.toLowerCase() ||
          x.id.toLowerCase() === e[0].paymentType.toLowerCase()
      ).length;
      e[0].paymentType = paymenttypeExist > 0 ? e[0].paymentType : "Check";

      let requestlist = { ...this.state.requestlist };
      let formData = { ...this.state.formData };
      requestlist.hotelID = this.state.hotelValue;
      requestlist.oprID = this.state.formData.oprID;
      requestlist.vid = e[0].vid;

      let oldVid = this.state.oldVendorId;
      let oldcustomerNo = formData.vendorContract;

      let today = Utils.getHotalCurrentDate();
      let date =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      let addDays = this.state.hotelDate;

      addDays.setDate(addDays.getDate() + Number(e[0].vendorDays));
      let duedate =
        addDays.getMonth() +
        1 +
        "/" +
        addDays.getDate() +
        "/" +
        addDays.getFullYear();

      if (formData.actionType != "move") {
        formData.transcationDate = this.state.hotelCurrentDate;
        formData.dueDate = duedate;
        formData.gDate = isBankSyncInvoice
          ? this.props?.selectedRow?.transDate
          : date;
        this.setState({
          isduplicateInvoice: false,
          isComment: true,
          defaulttranscationDate: date,
          defaultduedate: duedate,
          defaultgdate: date,
          vendorDays: e[0].vendorDays,
          isStateChanged,
        });
      } else {
        this.setState({
          isComment: true,
          vendorDays: e[0].vendorDays,
          isStateChanged,
        });
      }

      formData.vendorID = e[0].vid;
      formData.vendorName = e[0].vendorName;
      formData.vendorContract = e[0].accountNo;
      formData.aid = e[0].aid;
      formData.saletax = e[0].salestax;
      if (this.state.oldVendorId !== e[0].vid) {
        formData.isPaid = "Unpaid";
      }

      if (formData.actionType === "move") {
        this.setState({
          requestlist,
          formData,
          vendorSelected: e,
          isStateChanged,
        });
      } else {
        if (oldVid != e[0].vid || oldcustomerNo != e[0].accountNo) {
          if (this.state.invoiceUniqueNo > 0) {
            let paymenttypeExist = this.state.paymentTypelist.filter(
              (x) =>
                x.id.toString().toLowerCase() ===
                  this.state.formData.paymenttype.toString().toLowerCase() ||
                x.name.toString().toLowerCase() ===
                  this.state.formData.paymenttype.toString().toLowerCase()
            ).length;
            if (paymenttypeExist === 0) {
              let paymenttypeExist1 = this.state.paymentTypelist.filter(
                (x) =>
                  x.name.toLowerCase() === e[0].paymentType.toLowerCase() ||
                  x.id.toLowerCase() === e[0].paymentType.toLowerCase()
              ).length;
              formData.paymenttype =
                paymenttypeExist1 > 0 ? e[0].paymentType : "Check";
            }
          } else {
            let isWithdrawal =
              this.props?.selectedRow?.slideType === "invoicewithdrawal";
            let isDebitAcc =
              this.props?.selectedRow?.slideType === "invoiceDebit";
            let isCreditAcc =
              this.props?.selectedRow?.slideType === "invoiceCredit";
            let BankSyncpaymentType = isWithdrawal
              ? "Manual ACH"
              : isDebitAcc || isCreditAcc
              ? "Credit Card"
              : "Select Type";
            let paymenttypeExist = this.state.paymentTypelist.filter(
              (x) =>
                x.name.toLowerCase() === e[0].paymentType.toLowerCase() ||
                x.id.toLowerCase() === e[0].paymentType.toLowerCase()
            ).length;
            formData.isPaid = isBankSyncInvoice
              ? e[0]?.approval?.toString()?.toLowerCase() === "app"
                ? "Paid"
                : "Unpaid"
              : formData.isPaid;
            formData.paymenttype = isBankSyncInvoice
              ? BankSyncpaymentType
              : paymenttypeExist > 0
              ? e[0].paymentType
              : "Check";
          }

          let invoicePaid = { ...this.state.invoicePaid };
          if (formData.incompleteUniqueno >= 0 && formData.uniqueno === 0) {
            invoicePaid.paymentType = formData.paymenttype;
          }
          // this.GetAccountList(formData.paymenttype,this.state.formData.hotelID,"mark as paid");
          this.setState(
            {
              invoicePaid,
              requestlist,
              formData,
              vendorSelected: e,
              paymentType: [],
              selectedpaymentType: formData.paymenttype,
              defaultpaymentType1: formData.paymenttype,
              defaultpaymentType2: paymenttypeExist > 0 ? e[0].paymentType : "",
              defaultpaymentType2Change: paymenttypeExist > 0 ? false : true,
              defaultpaymentType: formData.paymenttype,
              isStateChanged,
            },
            () => this.setState({ paymentType: paymentType1 })
          );
        }
      }
      if (
        e[0]?.paymentType.toString().toLocaleLowerCase() === "epay" ||
        (this.state.formData.actionType === "copy" &&
          formData.paymenttype.toString().toLocaleLowerCase() === "epay")
      ) {
        let request: any = {};
        request.VID = e[0].vid;
        request.HID = this.state.formData?.hotelID;
        request.Contract = e[0].accountNo;
        this.vendorCheckEpayAddress(request, "", "", "");
      }
      this.DwollaServiceIsEnable(e[0].vid, "New", "new");
      this.GetHotelCOAlist(requestlist);
      this.GetTransactionEntryColoumn(formData);
      this.getInvoiceCOAMapping(e[0].vid);
    } else {
      let requestlist = { ...this.state.requestlist };
      let formData = { ...this.state.formData };
      requestlist.hotelID = this.state.hotelValue;
      requestlist.oprID = -1;
      requestlist.vid = "";
      formData.vendorID = 0;
      formData.vendorName = "";
      formData.vendorContract = "";
      formData.aid = 0;
      formData.saletax = "";
      this.setState(
        {
          isMapped: "No",
          isExtractOption: false,
          requestlist,
          formData: formData,
          vendorSelected: e,
          previousTransactionsData: [],
          isPreviousTransactions: false,
          defaultpaymentType1: "Select Type",
          defaultpaymentType: "Select Type",
          paymentType: [],
          accountlist: [],
          defaultaccountType: "Select Account",
          isStateChanged,
          LinemapData: [], //Reset
          mapData: [],
        },
        () => this.setState({ paymentType: paymentType1 })
      );
    }
  };

  getInvoiceCOAMapping = (vid) => {
    let requestlist: any = {};
    requestlist.vid = vid;
    requestlist.ForTransferPage = 1;
    requestlist.ShowConfidentialCOA = 1;

    registersevice
      .GetInvoiceCOAMapping(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ descCOAMapping: result });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleDatePicker = (event: any, refName: any) => {
    refName.current.setOpen(true);
  };

  totalAmtDiff = (transTotal, splitTotal) => {
    transTotal = Utils.removecurrencyFormat(transTotal);
    splitTotal = Utils.removecurrencyFormat(splitTotal);
    transTotal = transTotal === "" ? 0 : transTotal;
    splitTotal = splitTotal === "" ? 0 : splitTotal;
    let diff = "";
    diff = (
      Number(!isNaN(transTotal) ? transTotal : "0.00") - Number(splitTotal)
    ).toFixed(2);
    let isAmountDiff = diff === "0.00" ? "No" : diff === "0" ? "No" : "Yes";
    this.setState({
      totalAmountdiff: Utils.currencyFormat(diff),
      isAmountDiff: isAmountDiff,
    });
  };

  handleTotalAmount = (event) => {
    let formData = { ...this.state.formData };
    if (!isNaN(event.target.value)) {
      let trTotal = Utils.currencyFormat(formData.transactionTotal);
      formData.transactionTotal = trTotal;
    } else {
      formData.transactionTotal = "";
    }
    this.setState({ formData });
  };

  onAmountFocus = (event: any) => {
    let newval = Utils.removecurrencyFormat(event.target.value);
    let formData = { ...this.state.formData };
    formData.transactionTotal = newval;
    this.setState({ formData });
  };

  handleChangeNext = (event: any) => {
    this.setState({ createOther: event.target.checked });
  };

  handleChange = (event: any, FieldType: string) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;
    if (FieldType === "invoiceno") {
      start = event.target.selectionStart;
      end = event.target.selectionEnd;
    }
    let formData = { ...this.state.formData };
    if (FieldType === "totalAmt") {
      start = event.target.selectionStart;
      end = event.target.selectionEnd;
      let newInputVal = Utils.removeInvaildCharFromAmount(event.target.value);
      event.target.value = newInputVal;

      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (event.target.value.includes("-")) {
        lenbeforePoint = 9;
      }
      if (rx_live.test(event.target.value)) {
        if (event.target.value.includes(".")) {
          const timeArray = event.target.value?.split(".");
          if (
            timeArray[0].length <= lenbeforePoint &&
            timeArray[1].length <= 2
          ) {
            formData.transactionTotal = event.target.value;
          }
        } else {
          if (event.target.value.length <= lenbeforePoint) {
            formData.transactionTotal = event.target.value;
          }
        }
      } else if (
        event.target.value.includes(".") &&
        event.target.value.length === 1
      ) {
        formData.transactionTotal = event.target.value;
      }

      this.setState({ formData, isStateChanged }, () => {
        let txtID = "txttotalAmt";
        let txttotAmt = $("input[id^='" + txtID + "']")[0] as any;
        txttotAmt.selectionStart = start;
        txttotAmt.selectionEnd = end;

        this.totalAmtDiff(
          this.state.formData.transactionTotal,
          this.state.totalAmount
        );
      });
    } else if (FieldType === "paymentNotes") {
      formData.paymentNotes = event.target.value.replace("'", "");
      this.setState({ formData });
    } else if (FieldType === "gDate") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.gDate = dateNewt;
      this.setState({ formData, isStateChanged });
    } else {
      if (FieldType === "invoiceno") {
        formData.invoiceno =
          event.target.value.trim().length > 0 ? event.target.value : "";
      } else if (FieldType === "trDate") {
        let today = new Date(event);
        let dateNew =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear().toString().substring(2, 4);

        let newdate = new Date(dateNew);
        let date2 =
          newdate.getMonth() +
          1 +
          "/" +
          newdate.getDate() +
          "/" +
          newdate.getFullYear().toString().substring(0, 4);
        formData.transcationDate = date2;

        let addDays = new Date(dateNew);
        addDays.setDate(addDays.getDate() + Number(this.state.vendorDays));
        let duedate =
          addDays.getMonth() +
          1 +
          "/" +
          addDays.getDate() +
          "/" +
          addDays.getFullYear();

        formData.dueDate = duedate;
        if (this.state.formData.uniqueno === 0) {
          let accperList = Object.assign(
            [],
            JSON.parse(JSON.stringify(this.state.accPeriodList))
          );
          let accountingPeriodData = accperList.filter(
            (e) =>
              new Date(e.id).getFullYear().toString().substring(2, 4) ===
                today.getFullYear().toString().substring(2, 4) &&
              new Date(e.id).getMonth() + 1 === today.getMonth() + 1
          );
          if (accountingPeriodData.length > 0) {
            this.setState(
              {
                defaultaccountingPeriod: accountingPeriodData[0].id,
                accPeriodList: [],
              },
              () => {
                formData.accPeriod = accountingPeriodData[0].id;
                this.setState({ accPeriodList: accperList });
              }
            );
          }
        }
      } else if (FieldType === "dueDate") {
        let today = new Date(event);
        let dateNew =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear().toString().substring(2, 4);
        let todaynew = new Date(dateNew);
        let dateNewt =
          todaynew.getMonth() +
          1 +
          "/" +
          todaynew.getDate() +
          "/" +
          todaynew.getFullYear().toString().substring(0, 4);
        formData.dueDate = dateNewt;
      } else if (FieldType === "notes") {
        formData.internalNotes = event.target.value.replace("'", "");

        this.notesTextAreaRef.current.style.height = "0px";
        let scrollHeight = this.notesTextAreaRef.current.scrollHeight;
        this.notesTextAreaRef.current.style.height = scrollHeight + "px";
      } else if (FieldType === "check") {
        if (event.target.value.length > 0) {
          if (Number(event.target.value)) {
            formData.checkNo = Number(event.target.value);
          }
        } else {
          formData.checkNo = event.target.value;
        }
      } else if (FieldType === "repeat") {
        formData.isRepeat = event.target.checked ? "Yes" : "No";
        this.setState({ isRepeat: event.target.checked });
      }

      this.setState({ formData, isStateChanged }, () => {
        if (FieldType === "invoiceno") {
          let txtID = "txtInvoice";
          let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
          txtInvoice.selectionStart = start;
          txtInvoice.selectionEnd = end;
        }
      });
    }
  };

  handleNewRow = () => {
    let splitData: any = [];
    let newRow: any = {};
    let isStateChanged = true;
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    let maxValueOfRow = Math.max(...splitData.map((o) => o.rno), 0);
    let len = splitData.length;
    let maxRno = maxValueOfRow;
    let maxSrno = splitData[len - 1].srno;
    newRow.rno = Number(maxRno) + 1;
    newRow.srno = Number(maxSrno) + 1;
    splitData.push(newRow);
    let lastamount = Utils.removecurrencyFormat(splitData[len - 1].amount); // NW-32061
    splitData[len - 1].amount =
      lastamount === ""
        ? ""
        : !isNaN(lastamount)
        ? Utils.currencyFormatWithOutdoller(lastamount)
        : 0; // NW-32061
    this.setState({ splitData: [] }, () => {
      this.setState({ splitData: splitData, isStateChanged }, () => {
        let len = splitData.length;
        let txtID = "ddlEHID-" + (len - 1) + "ddl";
        setTimeout(() => {
          $("#tblSplit")
            .find("button[id^='" + txtID + "']")
            .focus();
        }, 100);
      });
    });
    this.addTotalAmount(splitData);
  };

  Previoustransactions() {
    this.setState((prevState) => ({
      isPreviousTransactions: !prevState.isPreviousTransactions,
    }));

    let requestlist = { ...this.state.requestlist };
    requestlist.recordCount = 5;
    this.GetPreviousTransactionList(requestlist);
    this.setState({ requestlist });
  }
  setTotalPages = (totalpage) => {
    let isextractShow =
      this.state.savedfiles.length === 1 && totalpage === 1 ? true : false;
    this.setState({ isextractShow, isExtractOption: false });
  };

  OpenViewer() {
    if (this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        fileSelect:
          this.state.savedfiles.length > 0
            ? this.state.savedfiles[0]
            : this.state.newSelectfiles[0],
        isMapped: "No",
        isExtractOption: false,
      }),
      () => {
        this.setState({
          defaultView: "doc-view",
          mapData: [],
          LinemapData: [],
        });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  }

  loadPreviousData() {
    let requestlist = { ...this.state.requestlist };
    let loadrecord = requestlist.recordCount;
    requestlist.recordCount = Number(requestlist.recordCount) + 5;
    if (Number(loadrecord) < Number(this.state.totalCount)) {
      this.GetPreviousTransactionList(requestlist);
      this.setState({ requestlist });
    } else {
      Utils.toastError("No additional transactions exist.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }
  }

  ishandleDeleteRow(row: any, mode: any) {
    if (mode) {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      let bulkSelectedSplitRows = this.state.bulkSelectedSplitRows?.filter(
        (rno) => rno !== row.rno
      );
      this.setState({ splitData: [] }, () => {
        this.setState(
          {
            splitData: splitData.filter((item) => item.rno !== row.rno),
            bulkSelectedSplitRows,
            showAssignCOABtn: bulkSelectedSplitRows.length > 0 ? true : false,
          },
          () => {
            this.validateIncompleteRows();
            this.addTotalAmount(this.state.splitData);
          }
        );
      });
    }
  }

  clearVendorControl = () => {
    const typeList = [...this.state.paymentType];
    let { formData } = this.state;
    formData.paymenttype = "";
    this.setState({ paymentType: [] }, () => {
      this.setState({
        paymentType: typeList,
        formData,
        defaultpaymentType1: "Select Type",
        defaultpaymentType: "Select Type",
        isDisabled: false,
        isSaveSpinner: false,
      });
    });
  };

  vendorCheckEpayAddress = (
    apirequest: any,
    type: any,
    request: any,
    isCopy: any
  ) => {
    this.setState({ isDisabled: true });
    registersevice
      .VendorCheckEpayAddress(apirequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          let data = result.result.result;
          if (data.toString().toLocaleLowerCase() === "invalid") {
            confirmAlert({
              title: "Alert",
              message:
                "This vendor has an invalid address for making ePay payments.  Having only special characters in the State/Zip field or blank values in Street/City fields is not accepted. Please correct this and then proceed with selecting ePay as the payment method.",
              buttons: [
                {
                  label: "OK",
                  onClick: () => {
                    reject();
                    this.clearVendorControl();
                  },
                },
              ],
              closeOnEscape: false,
              closeOnClickOutside: false,
            });
          } else {
            this.setState({ isDisabled: false });
            if (type === "sendtoApproval") {
              this.saveInvoiceDataDB(request, isCopy);
            }
          }
        } else {
          this.setState({ isDisabled: false, isSaveSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isDisabled: false, isSaveSpinner: false });
        reject();
      });
  };

  handleSelectedItem = (control: any, id: any) => {
    let isStateChanged = true;
    let formData = { ...this.state.formData };
    let controlID = Number(control.split("_")[0]);
    let rowIndex = Number(control.split("_")[1]);
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (controlID === 1) {
      let filterRow = this.state.splitHIDList.filter((x) => x.id === id);
      splitData[rowIndex].lettercode = filterRow[0].name;
      splitData[rowIndex].spiltHoteID = filterRow[0].id;
      splitData[rowIndex].splitoprID = filterRow[0].splitOprID;
      splitData[rowIndex].defaultEhid = filterRow[0].name;
      splitData[rowIndex].subVendorlist = this.state.subVendorList.filter(
        (x) => x.hid === filterRow[0].id
      );
      splitData[rowIndex].projectlist = this.state.projectList.filter(
        (x) => x.hid === filterRow[0].id
      );

      splitData[rowIndex].subVID = "0";
      splitData[rowIndex].subVendor = "";
      splitData[rowIndex].defaultVendor = "Select Sub Vendor";

      splitData[rowIndex].pID = "0";
      splitData[rowIndex].projectName = "";
      splitData[rowIndex].defaultProject = "Select Project";

      this.setState({ splitData: [] }, () => {
        this.setState({ splitData, isStateChanged }, () => {
          let txtID = "ddlEHID-" + rowIndex + "ddl";
          $("#tblSplit")
            .find("button[id^='" + txtID + "']")
            .focus();
        });
      });
    } else if (controlID === 2) {
      // COA

      if (id.length > 0) {
        if (id[0].id > 0) {
          splitData[rowIndex].coaName = id[0].coAname;
          splitData[rowIndex].coa = id[0].id;
          splitData[rowIndex].defaultCoa = id;
          splitData[rowIndex].isCOA = "Yes";
        } else {
          splitData[rowIndex].coaName = "";
          splitData[rowIndex].coa = "";
          splitData[rowIndex].defaultCoa = id;
          splitData[rowIndex].isCOA = "Yes";
        }
      } else {
        splitData[rowIndex].coaName = "";
        splitData[rowIndex].coa = "";
        splitData[rowIndex].defaultCoa = id;
        splitData[rowIndex].isCOA = "Yes";
      }
      this.setState({ splitData, isStateChanged }, () => {
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
        setTimeout(() => {
          $("#tblSplit")
            .find("input[class^='" + txtID + "']")
            .focus();
        }, 50);
      });
    } else if (controlID === 3) {
      // subVedor
      let filterRow = this.state.subVendorList.filter(
        (x) => x.id === id && x.hid === splitData[rowIndex].spiltHoteID
      );
      splitData[rowIndex].subVendor = filterRow[0].name;
      splitData[rowIndex].subVID = filterRow[0].id;
      splitData[rowIndex].defaultVendor = filterRow[0].name;
      this.setState({ splitData, isStateChanged }, () => {
        let txtID = "ddlSubVendor-" + rowIndex + "ddl";
        $("#tblSplit")
          .find("button[id^='" + txtID + "']")
          .focus();
      });
    } else if (controlID === 4) {
      // project
      let filterRow = this.state.projectList.filter(
        (x) => x.id === id && x.hid === splitData[rowIndex].spiltHoteID
      );
      splitData[rowIndex].projectName = filterRow[0].name;
      splitData[rowIndex].pID = filterRow[0].id;
      splitData[rowIndex].defaultProject = filterRow[0].name;
      this.setState({ splitData, isStateChanged }, () => {
        let txtID = "ddlProject-" + rowIndex + "ddl";
        $("#tblSplit")
          .find("button[id^='" + txtID + "']")
          .focus();
      });
    } else if (controlID === 5 || controlID === 15) {
      // payment Type

      let invoicePaid = { ...this.state.invoicePaid };
      let savedPaymentType = this.state.savedPaymentType;
      formData.paymenttype = id;
      formData.oprID = -1;
      formData.cardUniqueno = -1;
      invoicePaid.paymentType = id;

      if (controlID === 5 && this.state.formData.paymenttype !== id) {
        formData.isPaid = "Unpaid";
        this.setState({ associatedPayments: [] });
      }

      if (controlID === 5) {
        this.setState({
          invoicePaid,
          defaultpaymentType2Change: true,
          isShowTypeChangeAlert: false,
        });
      }
      if (
        id.toLowerCase() === "ACH".toLowerCase() ||
        id.toLowerCase() === "Digital ACH".toLowerCase() ||
        id.toLowerCase() === "Credit Card".toLowerCase()
      ) {
        this.GetAccountList(
          id,
          this.state.formData.hotelID,
          "mark as paid",
          "typeChange"
        );
        if (controlID === 5) {
          if (
            this.props.uniqueNo > 0 &&
            this.state.formData.actionType != "copy"
          ) {
          }
        } else {
          this.GetAccountList(
            id,
            this.state.formData.hotelID,
            "mark as paid",
            "typeChange"
          );
        }
      }
      if (id.toLowerCase() === "epay") {
        formData.oprID = -1;
        formData.cardUniqueno = -1;
        this.setState(
          {
            accountlist: [],
            defaultaccountType: "Select Account",
            isStateChanged,
          },
          () => {
            let request: any = {};
            request.VID = this.state.formData?.vendorID;
            request.HID = this.state.formData?.hotelID;
            request.Contract = this.state.formData?.vendorContract;
            this.vendorCheckEpayAddress(request, "", "", "");
          }
        );
      } else {
        if (savedPaymentType.toLowerCase() !== id.toLowerCase()) {
          formData.oprID = -1;
          formData.cardUniqueno = -1;
          this.setState({
            accountlist: [],
            defaultaccountType: "Select Account",
            isStateChanged,
          });
        }
      }
      if (controlID === 15) {
        this.setState({
          selectedpaymentType: id,
          defaultpaymentType: id,
          formData,
          updatedAccountName: "",
        });
      } else {
        this.setState({
          selectedpaymentType: id,
          defaultpaymentType: id,
          formData,
          isStateChanged,
          updatedAccountName: "",
        });
      }
    } else if (controlID === 7) {
      // Account Type
      let reqForSharedAcct: any = {};
      reqForSharedAcct.UserUniqueno = this.state.formData.uniqueno;
      reqForSharedAcct.OprID = id;
      reqForSharedAcct.Type = "Invoice";
      this.setState({ isStateChanged: true });
      this.checkSharedAccountExist(reqForSharedAcct, id);
    } else if (controlID === 10) {
      // Move HID period

      this.setState({ selectedPeriod: id });
    } else {
      // A/c Period
      formData.accPeriod = id;

      this.setState({ formData, isStateChanged });
    }
  };

  onChangeMarkAsPaid() {
    let formData = { ...this.state.formData };
    this.handleSelectedItem(7 + "_" + 0, formData.oprID);
  }
  checkSharedAccountExist(request, id) {
    let Invoicelist: any = "";
    registersevice
      .CheckSharedAccountExist(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            Invoicelist = result.message;

            if (this.state.formData.actionType === "move") {
              Invoicelist = "";
            }
            this.handleBankAccount(Invoicelist, id);
          }
        } else {
          Invoicelist = "";
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });

    return Invoicelist;
  }

  handleBankAccount = (SharedAccountInvoice, id) => {
    let formData = { ...this.state.formData };
    if (this.state.formData.ispayment !== "Yes") {
      formData.oprID = id;
      formData.cardUniqueno = id;
    } else {
      formData.oprID = id;
    }

    let requestlist = { ...this.state.requestlist };
    requestlist.oprID = id;
    let defaultaccountType = this.state.accountlist.filter(
      (e) => e.id === id
    )[0].name;

    if (SharedAccountInvoice != "") {
      this.setState(
        { isPaidButtonDisabled: true, isRefresh: !this.state.isRefresh },
        () => {
          confirmAlert({
            title: "Alert",
            message: SharedAccountInvoice,
            buttons: [
              {
                label: "Ok",
                onClick: () => reject(),
              },
            ],
          });
        }
      );
    } else {
      this.setState({ isPaidButtonDisabled: false });
    }

    this.setState({ formData, defaultaccountType }, () => {
      this.setState({ movebuttonDisable: false });
    });
  };
  onChangeStatus = (e: any, items: any, index: any) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let data = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.tableColumnList))
    );

    let hidExist = splitData.filter((e) => e.spiltHoteID !== "").length;
    let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
    let projectNameExist = splitData.filter((e) => e.pID > 0).length;
    let descriptionExist = splitData.filter((e) => e.description !== "").length;

    data[index].isChecked = e.target.checked;
    let chekedColumns = data
      .filter((item) => item.isChecked)
      ?.map((item) => item.name?.toUpperCase());
    const transactionsColumns = this.transactionsColumns.map((item) => {
      if (
        hidExist > 0 &&
        this.state.splitHIDList.length > 1 &&
        item.text?.toUpperCase() === "EHID".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        subVendorExist > 0 &&
        item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        projectNameExist > 0 &&
        item.text?.toUpperCase() === "Project".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        descriptionExist > 0 &&
        item.text?.toUpperCase() === "Description".toUpperCase()
      ) {
        item.hidden = false;
      } else {
        item.hidden =
          chekedColumns.includes(item.text?.toUpperCase()) || !item.text
            ? false
            : true;
      }
      return item;
    });
    this.setState({ transactionsColumns: [] }, () => {
      this.setState(
        { tableColumnList: data, HIDColumn: true, transactionsColumns },
        () => {
          $("#colList").click();
        }
      );
    });
  };

  updateState = (e: any, index: any, type: any, txtID) => {
    let isStateChanged = true;
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (type === "desc") {
      e.preventDefault();
      splitData[index].description = e.target.value;
      splitData[index].isDescription = "Yes";
      this.setState({ splitData, isStateChanged }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblSplit").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    } else if (type === "amt") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (e.target.value.includes("-")) {
        lenbeforePoint = 9;
      }

      if (rx_live.test(e.target.value)) {
        if (e.target.value.includes(".")) {
          const timeArray = e.target.value?.split(".");
          if (
            timeArray[0].length <= lenbeforePoint &&
            timeArray[1].length <= 2
          ) {
            splitData[index].amount = e.target.value;
          }
        } else {
          if (e.target.value.length <= lenbeforePoint) {
            splitData[index].amount = e.target.value;
          }
        }
      } else if (e.target.value.includes(".") && e.target.value.length === 1) {
        splitData[index].amount = e.target.value;
      }

      this.setState({ splitData, isStateChanged }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtamt = $("#tblSplit").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        txtamt.selectionStart = start;
        txtamt.selectionEnd = end;
        this.addTotalAmount(this.state.splitData);
      });
    }
  };

  addTotalAmount(splitData: any[]) {
    let splitData1 = Object.assign([], JSON.parse(JSON.stringify(splitData)));
    let totalAmount: string = "0";
    splitData1.forEach((element) => {
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "."
          ? "0"
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === ""
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "-"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "+"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      totalAmount = Number(
        Number(Number(totalAmount).toFixed(2)) + Number(element.amount)
      ).toString();
    });
    let newtotalAmount = Utils.currencyFormat(totalAmount);
    let formData = { ...this.state.formData };
    this.setState(
      { totalAmount: newtotalAmount, formData, isStateChanged: true },
      () => {
        this.totalAmtDiff(
          this.state.formData.transactionTotal,
          this.state.totalAmount
        );
      }
    );
  }

  CalculateTotalAmount(splitData: any[]) {
    let splitData1 = Object.assign([], JSON.parse(JSON.stringify(splitData)));
    let totalAmount: string = "0";
    splitData1.forEach((element) => {
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "."
          ? "0"
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === ""
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "-"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "+"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      totalAmount = Number(
        Number(Number(totalAmount).toFixed(2)) +
          Number(Number(element.amount).toFixed(2))
      ).toString();
    });
    let newtotalAmount = Utils.currencyFormat(totalAmount);
    let formData = { ...this.state.formData };
    this.setState({ totalAmount: newtotalAmount, formData }, () => {
      this.totalAmtDiff(
        this.state.formData.transactionTotal,
        this.state.totalAmount
      );
    });
  }

  handleSaveFiles(files: any) {
    let request: any = {};
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    request.entryType =
      this.state.formData.actionType === "copy"
        ? "INCOMPLETEINVOICE"
        : this.state.pageType === "Invoice"
        ? "Invoices"
        : "INCOMPLETEINVOICE";
    let splitItems: any = [];
    request.SplitItems = splitItems;

    this.setState({ isDisabled: true });

    let userComments: any = [];
    userComments = this.ChildComment?.current.CommentToSave();
    request.UserComments = userComments;
    registersevice
      .SaveInvoiceFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            let formData = { ...this.state.formData };
            if (this.state.pageType === "Invoice") {
            } else {
              formData.incompleteUniqueno = result.actualID;
              formData.uniqueno = 0;
            }

            if (request.uniqueno === 0) {
              this.GetTransactionComment(result.actualID);
            }

            this.setState({
              invoiceUniqueNo: result.actualID,
              formData,
              isDisabled: false,
            });
            this.GetUploadFileList(result.actualID, 1);
            this.hideBulkselect(); // added to reset checkboxes of bulk select attachments
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isDisabled: false });
            if (result.messageCode === "Validation") {
              this.handleDiscard(request.uniqueno);
            }
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  GetTransactionComment = (uniqueNo) => {
    let statusTypeList: any[] = [
      { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
      { id: 1, name: "Needs Review", eventName: "Needs Review" },
      { id: 2, name: "Reviewed", eventName: "Reviewed" },
      { id: 3, name: "Review Complete", eventName: "Review Complete" },
    ];

    let commentRequest: any = {};
    commentRequest.uniqueNo = uniqueNo;
    commentRequest.etype = this.state.pageType;
    registersevice
      .GetTransactionComment(commentRequest)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          let currentStatus = result[0].currentStatus;
          let currentStatusUserName = result[0].currentStatusUserName;
          // if (currentStatus.toLowerCase() === "review") {
          //   currentStatus = "markForReview";
          // }
          let reviewCurrentDescription = "";
          if (currentStatus.length > 0) {
            let currentFlagName = statusTypeList.filter(
              (x) => x.eventName.toLowerCase() === currentStatus.toLowerCase()
            )[0].name;
            reviewCurrentDescription =
              currentFlagName + " by " + currentStatusUserName;
          }

          this.setState({ htmlcomment: [], isComment: false }, () => {
            this.setState(
              {
                htmlcomment: result,
                isComment: true,
                reviewCurrentDescription,
                reviewStatus: currentStatus,
                selectedReviewStatus: currentStatus,
              },
              () => {
                this.addReviewStatus();
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  callBackCommentLoad = () => {
    if (this.props?.loadFrom?.toLowerCase() === "invoicecomments") {
      console.log("Invoice comments");
      setTimeout(() => {
        this.scrollToBottom();
      }, 600);
    }
  };

  saveInvoice = (entryType, isCopy) => {
    this.setState({ isSaveSpinner: true });
    let isFormValid = true;
    let request: any = {};
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    request.entryType = entryType;
    if (entryType === "INCOMPLETEINVOICE" && isCopy === false) {
      request.actionType = "";
    }

    request.transactionTotal = Utils.removecurrencyFormat(
      request.transactionTotal
    );
    if (this.ChildComment.current.isCommentAdd()) {
      Utils.toastError("Please add your comments.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.vendorID === 0 && !isCopy) {
      Utils.toastError("Please select vendor.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      this.setState({ isSaveSpinner: false });
      return false;
    }
    if (request.isPaid.toLowerCase() === "paid") {
      if (this.state.defaultaccountType === "Select Account") {
        Utils.toastError("Please select Account.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      }
    }
    if (
      (this.state.isDigitalEnable.toString().toLowerCase() !== "yes" ||
        this.state.isbank.toString().toLowerCase() !== "yes") &&
      request.paymenttype.toString().toLowerCase() ===
        "Digital ACH".toLowerCase()
    ) {
      Utils.toastError(
        "Digital ACH is not Enabled for this Hotel, Please contact the administrator to complete this setup.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        }
      );
      this.setState({ isSaveSpinner: false });
      return false;
    }
    if (entryType === "INVOICES") {
      let totalAmountdiff = Utils.removecurrencyFormat(
        this.state.totalAmountdiff
      );

      if (request.transactionTotal.toString().trim() === "") {
        Utils.toastError("Please enter total amount.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      }

      if (Number(totalAmountdiff) !== Number(0)) {
        Utils.toastError("Invoice Total and split amounts do not match.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      }

      if (request.paymenttype.length === 0) {
        Utils.toastError("Please select Payment Type.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (request.invoiceno.trim().length === 0) {
        Utils.toastError("Please enter the invoice number.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (this.state.isduplicateInvoice) {
        Utils.toastError("Invoice Number already posted.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (request.transcationDate === null) {
        Utils.toastError("Please choose Invoice Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (request.dueDate === null) {
        Utils.toastError("Please choose Due Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (
        new Date(request.transcationDate) > new Date(request.dueDate)
      ) {
        Utils.toastError("Due date can not be less than the invoice date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (
        request.gDate === null &&
        this.state.selectedpaymentType.toLowerCase() === "ACH".toLowerCase()
      ) {
        Utils.toastError("Please choose Transaction Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        return false;
      } else if (
        request.gDate === null &&
        this.state.selectedpaymentType.toLowerCase() ===
          "Credit Card".toLowerCase()
      ) {
        Utils.toastError("Please choose Transaction Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (request.accPeriod.length === 0) {
        Utils.toastError("Please select accounting period.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      } else if (
        entryType === "INVOICES" &&
        (request.checkNo !== "" ||
          this.state.digitalAchStatus === "Yes" ||
          this.state.formData.concilestatus.toString().toLowerCase() === "yes")
      ) {
        if (
          Number(Utils.removecurrencyFormat(this.state.amountTotal)) !==
          Number(Utils.removecurrencyFormat(this.state.totalAmount))
        ) {
          Utils.toastError(
            "Total amount should be same as the approved amount.",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            }
          );
          this.setState({ isSaveSpinner: false });
          return false;
        }
      }

      let arrdata;
      if (this.state.splitHIDList.length > 1) {
        arrdata = this.state.splitData.filter(
          (e) =>
            e.coaName.length > 0 ||
            e.pID > 0 ||
            e.subVID > 0 ||
            e.description.length > 0 ||
            Utils.removecurrencyFormat(e.amount) !== ""
        );
      } else {
        arrdata = this.state.splitData.filter(
          (e) =>
            e.coaName.length > 0 ||
            e.pID > 0 ||
            e.subVID > 0 ||
            e.description.length > 0 ||
            Utils.removecurrencyFormat(e.amount) !== ""
        );
      }

      if (arrdata.length > 0) {
        if (this.state.splitHIDList.length > 1) {
          request.SplitItems = this.state.splitData.filter(
            (e) =>
              e.coaName.length > 0 ||
              e.pID > 0 ||
              e.subVID > 0 ||
              e.description.length > 0 ||
              Utils.removecurrencyFormat(e.amount) !== ""
          );
        } else {
          request.SplitItems = this.state.splitData.filter(
            (e) =>
              e.coaName.length > 0 ||
              e.pID > 0 ||
              e.subVID > 0 ||
              e.description.length > 0 ||
              Utils.removecurrencyFormat(e.amount) !== ""
          );
        }
      } else {
        request.SplitItems = this.state.splitData;
        Utils.toastError("Please select at least one COA.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "InvoiceSlideout",
        });
        this.setState({ isSaveSpinner: false });
        return false;
      }
      isFormValid = this.isValidForm(request);
    } else {
      let splitItems: any = [];
      splitItems = this.state.splitData.filter(
        (e) => e.lettercode !== "" || e.coaName !== "" || e.projectName !== ""
      );
      splitItems.forEach((element) => {
        element.spiltHoteID =
          element.spiltHoteID === "" ? -1 : element.spiltHoteID;
        element.splitoprID =
          element.splitoprID === "" ? -1 : element.splitoprID;
        element.amount =
          Utils.removecurrencyFormat(element.amount) === ""
            ? ""
            : Utils.removecurrencyFormat(element.amount);
      });
      request.SplitItems = splitItems;
    }
    if (isFormValid) {
      if (this.state.savedfiles.length === 0) {
        if (entryType !== "INVOICES" || request.uniqueno <= 0) {
          if (isCopy) {
            this.changeTransactionType(entryType, request, isCopy);
          } else {
            this.setState(
              { saveentryType: entryType, saverequest: request },
              () => this.setState({ ispopupshow: true })
            );
          }
        } else {
          this.changeTransactionType(entryType, request, isCopy);
        }
      } else {
        this.changeTransactionType(entryType, request, isCopy);
      }
    }
  };

  isHandleAction() {
    this.setState({ ispopupshow: false }, () =>
      this.changeTransactionType(
        this.state.saveentryType,
        this.state.saverequest,
        false
      )
    );
  }

  changeTransactionType(entryType, request, isCopy) {
    if (entryType === "INVOICES") {
      if (this.state.showReviewBanner && this.state.isPostTrx === "yes") {
        this.isCheckReviewBanner(request, isCopy);
      } else {
        this.handleDuplicateInvoiceOnVendorChange(request, isCopy);
      }
    } else {
      this.saveInvoiceData(request, isCopy);
    }
  }

  diffrentEHIDInvoice(request, isCopy) {
    if (this.state.isduplicateEHIDInvoice) {
      confirmAlert({
        title: "POSSIBLE DUPLICATION WARNING",
        message:
          "The invoice numbers in red have been entered for this vendor but in a different E/HID. Please review and make changes if needed.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.validAmount(request, isCopy),
          },
          {
            label: "No",
            onClick: () => {
              this.setState({ isSaveSpinner: false });
              reject();
            },
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      this.validAmount(request, isCopy);
    }
  }

  handleDuplicateInvoiceOnVendorChange = (saveRequest, iscopy) => {
    let formData = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    let invoiceno = formData.invoiceno.toString().trim();

    if (invoiceno.length > 0) {
      let request: any = {};
      request.uniqueNo =
        this.state.formData.actionType === "copy"
          ? 0
          : this.state.formData.uniqueno;
      request.hotelId = this.state.formData.hotelID;
      request.vid = this.state.formData.vendorID;
      request.invoiceno = invoiceno;
      request.status = "new";
      this.checkDuplicateInvoiceOnVendorChange(request, saveRequest, iscopy);
    }
  };

  checkDuplicateInvoiceOnVendorChange(request, saveRequest, iscopy) {
    this.setState({ isduplicateInvoice: false, isduplicateEHIDInvoice: false });
    registersevice
      .CheckDuplicateInvoice(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState(
            {
              isduplicateInvoice:
                result[0].isSameHIDInvoice === "Yes" ? true : false,
              isduplicateEHIDInvoice:
                result[0].isDiffHIDInvoice === "Yes" ? true : false,
            },
            () => {
              this.diffrentEHIDInvoice(saveRequest, iscopy);
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  validAmount(request, isCopy) {
    if (this.state.formData.approved.toLowerCase() === "App".toLowerCase()) {
      this.saveInvoiceData(request, isCopy);
    } else {
      let prms: any = {};
      prms.hotelID = request.hotelID;
      prms.vid = request.vendorID;
      prms.date = request.transcationDate;
      prms.uniqueno = request.uniqueno;
      prms.transactionTotal = request.transactionTotal;
      registersevice
        .IsAmountExist(prms)
        .then(async (result: any | null) => {
          if (result !== null) {
            if (result.saveStatus === "Success") {
              confirmAlert({
                title: "Alert",
                message: result.message,
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => this.saveInvoiceData(request, isCopy),
                  },
                  {
                    label: "No",
                    onClick: () => {
                      this.setState({ isSaveSpinner: false });
                      reject();
                    },
                  },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
              });
            } else {
              this.saveInvoiceData(request, isCopy);
            }
          }
          resolve();
        })
        .catch((error) => {
          reject();
        });
    }
  }

  saveInvoiceData(request, isCopy) {
    // if (
    //   this.state.formData.readyForPayment !== "Paid" &&
    //   this.state.formData.isPaid === "Paid" &&
    //   this.state.formData.actionType !== "copy" &&
    //   (this.state.formData.vendorID !== this.state.oldVendorId ||
    //     this.state.defaultpaymentType.toLowerCase() !==
    //     (this.state.associatedPayments[0].type.toLowerCase() ===
    //       "M-ACH".toLowerCase()
    //       ? "ACH".toLowerCase()
    //       : this.state.associatedPayments[0].type.toLowerCase()))
    // ) {
    //   setTimeout(() => {
    //     confirmAlert({
    //       title: "Unsaved confirmation",
    //       message:
    //         "This invoice is already marked as paid. Do you want to mark as unpaid to change the vendor / account type?",
    //       buttons: [
    //         {
    //           label: "Yes",
    //           onClick: () => this.isPaymentChange(request, isCopy),
    //         },
    //         {
    //           label: "No",
    //           onClick: () => {
    //             this.setState({ isSaveSpinner: false });
    //             reject();
    //           },
    //         },
    //       ],
    //       closeOnEscape: false,
    //       closeOnClickOutside: false,
    //     });
    //   }, 100);
    // } else
    if (
      this.state.formData.readyForPayment === "Paid" &&
      this.state.formData.actionType !== "copy" &&
      this.state.defaultpaymentType.toLowerCase() !==
        (this.state.associatedPayments[0].type.toLowerCase() ===
        "M-ACH".toLowerCase()
          ? "ACH".toLowerCase()
          : this.state.associatedPayments[0].type
              .toLowerCase()
              .includes("check")
          ? "check"
          : this.state.associatedPayments[0].type.toLowerCase())
    ) {
      setTimeout(() => {
        confirmAlert({
          title: "Alert",
          message:
            "By changing the payment method, this invoice will move back to the Payments page and will no longer be marked as paid.",
          buttons: [
            {
              label: "Proceed",
              onClick: () => this.isPaymentChange(request, isCopy),
            },
            {
              label: "Cancel",
              onClick: () => {
                this.setState({ isSaveSpinner: false });
                reject();
              },
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      }, 100);
    } else {
      this.isCheckValidPaymentAddress(request, isCopy);
    }
  }

  isPaymentChange = (request, isCopy) => {
    this.setState({ isPaymentChange: "Yes" }, () => {
      this.isCheckValidPaymentAddress(request, isCopy);
    });
  };

  isCheckValidPaymentAddress = (request: any, isCopy: any) => {
    if (request.paymenttype.toString().toLocaleLowerCase() === "epay") {
      let apiRequest: any = {};
      apiRequest.VID = request.vendorID;
      apiRequest.HID = request.hotelID;
      apiRequest.Contract = request.vendorContract;
      this.vendorCheckEpayAddress(
        apiRequest,
        "sendtoApproval",
        request,
        isCopy
      );
    } else {
      this.saveInvoiceDataDB(request, isCopy);
    }
  };

  saveInvoiceDataDB(request, isCopy) {
    if (
      this.state.defaultpaymentType.toLowerCase() ===
      "Select Type".toLowerCase()
    ) {
      Utils.toastError("Please select Type.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      this.setState({ isSaveSpinner: false });
      return false;
    }

    let limitAmount = this.state.digitalLimit;
    if (
      request.entryType === "INVOICES" &&
      this.state.formData.uniqueno === 0 &&
      this.state.formData.paymenttype.toLowerCase() ===
        "Digital ACH".toLowerCase() &&
      Number(this.state.digitalLimit) < Number(this.state.totalAmount)
    ) {
      alert(
        "Digital ACH payment can not be more than $" +
          limitAmount +
          ". Please split into multiple payments."
      );
    }

    let updatedsplitlist: any = [];
    request.SplitItems.forEach((element) => {
      element.projectlist = [];
      element.subVendorlist = [];
      let splitlistItem: any = [];

      splitlistItem.coa = element.coa;
      splitlistItem.spiltHoteID = element.spiltHoteID;
      splitlistItem.subVID = element.subVID;
      splitlistItem.pID = element.pID;
      splitlistItem.description = element.description;
      splitlistItem.amount = Utils.removecurrencyFormat(element.amount);
      updatedsplitlist.push(splitlistItem);
    });
    request.isSplitChange = "false";

    let splitActualList = this.state.splitActualList;
    if (
      request.entryType === "INVOICES" &&
      Number(this.state.formData.incompleteUniqueno) > 0
    ) {
      request.isSplitChange = "true";
    } else if (this.state.splitActualList.length !== updatedsplitlist.length) {
      request.isSplitChange = "true";
    } else {
      updatedsplitlist.forEach((ele, idx) => {
        if (
          (ele.coa !== splitActualList[idx].coa ||
            ele.spiltHoteID !== splitActualList[idx].spiltHoteID ||
            ele.subVID !== splitActualList[idx].subVID ||
            ele.pID !== splitActualList[idx].pID ||
            ele.description.toLowerCase() !==
              splitActualList[idx].description.toLowerCase() ||
            Utils.removecurrencyFormat(ele.amount) !==
              Utils.removecurrencyFormat(splitActualList[idx].amount)) &&
          request.isSplitChange === "false"
        ) {
          request.isSplitChange = "true";
        }
      });
    }

    let userComments: any = [];
    userComments = this.ChildComment?.current.CommentToSave();

    request.UserComments = userComments;
    request.repeatDate = request.endDate;
    request.InvoiceMailID = this.state.emailPdfID;

    if (this.state.isMarkAsPaidClicked) {
      request.isPaid = "Paid";
    }
    if (request.entryType === "INCOMPLETEINVOICE") {
      request.isPostTrx = "no";
    } else {
      request.isPostTrx = this.state.isPostTrx;
    }
    request.isSaveFromMarkAsPaid = this.state.isMarkAsPaidClicked;
    request.bypassTo = this.getBypassStatus();

    this.setState({ isDisabled: true, isSave: true });
    registersevice
      .SaveInvoiceTransaction(request, this.state.files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            let prevMarkAsPaidClicked = this.state.isMarkAsPaidClicked;
            this.hidePaymentModal();
            this.hideBulkselect(); // added to reset checkboxes of bulk select attachments - NW-41640
            let vendorstatus = this.state.vendorApproval;
            //  result.vendorStatus === "" ? "App" : result.vendorStatus;
            this.setState(
              {
                vendorSelectedDB: Object.assign(
                  [],
                  JSON.parse(JSON.stringify(this.state.vendorSelected))
                ),
                isShowTypeChangeAlert: true,
                isMarkAsPaidClicked: false,
                isPostTrx: "no",
                isDisabled: false,
                isStateChanged: false,
                somechange: true,
                vendorApproval: vendorstatus,
                oldVendorId: this.state.formData.vendorID,
                isPaidDB: this.state.formData.isPaid,
                isPropsReload: true
              },
              () => {
                if (isCopy) {
                  let formData = { ...this.state.formData };
                  let newactualID = Number(result.actualID);
                  formData.incompleteUniqueno = newactualID;
                  formData.fileCopyfromUniqueno = 0;
                  formData.fileCopyfrom = "";
                  this.setState(
                    { formData, isStateChanged: true, isSaveSpinner: false },
                    () => {
                      this.GetUploadFileList(newactualID, 1);
                      this.resetReviewStatus();
                    }
                  );
                } else {
                  let newactualID = Number(result.actualID);
                  if (!this.state.createOther) {
                    this.GetUploadFileList(newactualID, 1);
                  }
                  let splitData: any = [];
                  splitData = Object.assign(
                    [],
                    JSON.parse(JSON.stringify(this.state.splitData))
                  );
                  splitData.forEach((element) => {
                    element.isHideRow = 0;
                    element.isSplitChecked = 0;
                  });

                  this.setState({
                    splitData,
                    bulkSelectedSplitRows: [],
                    showAssignCOABtn: false,
                    defaultEntry: "all-entry",
                    isAllIncomplete: false,
                  });

                  // if (
                  //   this.state.savedPaymentType.toLowerCase() !==
                  //   this.state.formData.paymenttype.toLowerCase()
                  // ) {
                  let associatedPayments: any = [];
                  let elemnt: any = {};
                  elemnt.date = this.state.formData.gDate;
                  elemnt.type =
                    this.state.defaultpaymentType.toLowerCase() === "ach"
                      ? "M-ACH"
                      : this.state.defaultpaymentType;
                  elemnt.account = this.state.defaultaccountType;
                  elemnt.amount = Utils.removecurrencyFormat(
                    this.state.formData.transactionTotal
                  );
                  elemnt.paymentNotes = this.state.formData.paymentNotes.trim();
                  associatedPayments.push(elemnt);
                  this.setState({ associatedPayments: [] }, () => {
                    this.setState({ associatedPayments: associatedPayments });
                  });
                  // }

                  if (this.state.isPaymentChange == "Yes") {
                    let formData = { ...this.state.formData };
                    formData.isPaid = "Unpaid";
                    this.setState({ formData, isPaidDB: "Unpaid" });
                  }

                  if (
                    this.state.vendorApproval.toLowerCase() === "app" &&
                    this.state.formData.approved.toLowerCase() !==
                      "App".toLowerCase() &&
                    this.state.formData.uniqueno > 0 &&
                    this.state.approveInvoiceStatus?.filter(
                      (e) => e.status === 0
                    ).length > 0 &&
                    this.state.formData.actionType.length === 0
                  ) {
                    this.setState({ isSaveSpinner: false });
                    this.checkInvoiceApproval("new");
                    this.getInvoiceCOAMapping(this.state.formData.vendorID);
                  } else if (
                    this.state.vendorApproval.toLowerCase() === "app" &&
                    this.state.formData.approved.toLowerCase() ==
                      "App".toLowerCase() &&
                    this.state.formData.readyForPayment !== "Paid" &&
                    this.state.formData.checkNo.length === 0 &&
                    this.state.digitalAchStatus != "Yes" &&
                    this.state.formData.uniqueno > 0 &&
                    this.state.formData.actionType.length === 0
                  ) {
                    this.setState({ isSaveSpinner: false });
                    this.checkInvoiceApproval("new");
                    this.getInvoiceCOAMapping(this.state.formData.vendorID);
                  } else {
                    if (request.entryType === "INVOICES") {
                      let formData = { ...this.state.formData };
                      let newactualID = Number(result.actualID);
                      formData.incompleteUniqueno = newactualID;
                      this.setState(
                        { formData, invoiceUniqueNo: newactualID },
                        () => {
                          // this.addReviewStatus();
                          let isBankSyncInvoice =
                            this.props?.selectedRow?.callFrom ===
                            "BankSyncInvoice";
                          if (isBankSyncInvoice) {
                            if (
                              this.props.transationSlideoutSave !== undefined
                            ) {
                              request.pageType = "BankSyncInvoice";
                              request.uniqueno = Number(result.actualID);
                              result.uniqueno = Number(result.actualID);
                              this.props.transationSlideoutSave(
                                request,
                                result
                              );
                            }
                            setTimeout(() => {
                              this.closeSlideOut(this.state.invoiceUniqueNo);
                            }, 3000);
                          }
                        }
                      );
                    }
                    if (!this.state.createOther || prevMarkAsPaidClicked) {
                      setTimeout(() => {
                        if (
                          request.entryType === "INVOICES"
                          //  && this.state.formData.incompleteUniqueno > 0
                        ) {
                          this.handleDiscard(
                            this.state.formData.incompleteUniqueno
                          );
                        } else {
                          let formData = { ...this.state.formData };
                          let newactualID = Number(result.actualID);
                          formData.incompleteUniqueno = newactualID;
                          formData.actionType = "";
                          this.setState(
                            {
                              formData,
                              invoiceUniqueNo: newactualID,
                              pageType: "INCOMPLETEINVOICE",
                            },
                            () => {
                              let isBankSyncInvoice =
                                this.props?.selectedRow?.callFrom ===
                                "BankSyncInvoice";
                              if (isBankSyncInvoice) {
                                if (
                                  this.props.transationSlideoutSave !==
                                  undefined
                                ) {
                                  request.pageType = "BankSyncIncomplete";
                                  request.uniqueno = Number(result.actualID);
                                  result.uniqueno = Number(result.actualID);
                                  this.props.transationSlideoutSave(
                                    request,
                                    result
                                  );
                                }
                                setTimeout(() => {
                                  this.closeSlideOut(
                                    this.state.invoiceUniqueNo
                                  );
                                }, 3000);
                              } else {
                                let requestlist = { ...this.state.requestlist };
                                requestlist.oprID = "-1";
                                requestlist.etype = "INCOMPLETEINVOICE";
                                this.GetTranToUpdate(requestlist);
                                this.GetTransactionComment(newactualID);
                                // this.addReviewStatus();
                              }
                            }
                          );
                        }
                      }, 3000);
                    } else {
                      this.resetState();
                      this.GetTransactionEntryColoumn(this.state.formData);
                      this.setState({
                        incompleteFiles: [],
                        incompleteFilesCopy: [],
                        savedfiles: [],
                        newSelectfiles: [],
                        files: [],
                        isSaveSpinner: false,
                      });
                    }
                  }
                }
              }
            );
          } else {
            this.hidePaymentModal();
            this.setState({
              isDisabled: false,
              isSaveSpinner: false,
              isMarkAsPaidClicked: false,
              isPostTrx: "no",
            });
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });

            if (result.messageCode === "Validation") {
              this.handleDiscard(request.uniqueno);
            }
          }
        }
        this.setState({
          isDisabled: false,
          moveHID: { hidValue: -1, hidName: "" },
          isPaymentChange: "no",
        });
        resolve();
      })
      .catch((error) => {
        this.hidePaymentModal();
        this.setState({
          isDisabled: false,
          moveHID: { hidValue: -1, hidName: "" },
          isSaveSpinner: false,
          isMarkAsPaidClicked: false,
          isPostTrx: "no",
        });
        reject();
      });
  }

  invoiceToApprove = () => {
    this.setState({ isApproveClicked: true, });
    let { formData } = this.state;
    let request: any = {};
    request.InvoiceUniqueNo = formData.uniqueno;
    let ruleIDList: any = [];
    this.state.rulesArray.forEach(
      (item) => item.isCheck && ruleIDList.push(item.ruleID)
    );
    ruleIDList = ruleIDList.toString();
    request.RuleIds = ruleIDList;
    let request1: any = {};
    request1.InvoiceUniqueNo = formData.uniqueno;

    registersevice
      .CheckInvoiceApprovalStatus(request1)
      .then(async (result: any | null) => {
        if (result.status.toLowerCase() === "no") {
          // result.status = no means invoice is not approved, if yes then it is already approved

          registersevice
            .invoiceToApprove(request)
            .then(async (result: any | null) => {
              if (result !== null) {
                if (result.success) {
                  if (!this.state.createOther) {                    
                    this.setState({ isApproveClicked: false, },()=>{
                      this.props.hideSlideOut(true);
                    });
                  } else {
                    this.setState(
                      {
                        showRuleModal: false,
                        isComment: false,
                        isPreviousTransactions: false,
                        isPropsReload:true
                      },
                      () => {
                        this.setState({ isComment: true, htmlcomment: [] });
                        if (this.state.saveAction === "AllInvoices") {
                          this.GetInvoiceDataAllInvoices("reload");
                        } else if (this.state.saveAction === "WaitingOnMe") {
                          this.GetInvoiceWaitingOnMe("reload");
                        }
                      }
                    );
                  }
                } else {
                this.setState({ isApproveClicked: false, });
                  Utils.toastError(result.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  });
                }
              } else {
                this.setState({ isApproveButton: false, isApproveClicked: false, }, () => {
                  Utils.toastError("Something went wrong.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  });
                });
              }
              resolve();
            })
            .catch((error) => {
              this.setState({ isApproveClicked: false, });
              Utils.toastError(`Server Error ${error}`);
              reject();
            });
        }
        else {
          this.setState({ isApproveClicked: false, });
          Utils.toastError(`This invoice is already approved.`);
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isApproveClicked: false, });
        Utils.toastError(`Server Error ${error}`);
        reject();
      });
  };

  retunToInvoice = () => {
    this.setState({ isApproveButton: false });
  };

  isValidForm = (request: any) => {
    let notvalid = true;
    let data = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.tableColumnList))
    );
    let chekedColumns = data.filter(
      (item) => item.name.toString().toLowerCase() === "ehid"
    )[0].isChecked;
    if (!chekedColumns) {
      request.SplitItems.forEach((element) => {
        element.defaultEhid = this.state.hotelName;
        element.lettercode = this.state.hotelName;
        element.spiltHoteID = this.state.hotelValue;
      });
    }

    if (request.SplitItems.length > 0) {
      request.SplitItems.forEach((element) => {
        if (notvalid) {
          if (element.spiltHoteID === "") {
            Utils.toastError("Please EHID.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isSaveSpinner: false });
            notvalid = false;
          } else if (element.coa.length === 0) {
            Utils.toastError("Please select COA.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isSaveSpinner: false });
            notvalid = false;
          } else if (
            request.vendorID.toString() === element.subVID.toString()
          ) {
            Utils.toastError("Vendor and Sub-Vendor can not be same.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isSaveSpinner: false });
            notvalid = false;
          } else if (element.amount.length === 0) {
            Utils.toastError("Please enter amount.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isSaveSpinner: false });
            notvalid = false;
          }
        }
      });
    } else {
      Utils.toastError("Please select COA.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      this.setState({ isSaveSpinner: false });
      notvalid = false;
    }

    return notvalid;
  };

  handleSaveColumn = () => {
    let tableColumnList = this.state.tableColumnList.filter(
      (e) => e.isChecked === true
    );
    let columns: any = [];
    tableColumnList.forEach((element) => {
      columns.push(element.id);
    });
    let columnstring = columns.join(",");
    let saveRequest: any = {};
    saveRequest.hotelID = this.state.formData.hotelID;
    saveRequest.oprid = this.state.formData.oprID;
    saveRequest.vid = this.state.formData.vendorID;
    saveRequest.columnname = columnstring;

    this.setState({ isdefaultColDisabled: true });
    registersevice
      .SaveTransactionColumn(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ isdefaultColDisabled: false });
          if (result.saveStatus === "Success") {
            //do this
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false });
        reject();
      });
  };

  resetState() {
    let formData = { ...this.state.formData };
    formData.internalNotes = "";
    formData.actionType = "";
    formData.transcationDate = this.state.defaulttranscationDate;
    formData.dueDate = this.state.defaulttranscationDate;
    formData.accPeriod = this.state.selectedaccountingPeriod;
    formData.checkNo = "";
    formData.paymenttype = this.state.defaultpaymentType1;
    formData.invoiceno = "";
    formData.transactionTotal = "0.00";
    formData.gDate = this.state.defaultgdate;
    formData.isPaid = "Unpaid";
    if (this.state.createOther) {
      formData.incompleteUniqueno = 0;
    }
    let accPeriodList: any = [];
    let paymentType1: any = [];
    accPeriodList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    paymentType1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );
    this.setState(
      {
        totalAmountdiff: 0.0,
        isAmountDiff: "No",
        totalAmount: "$0.00",
        htmlcomment: [],
        paymentType: [],
        accPeriodList: [],
        accountlist: [],
        splitData: [],
        defaultpaymentType: this.state.defaultpaymentType1,
        defaultaccountingPeriod: this.state.selectedaccountingPeriod,
        isComment: false,
      },
      () => {
        this.setState(
          {
            invoiceUniqueNo: this.state.createOther
              ? 0
              : this.state.createOther,
            moveHID: { hidValue: -1, hidName: "" },
            isComment: true,
            isStateChanged: this.state.createOther ? true : false,
            savedfiles: [],
            files: [],
            newSelectfiles: [],
            formData,
            isPaidDB: formData.isPaid,
            accPeriodList: accPeriodList,
            isOpenViewer: false,
            paymentType: paymentType1,
            tableColumnList: [
              { id: "ehid", name: "EHID", isChecked: true, disabled: false },
              { id: "coa", name: "COA", isChecked: true, disabled: true },
              {
                id: "sub vendor",
                name: "Sub Vendor",
                isChecked: true,
                disabled: false,
              },
              {
                id: "project",
                name: "Project",
                isChecked: false,
                disabled: false,
              },
              {
                id: "description",
                name: "Description",
                isChecked: true,
                disabled: false,
              },
              { id: "amount", name: "Amount", isChecked: true, disabled: true },
            ],
            splitData: this.state.defaultSplitData,
          },
          () => {
            this.resetReviewStatus();
          }
        );
      }
    );
  }

  handleSelect = (eventKey) => {
    if (
      eventKey === "Flag for Review" ||
      eventKey === "Needs Review" ||
      eventKey === "Reviewed" ||
      eventKey === "Review Complete"
    ) {
      this.handleReviewStatus(eventKey);
    }

    if (eventKey === "delete") {
      confirmAlert({
        title: "Delete Invoice",
        message: "Are you sure you want to delete this invoice?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.handleDeleteInvoice(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    if (eventKey === "move") {
      this.setState({
        PeriodList: [],
        defaultPeriod: "Accounting Period",
        selectedPeriod: "",
        showInvoiceModal: true,
        updatedAccountName: "",
        defaultaccountType: "Select Account",
        moveselected: false,
        movebuttonDisable:
          this.state.formData.readyForPayment == "Paid" ? true : false,
      });
    }
    if (eventKey === "copy") {
      if (this.state.islimited === "Yes") {
        Utils.toastError(
          "Unable to copy invoice. This invoice was created with the full service subscription.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          }
        );
      } else {
        if (this.state.savedfiles.length > 0) {
          confirmAlert({
            title: "Copy Invoice",
            message: "Do you want to copy the attachments to the new invoice?",
            buttons: [
              {
                label: "Yes",
                onClick: () => this.CopyInvoice("Yes"),
              },
              {
                label: "No",
                onClick: () => this.CopyInvoice("No"),
              },
            ],
            overlayClassName: "copy-trancsation-alert",
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        } else {
          this.CopyInvoice("No");
        }
      }
    }
    if (eventKey === "ImportStatement") {
      this.setState({ creditCardStatementModal: true });
    }

    if (eventKey === "paid") {
      let formData = { ...this.state.formData };
      let invoicePaid = { ...this.state.invoicePaid };
      let today = Utils.getHotalCurrentDate();
      let dateNew =
        today.getMonth() + 1 > 9
          ? today.getMonth() +
            1 +
            "/" +
            today.getDate() +
            "/" +
            today.getFullYear()
          : "0" +
            (today.getMonth() + 1) +
            "/" +
            today.getDate() +
            "/" +
            today.getFullYear();
      formData.gDate =
        this.state.formData.ispayment !== "Yes"
          ? dateNew
          : this.state.mpaymentDate;

      formData.paymenttype = invoicePaid.paymentType;
      formData.paymentNotes = "";
      if (this.state.formData.ispayment !== "Yes") {
        formData.oprID = -1;
        formData.cardUniqueno = -1;
      } else {
        formData.oprID = -1;
      }
      this.setState(
        {
          updatedAccountName: "",
          formData,
          defaultaccountType: invoicePaid.account,
          selectedpaymentType: invoicePaid.paymentType,
          defaultpaymentType:
            invoicePaid.paymentType === ""
              ? "Select Type"
              : invoicePaid.paymentType,
          defaultpaymentType1:
            invoicePaid.paymentType === ""
              ? "Select Type"
              : invoicePaid.paymentType,
        },
        () => {
          this.setState(
            { paymentModal: true, isPaidButtonDisabled: true },
            () => {
              this.GetAccountList(
                invoicePaid.paymentType,
                this.state.formData.hotelID,
                "mark as paid",
                "markPaid"
              );
            }
          );
        }
      );
    }

    if (eventKey === "unpaid") {
      confirmAlert({
        title: "Confirm Mark Unpaid",
        message: "This will remove any associated payments.",
        buttons: [
          {
            label: "Mark Unpaid",
            onClick: () => this.markAsPaidUnpaid("Unpaid"),
          },
          {
            label: "Cancel",
            onClick: () => reject(),
          },
        ],
        overlayClassName: "mark-unpaid",
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
  };

  hideCreditCardModal = () => {
    this.setState({ creditCardStatementModal: false });
  };

  hideMoveInvoiceModal = (event: any) => {
    this.setState({
      showInvoiceModal: false,
      moveHID: { hidValue: -1, hidName: "" },
    });
  };

  CopyInvoice(iscopyFile) {
    $(".disabled-area")
      .find("input, textarea, button, select")
      .removeAttr("disabled");
    this.copyVendor(iscopyFile);
    let splitData: any = [];
    let accPeriodList: any = [];
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );

    splitData.forEach((splitItem) => {
      splitItem.isHideRow = 0;
      splitItem.isSplitChecked = 0;

      if (splitItem.isCOAPer !== "Yes") {
        splitItem.coaName = "";
        splitItem.coa = "";
        splitItem.defaultCoa = "";
        splitItem.isCOA = "Yes";
        splitItem.isCOAPer = "Yes";
      }
    });

    accPeriodList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    let paymentType = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );
    let accountlist = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accountlist))
    );
    if (iscopyFile === "Yes") {
      this.setState(
        {
          isPermission: this.state.CopyisPermission,
          isInvoiceEntry: this.state.CopyisPermission,
          invoiceBedge: "",
          isError: "",
          defaultaccountingPeriod: "",
          defaultPeriod: "",
          accPeriodList: [],
          paymentType: [],
          accountlist: [],
          isStateChanged: true,
          splitData: [],
          bulkSelectedSplitRows: [],
          showAssignCOABtn: false,
          defaultEntry: "all-entry",
          isAllIncomplete: false,
        },
        () => {
          this.setState(
            {
              digitalAchStatus: "No",
              paymentType: paymentType,
              accountlist: accountlist,
              accPeriodList: accPeriodList,
              defaultaccountingPeriod: this.state.selectdefaultperiod,
              defaultPeriod: this.state.selectdefaultperiod,
              splitData,
            },
            () => {
              this.saveInvoice("INCOMPLETEINVOICE", true);
            }
          );
        }
      );
    } else {
      this.setState(
        {
          isPermission: this.state.CopyisPermission,
          isInvoiceEntry: this.state.CopyisPermission,
          isError: "",
          invoiceBedge: "",
          digitalAchStatus: "No",
          defaultaccountingPeriod: "",
          defaultPeriod: "",
          accPeriodList: [],
          paymentType: [],
          accountlist: [],
          incompleteFiles: [],
          incompleteFilesCopy: [],
          savedfiles: [],
          newSelectfiles: [],
          files: [],
          isStateChanged: true,
          splitData: [],
          bulkSelectedSplitRows: [],
          showAssignCOABtn: false,
          defaultEntry: "all-entry",
          isAllIncomplete: false,
        },
        () => {
          this.setState(
            {
              paymentType: paymentType,
              accountlist: accountlist,
              accPeriodList: accPeriodList,
              defaultaccountingPeriod: this.state.selectdefaultperiod,
              defaultPeriod: this.state.selectdefaultperiod,
              splitData,
            },
            () => {
              this.saveInvoice("INCOMPLETEINVOICE", true);
            }
          );
        }
      );
    }
  }

  copyVendor(iscopyFile) {
    let formData = { ...this.state.formData };
    formData.accPeriod = this.state.selectdefaultperiod;
    formData.invoiceno = "";
    formData.iscopyAttachment = iscopyFile === "Yes" ? "yes" : "no";
    formData.concilestatus = "No";
    formData.accPeriodstatus = "Active";
    formData.adj = "N";
    formData.checkNo = "";
    formData.actionType = "copy";
    formData.readyForPayment = "";
    // Added to reset/change isPaid to Unpaid in case of Copy
    if (
      this.state.formData.readyForPayment != "Paid" ||
      this.state.formData.isPaid === "Paid"
    ) {
      formData.isPaid = "Unpaid";
    }

    if (Number(this.state.formData.vendorID) > 0) {
      if (this.state.formData.vendorStatus.toLowerCase() === "inactive") {
        let vendorSelected: any = [];
        let vendorItem: any = {};
        vendorItem.id = 0;
        vendorItem.accountNo = "";
        vendorItem.aid = 0;
        vendorItem.salestax = "";
        vendorItem.vendorName = "";
        vendorSelected.push(vendorItem);
        this.vendorSearch?.current.handleSelectFromParent(vendorSelected);

        formData.vendorID = 0;
        formData.vendorName = "";
        formData.vendorContract = "";
        formData.aid = 0;
        formData.transcationDate = null;
        formData.dueDate = null;
        formData.gDate = null;
        this.setState({ formData });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "inactive"
      ) {
        let today = Utils.getHotalCurrentDate();
        let date =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear();
        let addDays = this.state.hotelDate;
        addDays.setDate(
          addDays.getDate() + Number(this.state.formData.vendorDays)
        );
        let duedate =
          addDays.getMonth() +
          1 +
          "/" +
          addDays.getDate() +
          "/" +
          addDays.getFullYear();

        formData.transcationDate = this.state.hotelCurrentDate; //date;
        formData.dueDate = duedate;
        formData.gDate = date;
        this.setState({ formData }, () => {
          this.handleMultiContract(this.state.formData.hotelID);
        });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "active"
      ) {
        let today = Utils.getHotalCurrentDate();
        let date =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear();
        let addDays = this.state.hotelDate;
        addDays.setDate(
          addDays.getDate() + Number(this.state.formData.vendorDays)
        );
        let duedate =
          addDays.getMonth() +
          1 +
          "/" +
          addDays.getDate() +
          "/" +
          addDays.getFullYear();
        formData.transcationDate = this.state.hotelCurrentDate;
        formData.dueDate = duedate;
        formData.gDate = date;
        this.setState({ formData });
      }
    }
    this.setState(
      {
        formData,
        htmlcomment: [],
        isComment: false,
        isPaidDB: formData.isPaid,
      },
      () => {
        this.setState({ isComment: true }, () => {
          $(".disabled-area")
            .find("input, textarea, button, select")
            .attr("disabled", "disabled");
        });
      }
    );
  }

  handleDeleteInvoice() {
    let request: any = {};
    if (this.state.pageType === "Invoice") {
      request.uniqueno = this.state.formData.uniqueno;
    } else {
      request.uniqueno = this.state.formData.incompleteUniqueno;
    }
    request.hotelID = this.state.formData.hotelID;
    request.fileNo = 0;
    request.allDelete = "YES";
    if (this.state.pageType === "Invoice") {
      request.type = "INVOICES";
    } else {
      request.type = "INCOMPLETEINVOICE";
    }
    this.handleDeleteFileFromDb(request, [], 1);
  }

  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let request: any = {};
      request = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.state.formData))
      );
      let masg = "";
      if (this.state.savedfiles.length === 1 && request.vendorID === 0) {
        masg =
          "Deleting this attachment will also delete the draft invoice. Are you sure you want to delete this invoice?";
      } else {
        masg = "Are you sure you want to delete this Attachment?";
      }
      confirmAlert({
        title: "Delete Attachment",
        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.isDeleteInvoice(file),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    }
  };

  isDeleteInvoice(file) {
    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    this.handleFileDelete(newfiles, file);
  }

  handleFileDelete(newfiles, file) {
    let request: any = {};
    request.fileNo = file.fileUniqueno;
    request.uniqueno = file.uniqueNo;
    request.allDelete = "single";
    request.hotelID = this.state.formData.hotelID;

    if (this.state.pageType === "Invoice") {
      request.type = "INVOICES";
    } else {
      request.type = "INCOMPLETEINVOICE";
    }
    this.handleDeleteFileFromDb(request, newfiles, 2);
  }

  handleDeleteFileFromDb(request, newfiles, id) {
    let fileno = request.fileNo;
    registersevice
      .DeleteUploadedFile(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isPropsReload: true })
            if (id === 1) {
              this.setState({ isSave: true }, () => {
                this.handleDiscard(request.uniqueno);
              });
            } else {
              let request: any = {};
              request = Object.assign(
                {},
                JSON.parse(JSON.stringify(this.state.formData))
              );
              if (
                this.state.savedfiles.length === 1 &&
                request.vendorID === 0
              ) {
                this.setState({ isSave: true }, () => {});
              } else {
                const newIds = this.state.chkIds.filter(
                  (x) => x.fileNo !== Number(request.fileNo)
                );
                this.setState({ savedfiles: [] }, () => {
                  if (newfiles.length === 0) {
                    this.setState({ isOpenViewer: false });
                  }
                  this.setState(
                    { savedfiles: newfiles, chkIds: newIds },
                    () => {
                      this.hideBulkselect(); // added to reset checkboxes of bulk select attachments
                    }
                  );
                  for (let i = 0; i < this.state.savedfiles.length; i++) {
                    this["myRef" + i].current?.hanndleDeleteFile(
                      Number(fileno)
                    );
                  }
                });
              }
            }
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            if (result.messageCode === "Validation") {
              this.handleDiscard(request.uniqueno);
            }
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  downloadTranactionFile = (file: any) => {
    registersevice
      .DownloadTranactionFile(file)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleDuplicateInvoice = (event, rowIndex) => {
    let formData = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    formData.invoiceno = formData.invoiceno.toString().trim();
    this.setState({ formData }, () => {
      let request: any = {};
      request.uniqueNo = this.state.formData.uniqueno;
      request.hotelId = this.state.formData.hotelID;
      request.vid = this.state.formData.vendorID;
      request.invoiceno = this.state.formData.invoiceno;
      request.status = "new";
      this.checkDuplicateInvoice(request);
    });
  };

  checkDuplicateInvoice(request) {
    this.setState({ isduplicateInvoice: false, isduplicateEHIDInvoice: false });
    registersevice
      .CheckDuplicateInvoice(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result[0].isSameHIDInvoice === "Yes") {
            this.setState({ isduplicateInvoice: true });
            Utils.toastError("Invoice Number already posted.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
          if (result[0].isDiffHIDInvoice === "Yes") {
            this.setState({ isduplicateEHIDInvoice: true });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  handlePreview = (file: any) => {
    this.setState({ fileSelect: "", isOpenViewer: false }, () => {
      this.setState(
        { fileSelect: file, isOpenViewer: true, fileName: file.name },
        () => {
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    });
  };

  handlePreviewfromblob = (file: any) => {
    registersevice
      .getbase64blob(file)
      .then(async (result: any | null) => {
        this.setState({ fileSelect: "", isOpenViewer: false }, () => {
          this.setState(
            {
              fileSelect: "data:application/pdf;base64," + result,
              isOpenViewer: true,
              fileName: file.name,
            },
            () => {
              if (this.state.isOpenViewer) {
                setTimeout(() => {
                  const innerWidthSec = this.scrollheight.current
                    .getElement()
                    .getBoundingClientRect().height;
                  this.setState({ scrollAreaHeight: innerWidthSec });
                }, 100);
              }
            }
          );
        });
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleAllCheckbox(event) {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  }
  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    this.setState({ currentZoom: updateZoom });
  };

  hideBulkselect() {
    this.setState({
      bulkSelect: false,
      chkIds: [],
      selectedChk: [],
      isExtractOption: false,
      isMapped: "No",
      isShowAttchmntInvLstMdl: false,
    });
    if (this.state.isOpenViewer) {
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.hideBulkSelect();
      }
    }
  }

  DownloadBulkInvoice = () => {
    let chkIds = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.chkIds))
    );
    let req: any = [];
    let distinctFileNo = chkIds
      .map((data) => data.fileNo)
      .filter((value, index, self) => self.indexOf(value) === index);

    for (let i = 0; i < distinctFileNo.length; i++) {
      let reqObj: any = {};
      let filesList = this.state.savedfiles;
      let selectedFile = filesList.filter(
        (x) => x.fileUniqueno === distinctFileNo[i]
      );
      let pageNos = "";
      let movedPages = chkIds.filter((x) => x.fileNo === distinctFileNo[i]);
      for (let j = 0; j < movedPages.length; j++) {
        let pageDetArr: any = [];
        pageDetArr = movedPages[j].id.toString().split("_");
        let pgNo = Number(pageDetArr[2]) + 1;
        if (j === movedPages.length - 1) {
          pageNos = pageNos + pgNo;
        } else {
          pageNos = pageNos + pgNo + ",";
        }
      }
      if (this.footerchk.current.checked) {
        // page No is "all" when all pages are selected
        pageNos = "all";
      }
      reqObj.etype =
        this.state.pageType.toLowerCase() === "INCOMPLETEINVOICE".toLowerCase()
          ? "IncompleteInvoice"
          : "Invoices";
      reqObj.hotelId = this.state.hotelValue;
      reqObj.uploadFile = selectedFile[0].uploadFile;
      reqObj.uploadFileName = selectedFile[0].name;
      reqObj.pageNo = pageNos;
      req.push(reqObj);
    }
    if (req.length > 0) {
      // Download files when 1 0r more pages are checked
      this.downloadBulkInvoiceAttachment(req);
    } else {
      // Download (all) files when 0 pages are checked
      let filesList = this.state.savedfiles;
      for (let j = 0; j < filesList.length; j++) {
        let reqObj: any = {};
        reqObj.etype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "IncompleteInvoice"
            : "Invoices";
        reqObj.hotelId = this.state.hotelValue;
        reqObj.uploadFile = filesList[j].uploadFile;
        reqObj.uploadFileName = filesList[j].name;
        reqObj.pageNo = "all";
        req.push(reqObj);
      }
      this.downloadBulkInvoiceAttachment(req);
    }
  };

  downloadBulkInvoiceAttachment = (request) => {
    registersevice
      .DownloadBulkInvoiceAttachment(request)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          if (result[0].saveStatus.toLowerCase() === "fail") {
            Utils.toastError(result[0].message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          } else {
            toast.success("Attachment(s) successfully downloaded.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            for (let i = 0; i < result.length; i++) {
              this.downloadFileObject(
                result[i].base64String,
                result[i].filename
              );
            }
          }
        } else {
          Utils.toastError(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  downloadFileObject(base64String, filename) {
    const linkSource = `data:application/pdf;base64,${base64String}`;
    const downloadLink = document.createElement("a");
    const fileName = filename;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  extracthideBulkselect = () => {
    this.setState({ bulkSelect: false, chkIds: [], selectedChk: [] });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  };

  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    this.setState({ isExtractOption: false });
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };

  handleUpdatedFile() {
    return this.state.chkIds;
  }

  handleincompleteFile() {
    return this.state.incompleteFilesCopy;
  }

  pdfExtract = () => {
    this.setState({ isExtractionBtnClicked: true });
    let extractionStart = false;
    if (this.state.savedfiles.length === 1) {
      if (this.state.savedfiles[0].pageno === "1") {
        extractionStart = true;
      } else {
        if (this.state.chkIds.length > 0) {
          extractionStart = true;
        } else {
          if (this.state.defaultView !== "grid-view") {
            this.setState({ defaultView: "grid-view" });
          }
          if (this.state.bulkSelect !== true) {
            this.setState({ bulkSelect: true });
            for (let i = 0; i < this.state.savedfiles.length; i++) {
              this["myRef" + i].current.showBulkSelect();
            }
          } else {
            if (this.state.chkIds.length > 0) {
              extractionStart = true;
            } else {
              Utils.toastError("Please select at least one page.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
              });
              return false;
            }
          }
        }
      }
    } else {
      if (this.state.chkIds.length > 0) {
        extractionStart = true;
      } else {
        if (this.state.defaultView !== "grid-view") {
          this.setState({ defaultView: "grid-view" });
        }
        if (this.state.bulkSelect !== true) {
          this.setState({ bulkSelect: true });
          for (let i = 0; i < this.state.savedfiles.length; i++) {
            this["myRef" + i].current.showBulkSelect();
          }
        } else {
          if (this.state.chkIds.length > 0) {
            extractionStart = true;
          } else {
            Utils.toastError("Please select at least one page.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            return false;
          }
        }
      }
    }

    if (extractionStart) {
      let pagelist: any = [];
      for (let x = 0; x < this.state.chkIds.length; x++) {
        let pageItem: any = {};
        let splitchkIds = this.state.chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageno = Number(splitchkIds[2]) + 1;
        let FileWithPage = fileNo + "_" + pageno;
        pagelist.push(FileWithPage);
      }
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : storage.tenantID;
      let selectedExtractFile: any = [];
      if (this.state.chkIds.length > 0) {
        for (let x = 0; x < 1; x++) {
          let splitchkIds: any = [];
          splitchkIds = this.state.chkIds[x].id.toString().split("_");
          let fileNo = Number(splitchkIds[1]);
          let pageNo = Number(splitchkIds[2]) + 1;
          let savedFileDet = this.state.savedfiles.filter(
            (e) => e.fileUniqueno === fileNo
          );
          let item: any = {};
          item.vendorID = this.state.formData.vendorID;
          item.hotelId = this.state.formData.hotelID;
          item.uniqueNo = savedFileDet[0].uniqueNo;
          item.uploadFile = savedFileDet[0].uploadFile;
          item.fileCode = savedFileDet[0].fileCode;
          item.fileName = savedFileDet[0].name;
          item.fileUniqueNo = fileNo;
          item.pageno = pagelist.join(","); // pageNo;
          item.invoicetype =
            this.state.pageType.toLowerCase() ===
            "INCOMPLETEINVOICE".toLowerCase()
              ? "IncompleteInvoice"
              : "Invoices";
          item.tenantID = tenantID;
          item.newpageno = pageNo;
          selectedExtractFile.push(item);
        }

        this.setState(
          {
            selectedExtractFile: selectedExtractFile,
            isStateChanged: true,
            totalAmountdiff: 0.0,
            isAmountDiff: "No",
          },
          () => {
            this.getPdfTextract(selectedExtractFile[0]);
          }
        );
      } else if (this.state.isextractShow) {
        let splitchkIds: any = [];
        let item: any = {};
        item.vendorID = this.state.formData.vendorID;
        item.hotelId = this.state.formData.hotelID;
        item.uniqueNo = this.state.savedfiles[0].uniqueNo;
        item.uploadFile = this.state.savedfiles[0].uploadFile;
        item.fileCode = this.state.savedfiles[0].fileCode;
        item.fileName = this.state.savedfiles[0].name;
        item.fileUniqueNo = this.state.savedfiles[0].fileUniqueno;
        item.pageno = this.state.savedfiles[0].fileUniqueno.toString() + "_1";
        item.invoicetype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "IncompleteInvoice"
            : "Invoices";
        item.tenantID = tenantID;
        item.newpageno = 1;
        selectedExtractFile.push(item);

        this.setState(
          {
            selectedExtractFile: selectedExtractFile,
            isStateChanged: true,
            totalAmountdiff: 0.0,
            isAmountDiff: "No",
          },
          () => {
            this.getPdfTextract(selectedExtractFile[0]);
          }
        );
      }
    }

    // This condition is for after saving the maped feild that page should be display instead of first page.
    if (this.state.chkIds.length > 0) {
      this.setState({ defaultView: "doc-view" }, () => {
        setTimeout(() => {
          let containerHeight =
            this.scrollheight.current.getElement().getBoundingClientRect()
              .height / 2;
          let elementTopPos = $(
            `#sec_${this.state.chkIds[0].fileNo}`
          ).position().top;
          let elePosition =
            this.scrollheight.current.getElement().scrollTop +
            elementTopPos -
            containerHeight +
            150;
          this.setState({ firstSelctedCheckboxYPos: elePosition });
        }, 100);
      });
    }
  };

  getPdfTextract(request: any) {
    this.setState({ isSpinner: true });
    if (this.state.isAzureExtraction.toLowerCase() === "yes") {
      registersevice
        .InvoicePdfExtraction_New(request)
        .then(async (result: any | null) => {
          this.setState({ isSpinner: false });

          if (result !== null) {
            if (result[0].saveStatus === "Success") {
              this.getPdfMasterMapping(result, request, false);
            } else {
              Utils.toastError(result[0].message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
              });
            }
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    } else {
      registersevice
        .InvoicePdfExtraction(request)
        .then(async (result: any | null) => {
          this.setState({ isSpinner: false });

          if (result !== null) {
            if (result[0].saveStatus === "Success") {
              this.getPdfMasterMapping(result, request, false);
            } else {
              Utils.toastError(result[0].message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
              });
            }
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    }
  }

  getPdfMasterMapping(PdfExtractList, selectedExtractFile, isopen) {
    let request: any = {};
    let pdfList: any = {};
    let tableItemList: any = [];
    pdfList = registersevice.bindPdfTextRactData(PdfExtractList);
    let header = "";
    let tableItem = "";
    pdfList.headerItemList.forEach((element, index) => {
      if (index === 0) {
        header = element.dbName;
      } else {
        header = header + "," + element.dbName;
      }
    });
    pdfList.tableItemList.forEach((element, index) => {
      if (index === 0) {
        tableItem = element.dbName;
      } else {
        tableItem = tableItem + "," + element.dbName;
      }
    });
    tableItemList = Object.assign(
      [],
      JSON.parse(JSON.stringify(pdfList.tableItemList))
    );
    request.HeaderList = header;
    request.ItemList = tableItem;
    request.Vid = selectedExtractFile.vendorID;
    request.TenantID = selectedExtractFile.tenantID;
    request.pageCount = PdfExtractList[0].totalPages;
    registersevice
      .InvoiceMappingMasterDetails(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let mapData: any = [];
          let LinemapData: any = [];

          result.forEach((element, index) => {
            let item: any = {};
            item.id = element.id;
            item.name = element.colName;
            item.isDisabled = false;
            item.isHighlight = false;
            let mappedcolName = element.mappedCol;

            if (element.type.toString().toLowerCase() === "header") {
              let colValueList = PdfExtractList[0].invoiceJsonDetails.filter(
                (x) =>
                  x.dbName.toString().toLowerCase() ===
                  mappedcolName.toString().toLowerCase()
              );
              let colValue = "";
              if (colValueList.length > 0) {
                colValue = colValueList[0].coloumnValues;
              }

              item.mappedField =
                colValueList.length > 0 ? colValueList[0].coloumnName : "";
              item.dataPreview = colValue;
              item.dbName =
                colValueList.length > 0 ? colValueList[0].dbName : "";
              mapData.push(item);
            } else {
              let selectedFields: any = [];
              selectedFields = mappedcolName?.toString().split(",");
              if (selectedFields.length > 0) {
                let colValueList = PdfExtractList[0].invoiceSpiltDetails.filter(
                  (x) =>
                    x.dbName.toString().toLowerCase() ===
                    selectedFields[0].toString().toLowerCase()
                );
                let colValue = "";
                let chkcolValue = false;
                colValueList.forEach((element1) => {
                  if (colValueList.length > 0 && !chkcolValue) {
                    colValue = element1.coloumnValues;
                  }
                  if (element1.coloumnValues.length > 0) {
                    chkcolValue = true;
                  }
                });
                item.mappedField = mappedcolName;
                item.dataPreview = colValue;
              } else {
                item.mappedField = mappedcolName;
                item.dataPreview = "";
              }
              LinemapData.push(item);
              // Amount Due@@2,Extended Amount@@1,Net Amount@@2
              for (let i = 0; i < selectedFields.length; i++) {
                if (
                  tableItemList.filter((x) => x.dbName === selectedFields[i])
                    .length > 0
                ) {
                  for (let j = 0; j < tableItemList.length; j++) {
                    if (tableItemList[j].dbName === selectedFields[i]) {
                      tableItemList[j].status = "mapped";
                      tableItemList[j].mappedTo = element.colName;
                    }
                  }
                }
              }
            }
          });

          this.setState(
            { mapData: [], LinemapData: [], selectedTableItemList: [] },
            () => {
              this.setState(
                {
                  mapData,
                  LinemapData,
                  PdfExtractList: PdfExtractList,
                  isMapped: result[0].isMapped,
                  selectedTableItemList: tableItemList,
                },
                () => {
                  if (this.state.isMappedShow) {
                    this.setState(
                      {
                        textractMap: isopen,
                        isExtractOption: false,
                        isMappedShow: false,
                      },
                      () => {
                        if (!isopen) {
                          this.setState({
                            isMappedShow: true,
                            isMapped: "Yes",
                          });
                        }
                      }
                    );
                  } else {
                    if (
                      LinemapData.filter((x) => x.mappedField === "").length >
                        0 ||
                      mapData.filter((x) => x.mappedField === "").length > 0
                    ) {
                      this.setState(
                        { textractMap: isopen, isExtractOption: false },
                        () => {
                          if (!isopen) {
                            this.setState({
                              isMappedShow: true,
                              isMapped: "Yes",
                            });
                          }
                        }
                      );
                    }
                  }
                  this.setState({ isExtractOption: true }, () => {
                    let splitItem: any = [];
                    splitItem = registersevice.mapLineItem(
                      LinemapData,
                      PdfExtractList,
                      this.state.selectedTableItemList
                    );
                    this.invoiceMapData(splitItem, mapData, true);
                  });
                }
              );
            }
          );

          this.extracthideBulkselect();
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  }

  updateMappingFromChild = (mapData, LinemapData, tableItemList) => {
    this.setState({
      mapData,
      LinemapData,
      selectedTableItemList: tableItemList,
    });
  };

  handleBulkRotate = (type) => {
    this.handleRotate(this.state.chkIds, 0, 0, type);
  };

  handleBulkRemove = () => {
    this.handlePageRemove(this.state.chkIds, 0, 0);
  };

  handleRotate(chkIds, currentfileNo, currentPage, type) {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID;
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo = savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "IncompleteInvoice"
            : "Invoices";
        item.tenantID = tenantID;
        item.rotateType = type;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo = savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "INCOMPLETEINVOICE"
            : "INVOICES";
        item1.tenantID = tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRotation(selectedRotateFile, chkIds);
    } else {
      Utils.toastError("Please select at least one page to rotate.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }
  }

  saveRotation(request, chkIds) {
    this.setState({ isSpinner: true });
    registersevice
      .RotateInvoicePDf(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ selectedChk: chkIds }, () => {
              this.GetUploadFileList(this.state.invoiceUniqueNo, 2);
              this.GetPostToInvoice();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  }

  handlePageRemove(chkIds, currentfileNo, currentPage) {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID;
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo = savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "IncompleteInvoice"
            : "Invoices";
        item.tenantID = tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo = savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.pageType.toLowerCase() ===
          "INCOMPLETEINVOICE".toLowerCase()
            ? "INCOMPLETEINVOICE"
            : "INVOICES";
        item1.tenantID = tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRemovepage(selectedRotateFile, chkIds);
    } else {
      Utils.toastError("Please select at least one page to remove.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }
  }

  saveRemovepage(request, chkIds) {
    this.setState({ isSpinner: true });
    registersevice
      .RemoveInvoicePDf(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ selectedChk: [chkIds], isSave: true }, () => {
              this.GetUploadFileList(this.state.invoiceUniqueNo, 2);
              this.GetPostToInvoice();
              this.hideBulkselect();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  }

  saveSplitFile(splitrequest, pageno, type) {
    this.setState({ isSpinner: true });
    splitrequest.hotelID = this.state.hotelValue;
    registersevice
      .saveSplitFile(splitrequest)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isSave: true });
            this.GetUploadFileList(this.state.invoiceUniqueNo, 2);
            this.GetPostToInvoice();
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  }

  isModalOpen = (type: any) => {
    this.setState({ modalOpen: type });
  };

  rowEvents = {
    onClick: (e: any, newRow: any, rowIndex: any) => {
      let row: any = {};
      row.hotelid = this.state.formData.hotelID;
      row.etype = "Invoice";
      row.vendor = this.state.formData.vendorName;
      row.lettercode = this.state.hotelName;
      row.vid = this.state.formData.vendorID;
      row.oprID = this.state.formData.oprID;
      row.uniqueno = this.state.formData.uniqueno;
      row.ckno =
        this.state.formData.paymenttype.toLowerCase() === "Check".toLowerCase()
          ? this.state.formData.checkNo
          : this.state.formData.paymenttype.toLowerCase() ===
            "Digital ACH".toLowerCase()
          ? "ACH"
          : this.state.formData.paymenttype;
      row.series = this.state.formData.series;
      row.postFix = this.state.formData.postFix;
      row.groupID = this.state.formData.groupID;
      this.props.OpenInvoiceSlideOut(e, row, rowIndex, "main");
    },
  };

  showHideChangeLogModal = () => {
    this.setState({
      showChangeLogModal: !this.state.showChangeLogModal,
    });
  };

  showUnApproveModal = () => {
    this.setState({ isUnapproveModal: true });
  };

  hideUnApprovalModal = (value) => {
    if (value) {
      this.props.hideSlideOut(value);
    }
    this.setState({ isUnapproveModal: false });
  };

  closeTextract = () => {
    this.setState(
      { isMappedShow: false, textractMap: false, defaultView: "doc-view" },
      () => {
        $(".scroll-area").animate(
          {
            scrollTop: this.state.firstSelctedCheckboxYPos,
          },
          500
        );
      }
    );
  };

  adjustMapping = () => {
    this.setState({ isMappedShow: true, textractMap: true }, () => {});
  };

  invoiceMapData = (tabData, headers, isOpen) => {
    this.setState({
      bulkSelectedSplitRows: [],
      showAssignCOABtn: false,
      defaultEntry: "all-entry",
      isAllIncomplete: true,
    });
    let transTotal = "0.00";
    let formData = { ...this.state.formData };
    let splitDatadetails: any = [];
    let reg =
      /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$/;
    let defaultaccountingPeriod = formData.accPeriod;
    let accPeriodListItems = this.state.accPeriodList;
    headers.forEach((element) => {
      if (element.mappedField !== null || element.mappedField !== undefined) {
        if (
          element.name.toString().toLowerCase() ===
          "Invoice Number".toString().toLowerCase()
        ) {
          formData.invoiceno = element.dataPreview;
        }
        if (
          element.name.toString().toLowerCase() ===
          "Invoice Date".toString().toLowerCase()
        ) {
          let today = new Date(
            isNaN(element.dataPreview) ? element.dataPreview : ""
          );
          if (today.toString() === "Invalid Date") {
            today = Utils.getHotalCurrentDate();
          }
          if (today.toString() !== "Invalid Date") {
            let dateNew =
              today.getMonth() +
              1 +
              "/" +
              today.getDate() +
              "/" +
              today.getFullYear().toString().substring(2, 4);
            if (reg.test(dateNew)) {
              formData.transcationDate = dateNew;
            }

            let addDays = new Date(dateNew);
            addDays.setDate(addDays.getDate() + Number(this.state.vendorDays));
            let duedate =
              addDays.getMonth() +
              1 +
              "/" +
              addDays.getDate() +
              "/" +
              addDays.getFullYear();

            formData.dueDate = duedate;
            if (this.state.formData.uniqueno === 0) {
              let accperList = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.accPeriodList))
              );

              let accountingPeriodData = accperList.filter(
                (e) =>
                  new Date(e.id).getFullYear().toString().substring(2, 4) ===
                    today.getFullYear().toString().substring(2, 4) &&
                  new Date(e.id).getMonth() + 1 === today.getMonth() + 1
              );
              if (accountingPeriodData.length > 0) {
                formData.accPeriod = accountingPeriodData[0].id;
                defaultaccountingPeriod = accountingPeriodData[0].id;
              }
            }
          }
        }
        if (
          element.name.toString().toLowerCase() ===
          "Due Date".toString().toLowerCase()
        ) {
          let today = new Date(
            isNaN(element.dataPreview) ? element.dataPreview : ""
          );
          if (today.toString() !== "Invalid Date") {
            let dateNew =
              today.getMonth() +
              1 +
              "/" +
              today.getDate() +
              "/" +
              today.getFullYear().toString().substring(2, 4);
            if (reg.test(dateNew)) {
              formData.dueDate = dateNew;
            }
          }
        }
        if (
          element.name.toString().toLowerCase() ===
          "Payment Date".toString().toLowerCase()
        ) {
          let today = new Date(
            isNaN(element.dataPreview) ? element.dataPreview : ""
          );
          if (today.toString() !== "Invalid Date") {
            let dateNew =
              today.getMonth() +
              1 +
              "/" +
              today.getDate() +
              "/" +
              today.getFullYear().toString().substring(2, 4);
            if (reg.test(dateNew)) {
              formData.gDate = dateNew;
            }
          }
        }
        if (
          element.name.toString().toLowerCase() ===
          "Accounting Period".toString().toLowerCase()
        ) {
          let accPrd = accPeriodListItems.filter(
            (x) =>
              new Date(x.id).getFullYear() ===
                new Date(element.dataPreview).getFullYear() &&
              new Date(x.id).getMonth() ===
                new Date(element.dataPreview).getMonth()
          );
          if (accPrd.length > 0) {
            formData.accPeriod = accPrd[0].id;
            defaultaccountingPeriod = accPrd[0].id;
          }
        }
        if (
          element.name.toString().toLowerCase() ===
          "Notes".toString().toLowerCase()
        ) {
          let notes = "";
          notes =
            element.dataPreview.length <= 99
              ? element.dataPreview
              : element.dataPreview.slice(0, 99);
          formData.internalNotes = notes;
        }
        if (
          element.name.toString().toLowerCase() ===
          "Total Amount".toString().toLowerCase()
        ) {
          transTotal = Utils.removeInvaildCharFromAmount(element.dataPreview);
          formData.transactionTotal = Utils.currencyFormat(transTotal);
        }
      }
    });
    this.setState({ accPeriodList: [], isMapped: "No" }, () => {
      this.setState(
        {
          formData,
          textractMap: false,
          defaultaccountingPeriod,
          accPeriodList: accPeriodListItems,
          isMapped: "Yes",
        },
        () => {
          this.notesTextAreaRef.current.style.height = "0px";
          let scrollHeight = this.notesTextAreaRef.current.scrollHeight;
          this.notesTextAreaRef.current.style.height = scrollHeight + "px";
        }
      );
    });

    if (tabData.length > 0) {
      tabData.forEach((element, index) => {
        let description = "";
        description =
          element.Description.length <= 99
            ? element.Description
            : element.Description.slice(0, 99);
        let splitlistItem: any = {};
        splitlistItem.rno = index;
        splitlistItem.lettercode = this.state.hotelName;
        splitlistItem.spiltHoteID = this.state.hotelValue;
        splitlistItem.splitoprID = this.state.hotelValue;
        splitlistItem.defaultEhid = this.state.hotelName;
        splitlistItem.subVendorlist = this.state.subVendorList.filter(
          (x) => x.hid === this.state.hotelValue
        );
        splitlistItem.projectlist = this.state.projectList.filter(
          (x) => x.hid === this.state.hotelValue
        );
        splitlistItem.coa =
          this.state.splitData[index]?.coa === undefined
            ? ""
            : this.state.splitData[index]?.coa === null
            ? ""
            : this.state.splitData[index]?.coa; //"";
        splitlistItem.coaName =
          this.state.splitData[index]?.coaName === undefined
            ? ""
            : this.state.splitData[index]?.coaName === null
            ? ""
            : this.state.splitData[index]?.coaName; //"";
        splitlistItem.defaultCoa =
          this.state.splitData[index]?.defaultCoa === undefined
            ? []
            : this.state.splitData[index]?.defaultCoa === null
            ? []
            : this.state.splitData[index]?.defaultCoa; //"";
        splitlistItem.description = description;

        // Added to Auto Populate COA if a Desc is found on Desc-COA rule on DB
        if (element?.Description !== "" && element?.Description !== null) {
          if (
            this.state.descCOAMapping.filter(
              (x) =>
                x.label.trim().toLowerCase() ===
                description.trim().toLowerCase()
            ).length > 0
          ) {
            const index = this.state.descCOAMapping.findIndex(
              (x) =>
                x.label.trim().toLowerCase() ===
                description.trim().toLowerCase()
            );
            if (
              this.state.coaList.filter(
                (x) => x.id === this.state.descCOAMapping[index].coa
              ).length > 0
            ) {
              const coaListIndex = this.state.coaList.findIndex(
                (x) => x.id === this.state.descCOAMapping[index].coa
              );
              splitlistItem.coa = this.state.coaList[coaListIndex].id;
              splitlistItem.coaName = this.state.coaList[coaListIndex].coAname;
              let defaultCoaArray: any = [];
              defaultCoaArray.push(this.state.coaList[coaListIndex]);
              splitlistItem.defaultCoa = defaultCoaArray;
            }
          }
          // }
        }

        splitlistItem.amount = Utils.currencyFormatWithOutdoller(
          Utils.removeInvaildCharFromAmount(element.Amount.trim()) === "."
            ? "0.00"
            : Utils.removeInvaildCharFromAmount(element.Amount.trim())
        );
        splitlistItem.srno = index;
        splitlistItem.clMonth = "";
        splitlistItem.clYear = "";
        splitlistItem.subVID = "0";
        splitlistItem.subVendor = "";
        splitlistItem.pID = "0";
        splitlistItem.isCOAPer = "Yes";
        splitlistItem.projectName = "";
        splitlistItem.defaultVendor = "Select Sub Vendor";
        splitlistItem.defaultProject = "Select Project";

        splitDatadetails.push(splitlistItem);
      });

      splitDatadetails = splitDatadetails.filter(
        (d) => d.description.trim().length > 0 || d.amount !== "0.00"
      );
      splitDatadetails = splitDatadetails.filter(
        (d) => d.description.trim().length > 0 || d.amount !== ""
      );
      if (splitDatadetails.length === 0) {
        if (isOpen) {
          Utils.toastError("No Split data found.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          });
        }
        splitDatadetails = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.splitData))
        );
      }
      const grandAmount = tabData.reduce(
        (total, currentValue) =>
          (total =
            Number(total) +
            Number(
              Utils.removeInvaildCharFromAmount(currentValue.Amount) === "."
                ? "0.00"
                : Utils.removeInvaildCharFromAmount(currentValue.Amount)
            )),
        0
      );
      let diff = "";
      diff = (Number(transTotal) - Number(grandAmount)).toFixed(2);
      let isAmountDiff = diff === "0.00" ? "No" : diff === "0" ? "No" : "Yes";
      this.setState({ splitData: [] }, () => {
        this.setState(
          {
            splitData: splitDatadetails,
            textractMap: false,
            defaultView: "doc-view",
            totalAmount: Utils.currencyFormat(grandAmount),
            totalAmountdiff: Utils.currencyFormat(diff),
            isAmountDiff: isAmountDiff,
          },
          () => {
            if (!isOpen) {
              let selectedExtractFile: any = [];
              selectedExtractFile = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.selectedExtractFile))
              );
              this.getPdfMasterMapping(
                this.state.PdfExtractList,
                selectedExtractFile[0],
                isOpen
              );
            }
            $(".scroll-area").animate(
              {
                scrollTop: this.state.firstSelctedCheckboxYPos,
              },
              500
            );
          }
        );
      });
    } else {
      Utils.toastError("No Split data found.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
    }
  };

  openFileViewer = (row: any) => {
    let uniqueNo = row.uniqueNo;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID;
    let etype = "Invoice";
    window.open(
      "/MediaViewer?Uniqueno=" +
        btoa(uniqueNo) +
        "&tenantID=" +
        btoa(tenantID) +
        "&Etype=" +
        btoa(etype),
      "_blank"
    );
  };

  showRules = () => {
    if (this.state.rulesArray.length === 1) {
      this.setState({ isApproveClicked: true},()=>{
        this.invoiceToApprove();
      });
    } else {
      this.state.rulesArray.forEach((item) => {
        if (item.appLavel === 1) {
          item.isCheck = true;
        }
      });

      this.setState({ showRuleModal: true });
    }
  };

  hideApprovalModal = () => {
    this.setState({ showRuleModal: false, isApproveClicked: false, });
    $("#btntemp").click();
  };

  approvalcheckChange = (event, row) => {
    let { rulesArray } = this.state;
    let checked = event.target.checked;
    let index = rulesArray.indexOf(row);
    row.isCheck = checked;
    rulesArray[index] = row;
    this.setState({ rulesArray });
  };
  toggleClass = () => {
    let currentState = this.state.activeToggle;
    this.setState({ activeToggle: !currentState });
  };

  loadFileFromMailBody = () => {
    let request: any = {};
    request.entryType =
      this.state.pageType === "Invoice" ? "Invoices" : "INCOMPLETEINVOICE";
    request.incompleteUniqueno =
      this.state.pageType === "Invoice" ? 0 : this.state.invoiceUniqueNo;
    request.uniqueno =
      this.state.pageType === "Invoice" ? this.state.invoiceUniqueNo : 0;
    request.hotelID = this.state.formData.hotelID;
    request.mailinboxID = this.state.emailPdfID;
    request.htmlbodyNew = "";

    this.setState({ isSpinner: true });
    registersevice
      .SaveinvoiceMailBox(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isHtmlBody: "NotShow" });
            this.GetUploadFileList(this.state.invoiceUniqueNo, 1);
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  hidePaymentModal = () => {
    this.setState({ paymentModal: false });
  };
  hideBulkSelectCoaModal = () => {
    this.setState({ showBulkSelectCoa: false });
  };
  showBulkSelectCoaModal = () => {
    this.setState({ bulkSelectedCOA: [] }, () => {
      this.setState({ showBulkSelectCoa: true });
    });
  };

  deleteBulkSelectedSplitRows = () => {
    let splitData: any = [];
    let bulkSelectedSplitRows = this.state.bulkSelectedSplitRows;
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );

    if (
      splitData.length === 1 ||
      splitData.length === bulkSelectedSplitRows.length
    ) {
      Utils.toastError(
        "All Split rows cannot be deleted. Atleast 1 row is mandatory.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "BulkDeleteRow 1",
        }
      );
    } else {
      bulkSelectedSplitRows.forEach((rno) => {
        splitData = splitData.filter((item) => item.rno !== rno);
      });
      this.setState(
        { splitData: [], bulkSelectedSplitRows: [], showAssignCOABtn: false },
        () => {
          this.setState({ splitData }, () => {
            this.validateIncompleteRows();
            this.addTotalAmount(this.state.splitData);
          });
        }
      );
    }
  };

  handleBulkSelectedCoa = (selected) => {
    this.setState({ bulkSelectedCOA: selected.length > 0 ? selected : [] });
  };

  saveBulkSelectedCOA = () => {
    let splitData: any = [];
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let bulkSelectedSplitRows = this.state.bulkSelectedSplitRows;
    let bulkSelectedCOA = this.state.bulkSelectedCOA;

    bulkSelectedSplitRows.forEach((rno) => {
      if (splitData.filter((x) => x.rno === rno).length > 0) {
        const index = splitData.findIndex((x) => x.rno === rno);
        if (bulkSelectedCOA.length > 0) {
          if (bulkSelectedCOA[0].id > 0) {
            splitData[index].coaName = bulkSelectedCOA[0].coAname;
            splitData[index].coa = bulkSelectedCOA[0].id;
            splitData[index].defaultCoa = bulkSelectedCOA;
            splitData[index].isSplitChecked = 0;
          } else {
            splitData[index].coaName = "";
            splitData[index].coa = "";
            splitData[index].defaultCoa = bulkSelectedCOA;
            splitData[index].isSplitChecked = 0;
          }
        } else {
          splitData[index].coaName = "";
          splitData[index].coa = "";
          splitData[index].defaultCoa = bulkSelectedCOA;
          splitData[index].isSplitChecked = 0;
        }
      }
    });
    this.setState(
      {
        splitData,
        bulkSelectedSplitRows: [],
        showAssignCOABtn: false,
        isStateChanged: true,
        showBulkSelectCoa: false,
      },
      () => {
        this.validateIncompleteRows();
      }
    );
  };

  markAsPaidUnpaid = (isPaid: any) => {
    if (
      this.state.defaultaccountType === "Select Account" &&
      isPaid === "Paid"
    ) {
      if (
        this.state.formData.paymenttype.toString().toLowerCase() ===
        "Credit Card".toLowerCase()
      ) {
        Utils.toastError(
          "There are no accounts available for the selected payment type. Please select a different Payment method.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          }
        );
      } else if (
        this.state.formData.paymenttype.toString().toLowerCase() ===
        "Digital ACH".toLowerCase()
      ) {
        Utils.toastError(
          "There are no accounts available for the selected payment type. Please select a different Payment method.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          }
        );
      } else if (
        this.state.formData.paymenttype.toString().toLowerCase() ===
        "ACH".toLowerCase()
      ) {
        Utils.toastError(
          "There are no accounts available for the selected payment type. Please select a different Payment method.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          }
        );
      }

      return false;
    }
    let mOprID = "";
    if (
      this.state.formData.paymenttype.toString().toLowerCase() ===
      "Credit Card".toLowerCase()
    ) {
      mOprID = this.state.formData.cardUniqueno;
    } else {
      mOprID = this.state.formData.oprID;
    }

    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : storage.tenantID;
    let request: any = {};
    request.uniqueno = this.state.formData.uniqueno;
    request.incompleteUniqueno = this.state.formData.incompleteUniqueno;
    request.oprID = mOprID;
    request.cardUniqueno = mOprID;
    request.paymenttype = this.state.formData.paymenttype;
    request.gDate = this.state.formData.gDate;
    request.tenantid = tenantID;
    request.hotelID = this.state.hotelValue;
    request.paymentNotes = this.state.formData.paymentNotes
      .trim()
      .replace("'", "");
    request.isPaid = isPaid;
    request.entryType =
      this.state.formData.incompleteUniqueno > 0 &&
      this.state.formData.uniqueno === 0
        ? "INCOMPLETEINVOICE"
        : "INVOICES";

    if (
      (this.state.formData.uniqueno === 0 ||
        (this.state.formData.uniqueno > 0 &&
          this.state.formData.actionType === "copy")) &&
      isPaid === "Paid"
    ) {
      this.setState({ isMarkAsPaidClicked: true }, () => {
        this.saveInvoice("INCOMPLETEINVOICE", false);
        this.hidePaymentModal();
      });
    } else {
      registersevice
        .markAsPaidUnpaid(request)
        .then(async (result: any | null) => {
          this.setState({ isSpinner: false, isPaidClick: true });
          if (result !== null) {
            if (result.saveStatus === "Success") {
              if (isPaid === "Unpaid") {
                this.setState({ associatedPayments: [], isPostTrx: "no" });
              }
              if (isPaid === "Paid") {
                let associatedPayments: any = [];
                let elemnt: any = {};
                elemnt.date = this.state.formData.gDate;
                elemnt.type =
                  this.state.defaultpaymentType.toLowerCase() === "ach"
                    ? "M-ACH"
                    : this.state.defaultpaymentType;
                elemnt.account = this.state.defaultaccountType;
                elemnt.amount = Utils.removecurrencyFormat(
                  this.state.formData.transactionTotal
                );
                elemnt.paymentNotes = this.state.formData.paymentNotes.trim();
                associatedPayments.push(elemnt);
                let ptype = [...this.state.paymentType];
                this.setState({ associatedPayments, paymentType: [] }, () => {
                  this.setState({ paymentType: ptype });
                });
              }
              let formData = { ...this.state.formData };
              let invoicePaid = { ...this.state.invoicePaid };

              formData.isPaid = isPaid;
              invoicePaid.paymentType = this.state.defaultpaymentType;
              this.setState({
                paymentModal: false,
                formData,
                invoicePaid,
                isPaidDB: formData.isPaid,
              });
              if (this.state.saveAction === "Payment") {
                setTimeout(() => {
                  this.props.hideSlideOut(true);
                }, 0);
              }
            } else {
              Utils.toastError(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "InvoiceSlideout",
              });
            }
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    }
  };

  showIncompleteSplitColumns = (type) => {
    let splitData: any = [];
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );

    splitData.forEach((element, index) => {
      if (type === "incomplete-entry") {
        if (
          element.coa.length !== 0 &&
          element.spiltHoteID !== "" &&
          element.amount.length !== 0
        ) {
          element.isHideRow = 1;
        } else {
          element.isHideRow = 0;
        }
      } else {
        element.isHideRow = 0;
      }
    });

    this.setState({
      splitData,
      bulkSelectedSplitRows: [],
      showAssignCOABtn: false,
    });
  };

  hideRowClass = (row, rowIndex) => {
    let classes = "";

    if (row?.isHideRow === 1) {
      classes = "hidesplitrow";
    }
    return classes;
  };

  handleOnSelect = (row, isChecked) => {
    let bulkSelectedSplitRows = this.state.bulkSelectedSplitRows;
    if (isChecked) {
      bulkSelectedSplitRows.push(row.rno);
    } else {
      bulkSelectedSplitRows = bulkSelectedSplitRows.filter(
        (num) => num !== row.rno
      );
    }
    this.setState({
      bulkSelectedSplitRows,
      showAssignCOABtn: bulkSelectedSplitRows.length > 0 ? true : false,
    });
  };
  handleOnSelectAll = (isChecked, rows) => {
    let bulkSelectedSplitRows = this.state.bulkSelectedSplitRows;
    let ids = rows.map((r) => r.rno);
    if (isChecked) {
      if (this.state.defaultEntry === "incomplete-entry") {
        let incompleteRows = rows.filter(
          (r) =>
            r.coa.length === 0 || r.spiltHoteID === "" || r.amount.length === 0
        );
        let incompleteRowIds = incompleteRows.map((r) => r.rno);

        bulkSelectedSplitRows = incompleteRowIds;
      } else {
        bulkSelectedSplitRows = ids;
      }
    } else {
      bulkSelectedSplitRows = [];
    }
    this.setState({
      bulkSelectedSplitRows,
      showAssignCOABtn: bulkSelectedSplitRows.length > 0 ? true : false,
    });
  };

  validateIncompleteRows = () => {
    if (this.state.defaultEntry === "incomplete-entry") {
      let incompleteRows = this.state.splitData.filter(
        (r) =>
          r.coa.length === 0 || r.spiltHoteID === "" || r.amount.length === 0
      );
      if (incompleteRows.length === 0) {
        this.setState({ defaultEntry: "all-entry" }, () => {
          this.showIncompleteSplitColumns(this.state.defaultEntry);
        });
      }
    }
  };

  handlePaymentSave = () => {
    this.setState({ isDisabled: true });
    let { formData } = this.state;
    let request: any = {};
    request.vid = formData.vendorID;
    request.PaymentType = formData.paymenttype;
    registersevice
      .UpdateVendorDefaultPaymentMethod(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let isSuccess =
            result.result[0].result.toString().toLocaleLowerCase() ===
            "success";
          if (isSuccess) {
            this.setState({
              defaultpaymentType2: formData.paymenttype,
              defaultpaymentType: formData.paymenttype,
              defaultpaymentType1: formData.paymenttype,
              isDisabled: false,
            });
          } else {
            Utils.toastError("Something went wrong.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isDisabled: false });
          }
          resolve();
        } else {
          Utils.toastError("Something went wrong.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "InvoiceSlideout",
          });
          this.setState({ isDisabled: false });
        }
      })
      .catch((error) => {
        this.setState({ isDisabled: false });
        reject();
      });
  };

  handleMoveAttachmentInvoiceListModal = (type) => {
    const incompleteFiles = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.incompleteFilesCopy))
    );
    this.setState({
      isShowAttchmntInvLstMdl: type === "show" ? true : false,
      filterInvoiceInput: "",
      incompleteFiles,
    });
  };
  handleMovedropDown(type) {
    this.setState({ isShowAttchmntInvLstMdl: false });
    $("#footerMoveList").click();
  }

  moveAttachment = (type, items) => {
    let chkIds = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.chkIds))
    );
    let req: any = [];
    let distinctFileNo = chkIds
      .map((data) => data.fileNo)
      .filter((value, index, self) => self.indexOf(value) === index);

    for (let i = 0; i < distinctFileNo.length; i++) {
      let reqObj: any = {};
      let filesList = this.state.savedfiles;
      let selectedFile = filesList.filter(
        (x) => x.fileUniqueno === distinctFileNo[i]
      );
      let pageNos = "";
      let movedPages = chkIds.filter((x) => x.fileNo === distinctFileNo[i]);
      for (let j = 0; j < movedPages.length; j++) {
        let pageDetArr: any = [];
        pageDetArr = movedPages[j].id.toString().split("_");
        let pgNo = Number(pageDetArr[2]) + 1;
        if (j === movedPages.length - 1) {
          pageNos = pageNos + pgNo;
        } else {
          pageNos = pageNos + pgNo + ",";
        }
      }
      reqObj.etype = "IncompleteInvoice";
      reqObj.hotelId = this.state.hotelValue;
      reqObj.fileUniqueno = distinctFileNo[i];
      reqObj.uploadFile = selectedFile[0].uploadFile;
      reqObj.methodType = type;
      reqObj.pageNo = pageNos;
      reqObj.uniqueno = type === "MoveToExistingInvoice" ? items.uniqueno : 0;
      req.push(reqObj);
    }
    if (req.length > 0) {
      this.moveAttachToNewFile(req, type);
    }
  };

  moveAttachToNewFile = (request, type) => {
    let msg = "";
    if (this.state.chkIds.length > 1) {
      msg = "Invoice Pages Moved Successfully.";
    } else {
      msg = "Invoice Page Moved Successfully.";
    }
    this.setState({ isSpinner: true });
    registersevice
      .MoveToNewInvoice(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            toast.success(msg, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
            this.setState({ isSave: true });
            this.GetUploadFileList(this.state.invoiceUniqueNo, 2);
            this.GetPostToInvoice();
            this.hideBulkselect();
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "InvoiceSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  handleFilterInvoiceChange = (e: any) => {
    const newincompleteFile = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.incompleteFilesCopy))
    );
    const updatedList = newincompleteFile.filter((item: any) => {
      return (
        (
          item.createDate.toLowerCase() +
          item.userName.toLowerCase() +
          item.vendor.toLowerCase()
        ).indexOf(e.target.value.toLowerCase()) > -1
      );
    });
    this.setState({
      incompleteFiles: updatedList,
      filterInvoiceInput: e.target.value,
    });
  };

  showAttachmentRemoveConfirmation = () => {
    confirmAlert({
      title: "Delete Attachment Pages",
      message: "Deleting pages is permanent. Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.handleBulkRemove(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  postTransaction = () => {
    this.setState({ isPostTrx: "yes" }, () => {
      this.saveInvoice("INVOICES", false);
    });
  };

  handleReviewStatus = (type) => {
    let commentModalTitle = "";
    switch (type) {
      case "Flag for Review": {
        commentModalTitle = "Flag for Review";
        break;
      }
      case "Needs Review": {
        commentModalTitle = "Change Status to Needs Review";
        break;
      }
      case "Reviewed": {
        commentModalTitle = "Change Status to Reviewed";
        break;
      }
      case "Review Complete": {
        commentModalTitle = "Change Status to Review Complete";
        break;
      }
      default: {
        break;
      }
    }
    this.setState({ commentModalTitle, reviewStatus: type }, () => {
      this.setState({ showCommentModal: true });
    });
  };

  closeCommentModal = (isUpdate) => {
    // if (isUpdate) {
    //   this.setState({ showReviewBanner: true });
    // }
    this.setState({ showCommentModal: false });
  };

  addReviewComment = (mentionData: any) => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userName = storage.userName;
    let reviewstatus = this.state.reviewStatus;
    let currentFlagName = this.state.statusTypeList.filter(
      (x) => x.eventName.toLowerCase() === reviewstatus.toLowerCase()
    )[0].name;
    let reviewCurrentDescription = currentFlagName + " by " + userName;

    // if (reviewstatus.toLowerCase() === "markforreview") {
    //   reviewstatus = "Review";
    // }
    this.ChildComment?.current.addReviewComment(reviewstatus, mentionData);
    this.closeCommentModal(true);
    this.setState({ reviewCurrentDescription }, () => {
      this.addReviewStatus();
      this.ChildComment?.current.addReviewStatus(this.state.reviewStatus);
    });
  };

  addReviewStatus = () => {
    debugger;
    let statusTypeList: any[] = [
      { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
      { id: 1, name: "Needs Review", eventName: "Needs Review" },
      { id: 2, name: "Reviewed", eventName: "Reviewed" },
      { id: 3, name: "Review Complete", eventName: "Review Complete" },
    ];

    let muniqueno =
      this.state.pageType === "Invoice"
        ? this.state.formData.uniqueno
        : this.state.formData.incompleteUniqueno;
    if (this.state.invoiceUniqueNo > 0) {
      muniqueno = this.state.invoiceUniqueNo;
    }
    if (this.state.formData.actionType === "copy") {
      muniqueno = 0;
    }

    let isShowBanner = false;
    let isReview = false;
    if (this.state.reviewStatus.length > 0) {
      isShowBanner = true;
    }
    if (
      (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
      (this.state.reviewStatus === "Flag for Review" ||
        this.state.reviewStatus === "Needs Review")
    ) {
      isReview = true;
    }

    if (
      (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
      this.state.reviewStatus === "Review Complete" &&
      muniqueno > 0
    ) {
      isShowBanner = false;
      isReview = false;
    }

    let statusList: any[] = [];
    statusTypeList.forEach((element, index) => {
      if (
        element.eventName === "Flag for Review" &&
        this.state.canFlag === "Yes" &&
        (this.state.reviewStatus === "" ||
          this.state.reviewStatus === "Review Complete")
      ) {
        statusList.push(element);
      }
      if (
        element.eventName === "Needs Review" &&
        this.state.canFlag === "Yes" &&
        this.state.reviewStatus === "Reviewed" &&
        muniqueno > 0
      ) {
        statusList.push(element);
      }
      if (
        element.eventName === "Reviewed" &&
        this.state.canReview === "Yes" &&
        (this.state.reviewStatus === "Flag for Review" ||
          this.state.reviewStatus === "Needs Review") &&
        muniqueno > 0
      ) {
        statusList.push(element);
      }
      if (
        element.eventName === "Review Complete" &&
        this.state.canFlag === "Yes" &&
        (this.state.reviewStatus === "Flag for Review" ||
          this.state.reviewStatus === "Needs Review" ||
          this.state.reviewStatus === "Reviewed") &&
        muniqueno > 0
      ) {
        statusList.push(element);
      }
    });

    this.setState(
      {
        statusTypeList: [],
        showReviewBanner: isShowBanner,
        isReviewed: isReview,
        selectedReviewStatus: this.state.reviewStatus,
      },
      () => {
        this.setState({ statusTypeList: statusList });
      }
    );
  };

  resetReviewStatus = () => {
    let statusTypeList: any[] = [
      { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
      { id: 1, name: "Needs Review", eventName: "Needs Review" },
      { id: 2, name: "Reviewed", eventName: "Reviewed" },
      { id: 3, name: "Review Complete", eventName: "Review Complete" },
    ];
    this.setState(
      {
        statusTypeList: [],
        isReviewed: false,
        showReviewBanner: false,
        showCommentModal: false,
        commentModalTitle: "",
        reviewStatus: "Flag for Review",
        selectedReviewStatus: "",
        reviewCurrentDescription: "",
        isComment: false,
      },
      () => {
        this.setState({ statusTypeList: statusTypeList, isComment: true });
      }
    );
  };

  showbanner = (status) => {
    this.setState({ reviewStatus: status }, () => {
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let userName = storage.userName;
      let reviewstatus = this.state.reviewStatus;
      let currentFlagName = this.state.statusTypeList.filter(
        (x) => x.eventName.toLowerCase() === reviewstatus.toLowerCase()
      )[0].name;
      let reviewCurrentDescription = currentFlagName + " by " + userName;

      let isReview = false;
      if (
        (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
        (this.state.reviewStatus === "Flag for Review" ||
          this.state.reviewStatus === "Needs Review")
      ) {
        isReview = true;
      }

      this.setState({ reviewCurrentDescription, isReviewed: isReview }, () => {
        this.addReviewStatus();
      });
    });
  };

  isCheckReviewBanner = (request, isCopy) => {
    confirmAlert({
      title: "Post Invoice",
      message:
        "This invoice has been flagged. Are you sure you want to post without changing the status?",
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            this.handleDuplicateInvoiceOnVendorChange(request, isCopy),
        },
        {
          label: "No",
          onClick: () => {
            this.setState({ isSaveSpinner: false });
            reject();
          },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  getReviewPermissions = (hidValue, type) => {
    let request: any = {};
    request.HotelId = hidValue;
    registersevice
      .GetReviewPermissions(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            this.setState(
              {
                canReview: result[0].canReview,
                canFlag: result[0].canFlag,
              },
              () => {
                if (type === "move") {
                  this.setState({ isComment: false }, () => {
                    if (
                      this.state.htmlcomment.length > 0 &&
                      this.state.htmlcomment[0].currentStatus.length > 0
                    ) {
                      this.addReviewStatus();
                    }
                    this.setState({ isComment: true });
                  });
                } else {
                  this.setState({ isComment: false }, () => {
                    this.setState({ isComment: true });
                  });
                }
              }
            );
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  onChangeMarkAsPaidtoggle = (event) => {
    if (event.target.checked) {
      let formData = { ...this.state.formData };
      formData.isPaid = "Paid";
      this.setState({ formData, isStateChanged: true }, () => {
        this.handleSelect("paid");
      });
    } else {
      if (this.state.isPaidDB.toLowerCase() === "paid") {
        this.handleSelect("unpaid");
      } else {
        let formData = { ...this.state.formData };
        formData.isPaid = "Unpaid";
        this.setState({ formData }, () => {
          // this.setState({ associatedPayments: [], isPostTrx: "no", });
        });
      }
    }
  };

  showTypeChangeAlert = (control: any, id: any) => {
    if (this.state.formData.paymenttype !== id) {
      if (
        this.state.isPaidDB.toLowerCase() === "paid" &&
        this.state.isShowTypeChangeAlert
      ) {
        confirmAlert({
          title: "Unsaved confirmation",
          message:
            "This invoice is already marked as paid. Do you want to mark as unpaid to change the vendor / account type?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.handleSelectedItem(control, id),
            },
            {
              label: "No",
              onClick: () => {
                let paymentType = this.state.paymentType;
                this.setState({ paymentType: [] }, () => {
                  this.setState({ paymentType: paymentType });
                });
                reject();
              },
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.handleSelectedItem(control, id);
      }
    }
  };

  showVendorChangeAlert = (e: any) => {
    let paymentType1: any = [];
    paymentType1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );

    let isStateChanged = true;
    if (e.length > 0) {
      if (this.state.oldVendorId !== e[0].vid) {
        if (
          this.state.isPaidDB.toLowerCase() === "paid" &&
          this.state.isShowTypeChangeAlert
        ) {
          confirmAlert({
            title: "Unsaved confirmation",
            message:
              "This invoice is already marked as paid. Do you want to mark as unpaid to change the vendor / account type?",
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  this.setState({ isShowTypeChangeAlert: false });
                  this.handleVendorChange(e);
                },
              },
              {
                label: "No",
                onClick: () => {
                  debugger;
                  let vendorSelected = Object.assign(
                    [],
                    JSON.parse(JSON.stringify(this.state.vendorSelectedDB))
                  );
                  let requestlist = { ...this.state.requestlist };
                  let formData = { ...this.state.formData };
                  let hotelValueCopy = this.state.hotelValue;
                  if (vendorSelected.length > 0) {
                    requestlist.hotelID = this.state.hotelValue;
                    requestlist.oprID = formData.oprID;
                    requestlist.vid = vendorSelected[0]?.id;

                    formData.vendorID = vendorSelected[0].id;
                    formData.vendorName = vendorSelected[0].vendorName;
                    formData.vendorContract = vendorSelected[0].accountNo;
                    formData.aid = vendorSelected[0].aid;
                    formData.saletax = vendorSelected[0].salestax;
                  }

                  this.setState(
                    {
                      requestlist,
                      formData,
                      vendorSelected,
                      isvendorShow: false,
                    },
                    () => {
                      this.setState({ isvendorShow: true });
                      if (vendorSelected[0].vendorName.length > 0) {
                        this.VendorSearchlistWithKey(
                          vendorSelected[0].vendorName,
                          this.state.hotelValue
                        );
                      }
                      // this.setState({ hotelValue: hotelValueCopy });
                    }
                  );
                  reject();
                },
              },
            ],
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        } else {
          this.handleVendorChange(e);
        }
      } else {
        this.handleVendorChange(e);
      }
    } else {
      let requestlist = { ...this.state.requestlist };
      let formData = { ...this.state.formData };
      requestlist.hotelID = this.state.hotelValue;
      requestlist.oprID = -1;
      requestlist.vid = "";
      formData.vendorID = 0;
      formData.vendorName = "";
      formData.vendorContract = "";
      formData.aid = 0;
      formData.saletax = "";
      this.setState(
        {
          // isMapped: "No",
          // isExtractOption: false,
          requestlist,
          formData: formData,
          vendorSelected: e,
          // previousTransactionsData: [],
          // isPreviousTransactions: false,
          // defaultpaymentType1: "Select Type",
          // defaultpaymentType: "Select Type",
          paymentType: [],
          // accountlist: [],
          // defaultaccountType: "Select Account",
          isStateChanged,
          // LinemapData: [],//Reset
          // mapData: []
        },
        () => this.setState({ paymentType: paymentType1 })
      );
    }
  };

  getEpayCheckImageURL = () => {
    let request: any = {};
    request.degitalID = this.state.epayDigitalID;
    InvoiceApprovalS.GetEpayCheckImageURL(request)
      .then(async (result: any | null) => {
        //debugger;
        if (result !== null && result !== "") {
          this.downloadEpayCheckImage(result);
        } else {
          Utils.toastError(
            "Check image is not yet available. This may take up to 24 hours after the check is sent to the vendor.",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reject();
      });
  };

  downloadEpayCheckImage = (url) => {
    let alink = document.createElement("a");
    alink.href = url;
    // alink.target="_blank"
    alink.setAttribute("download", `${this.state.epayCheckNo}.pdf`);
    alink.setAttribute("target", "_blank");
    document.body.appendChild(alink);
    alink.click();
  };

  render() {
    let { selectedRow } = this.props;
    let disableControl: boolean = false;
    let isBankSyncInvoice = selectedRow?.callFrom === "BankSyncInvoice";
    let isWithdrawal = selectedRow?.slideType === "invoicewithdrawal";
    let isDebitAcc = selectedRow?.slideType === "invoiceDebit";
    let isCreditAcc = selectedRow?.slideType === "invoiceCredit";
    let isSlideType = "";
    if (isDebitAcc) {
      isSlideType = "invoiceDebit";
    } else if (isCreditAcc) {
      isSlideType = "invoiceCredit";
    } else if (isWithdrawal) {
      isSlideType = "invoicewithdrawal";
    }
    disableControl = isDebitAcc || isCreditAcc || isWithdrawal;

    // condition to check if Mark as Paid Toggle is ON
    let isMrkPdTgglOn = this.state.formData.isPaid.toLowerCase() === "paid";
    let isCC = this.state.formData.paymenttype.toLowerCase() === "credit card";
    let isMach =
      this.state.formData.paymenttype.toLowerCase() === "ach" ||
      this.state.formData.paymenttype.toLowerCase() === "manual ach";
    // condition to check for byPass Rules and Send Invoice to Approval/Payments/Register

    let isBypassRules =
      (this.state.formData.uniqueno === 0 ||
        (this.state.formData.uniqueno > 0 &&
          this.state.formData.actionType === "copy")) &&
      isMrkPdTgglOn &&
      ((isMach &&
        (this.state.isACHBypassApproval.toLowerCase() === "yes" ||
          this.state.isACHBypassPayment.toLowerCase() === "yes")) ||
        (isCC &&
          (this.state.isCCBypassApproval.toLowerCase() === "yes" ||
            this.state.isCCBypassPayment.toLowerCase() === "yes")));

    let bypassBtnName =
      this.getBypassStatus() === "register"
        ? "Post Transaction"
        : this.getBypassStatus() === "payments"
        ? "Send to Payment"
        : "Send to Approval";

    // isPdfFile added to check if uploaded file has a pdf or not
    let isPdfFile = false;
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      let fileDet = this.state.savedfiles[i];
      if (
        fileDet?.name.substring(
          fileDet?.name.lastIndexOf(".") + 1,
          fileDet?.name.length
        ) === "pdf"
      ) {
        isPdfFile = true;
        break;
      }
    }
    const highlightDates = [
      new Date(), // Current date
    ];

    let isIncompleteDisabled =
      this.state.splitData.filter(
        (r) =>
          r.coa.length === 0 || r.spiltHoteID === "" || r.amount.length === 0
      ).length === 0;
    if (
      isIncompleteDisabled &&
      this.state.defaultEntry === "incomplete-entry"
    ) {
      isIncompleteDisabled = false;
    }
    let isBedgeProcessing = this.state.invoiceBedge
      .toString()
      .toLowerCase()
      .includes("processing");

    let isCheckBoxDisable = isBedgeProcessing
      ? true
      : this.state.isPermission === "No" ||
        this.state.isError === "NotEdit" ||
        this.state.formData.accPeriodstatus.toString().toLowerCase() !==
          "active" ||
        this.state.formData.adj.toString() === "Y" ||
        this.state.formData.ispayment === "Yes"
      ? true
      : false;
    let nonSelectable = [];
    if (isCheckBoxDisable) {
      nonSelectable = this.state.splitData.map((r) => r.rno);
    } else {
      nonSelectable = this.state.splitData
        .filter((r) => r.isCOAPer !== "Yes")
        .map((r) => r.rno);
    }

    const selectRow = {
      mode: "checkbox",
      selected: this.state.bulkSelectedSplitRows,
      onSelect: this.handleOnSelect,
      onSelectAll: this.handleOnSelectAll,
      nonSelectable: nonSelectable,
    };

    let isEditPermission =
      this.state.isPermission === "No" ||
      this.state.isError === "NotEdit" ||
      this.state.formData.accPeriodstatus.toString().toLowerCase() != "active";
    let isEditPermission1 =
      this.state.isPermission === "No" || this.state.isError === "NotEdit";

    let appDisabled =
      this.state.rulesArray.filter((item) => item.isCheck).length > 0
        ? false
        : true;
    let bedgeClass = "";

    if (
      this.state.invoiceBedge.toString().toLowerCase() ==
        "Pending approval".toLowerCase() ||
      this.state.invoiceBedge.toString().toLowerCase() ==
        "Pending payment".toLowerCase() ||
      this.state.invoiceBedge.toString().toLowerCase() ==
        "Processing".toLowerCase() ||
      this.state.invoiceBedge.toString().toLowerCase().includes("pending")
    ) {
      bedgeClass = "orange";
    } else if (
      this.state.invoiceBedge.toString().toLowerCase() ==
        "Paid - unreconciled".toLowerCase() ||
      this.state.invoiceBedge.toString().toLowerCase() ==
        "Paid - reconciled".toLowerCase() ||
      this.state.invoiceBedge.toString().toLowerCase().includes("paid")
    ) {
      bedgeClass = "gray";
    } else if (
      this.state.invoiceBedge.toString().toLowerCase() == "Failed".toLowerCase()
    ) {
      bedgeClass = "red";
    } else if (
      this.state.invoiceBedge.toString().toLowerCase() == "Void".toLowerCase()
    ) {
      bedgeClass = "gray";
    }

    const currentView = this.state.defaultView;
    const allsavedfiles = this.state.savedfiles;
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };

    const toggleEntrySwitch = (event: any) => {
      this.setState({ defaultEntry: event }, () => {
        this.showIncompleteSplitColumns(this.state.defaultEntry);
      });
    };

    let btnlist =
      this.state.formData.uniqueno > 0
        ? true
        : this.state.invoiceUniqueNo > 0 &&
          this.state.isPermission === "Yes" &&
          this.state.formData.incompleteUniqueno > 0
        ? true
        : false;
    if (btnlist && this.state.formData.incompleteUniqueno > 0) {
      btnlist =
        this.state.formData.incompleteUniqueno > 0 &&
        this.state.formData.actionType.length === 0
          ? true
          : false;
    }

    let fileNolist: any = [];

    if (this.state.chkIds.length > 0) {
      for (let x = 0; x < this.state.chkIds.length; x++) {
        let fileItem: any = {};
        let splitchkIds = this.state.chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        fileItem.fileNo = fileNo;
        fileNolist.push(fileItem);
      }
    }

    const files = this.state.newSelectfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex align-items-center">
              <div className="name-loader d-flex align-items-center">
                <div className="name">
                  <EllipsisWithTooltip placement="bottom">
                    <div
                      className="full-name"
                      onClick={() => {
                        this.handlePreview(file);
                      }}
                    >
                      {file.name}
                    </div>
                  </EllipsisWithTooltip>
                </div>
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
              </div>
            </div>
          </div>
        </li>
      </>
    ));

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex align-items-center">
              <div className="name-loader d-flex align-items-center">
                <div className="name">
                  <EllipsisWithTooltip placement="bottom">
                    <div className="full-name">{file.name}</div>
                  </EllipsisWithTooltip>
                  <div className="details">
                    {file.createDate} - {file.pageno} Page
                  </div>
                </div>
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
              </div>
            </div>
            <div className="action">
              {!this.state.bulkSelect && (
                <Dropdown
                  className="more-action"
                  alignRight
                  onSelect={(event: any) =>
                    this.handleSelectFileUpload(event, file, index)
                  }
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.state.moreActionFileUpload1.map(
                      (item: any, idx: any) => (
                        <>
                          {this.state.isPermission === "Yes" &&
                            this.state.formData.incompleteUniqueno > 0 &&
                            this.state.formData.uniqueno === 0 && (
                              <Dropdown.Item
                                className={
                                  (this.state.formData.actionType === "copy" ||
                                    this.state.isError === "NotEdit" ||
                                    this.state.formData.adj.toLowerCase() ===
                                      "y") &&
                                  this.state.moreActionFileUpload1[idx]
                                    .eventKey === "delete"
                                    ? "isHide"
                                    : ""
                                }
                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}

                          {this.state.invoiceUniqueNo > 0 &&
                            this.state.formData.uniqueno > 0 && (
                              <Dropdown.Item
                                className={
                                  (this.state.formData.actionType === "copy" ||
                                    this.state.isError === "NotEdit" ||
                                    this.state.isEdit === "No" ||
                                    this.state.formData.adj.toLowerCase() ===
                                      "y") &&
                                  this.state.moreActionFileUpload1[idx]
                                    .eventKey === "delete"
                                    ? "isHide"
                                    : ""
                                }
                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}
                        </>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </li>
      </>
    ));

    const attachmentheader = (column: any, colIndex: any) => {
      return (
        <div className="paperClipBtn">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 448 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path>
          </svg>
        </div>
      );
    };

    const previousTransactionsColumns = [
      {
        dataField: "accper",
        text: "AP",
        headerClasses: "cl ap",
        classes: "cl ap",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return <>{row.accper}</>;
        },
      },
      {
        dataField: "date",
        text: "Date",
        headerClasses: "date",
      },
      {
        dataField: "lettercode",
        text: "EHID",
        headerClasses: "ehid",
      },
      {
        dataField: "internalnotes",
        text: "Notes",
        headerClasses: "notes",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.internalnotes}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "isFile",
        text: "Attachments",
        headerClasses: "attachments",
        headerFormatter: attachmentheader,
        formatter: (cell: any, row: any, rowIndex: any) => {
          if (row.isFile === "Yes") {
            return (
              <div
                className="paperClipBtn"
                onClick={() => this.openFileViewer(row)}
              >
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                </svg>
              </div>
            );
          } else {
            return <div></div>;
          }
        },
      },
      {
        dataField: "transTotal",
        text: "Total",
        headerClasses: "amount",
        classes: "amount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.amountFormatted(Number(row.transTotal).toFixed(2))}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "cl",
        text: "CL",
        headerClasses: "cl",
        classes: "cl",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return <>{row.cl}</>;
        },
      },
    ];

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderPreviousTableChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderPreviousTableChild = (mainrow) => {
      let SplitPreviousCOADetail: any = [];
      SplitPreviousCOADetail = this.state.previousTransactionsData.filter(
        (x) => x.uniqueNo === mainrow.uniqueNo && x.mainType === 2
      );
      const columnCOAChild = [
        {
          dataField: "",
          text: "",
          headerClasses: "expand-cell-header",
          classes: "expand-cell-header",
          headerFormatter: whiteBgFormatter,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div className="white-bg"></div>;
          },
        },
        {
          dataField: "invoiceNo",
          text: "Invoice",
          headerClasses: "date",
          classes: "date",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div className="d-flex align-items-center txt-bold">
                <EllipsisWithTooltip placement="bottom">
                  {rowIndex === 0 ? row.invoiceNo : ""}
                </EllipsisWithTooltip>
              </div>
            );
          },
        },
        {
          dataField: "coa",
          text: "COA #",
          headerClasses: "ehid",
          classes: "ehid",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coa}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "cOAName",
          text: "COA Name",
          headerClasses: "notes",
          classes: "notes",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coaName}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "description",
          text: "Description",
          headerClasses: "description",
          classes: "description",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.description}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "accper",
          text: "A/C Period",
          hidden: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.accper}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "amount",
          text: "Amount",
          headerClasses: "amount",
          classes: "amount",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>{Utils.amountFormatted(Number(row.amount).toFixed(2))}</div>
            );
          },
        },
        {
          dataField: "",
          text: "",
          headerClasses: "blankLastChildofChild",
        },
        {
          dataField: "",
          text: "",
          headerClasses: "cl",
          classes: "cl",
          headerFormatter: whiteBgFormatter,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div className="white-bg"></div>;
          },
        },
      ];

      return (
        <>
          <BootstrapTable
            id="tblCOAchild"
            keyField="uniqueNo"
            data={SplitPreviousCOADetail}
            columns={columnCOAChild}
          />
        </>
      );
    };

    const handleUpdate = (newtext) => {
      toggleSwitch("doc-view");
      setTimeout(function () {
        let currentPos: any = $(`#${newtext}`).offset()?.top;
        let marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      docViewerFiles.push(docFiles);
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      if (type === "removeAll") {
        if (
          this.footerchk.current !== null &&
          this.footerchk.current !== undefined
        ) {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = false;
        }
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
          this.footerchk.current.checked = false;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };

    const savedfilesCount = this.state.savedfiles.length;
    const iSePayEntry =
      this.state.formData.paymenttype.toString().toLocaleLowerCase() === "epay";
    const isStatusPaidSent = this.state.invoiceBedge
      .toLocaleLowerCase()
      .includes("paid");
    const isePayMethod = this.state.ePayMethod !== "";

    const associatedPaymentsColumns = [
      {
        dataField: "date",
        text: "Date",
      },
      {
        dataField: "type",
        text: "Type",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.type}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "account",
        text: "Account",
        headerClasses: "account",
        classes: "account",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.account}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "amount",
        text: "Amount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return Utils.amountFormatted(row.amount);
        },
      },
      {
        dataField: "paymentNotes",
        text: "Notes",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              {row.paymentNotes?.toString()?.length > 0 && (
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id={"EHID-more"}>{row.paymentNotes}</Tooltip>
                  }
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2H9.75V0.5H8.25V2H5.25V0.5H3.75V2H1.5C0.67275 2 0 2.67275 0 3.5V14C0 14.8273 0.67275 15.5 1.5 15.5H12C12.8273 15.5 13.5 14.8273 13.5 14V3.5C13.5 2.67275 12.8273 2 12 2ZM1.5 14V4.25H3.75H5.25H8.25H9.75H12V3.5L12.0015 14H1.5Z"
                      fill="#84888C"
                    />
                    <path
                      d="M3 5.75H10.5V7.25H3V5.75ZM3 8.75H6.75V10.25H3V8.75Z"
                      fill="#84888C"
                    />
                  </svg>
                </OverlayTrigger>
              )}
            </>
          );
        },
      },
    ];

    const associatedInvoicesColumns = [
      {
        dataField: "date",
        text: "Date",
      },
      {
        dataField: "type",
        text: "Type",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {iSePayEntry && isStatusPaidSent && isePayMethod
                ? row.type + " - " + this.state.ePayMethod
                : row.type}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "account",
        text: "Account",
        headerClasses: "account",
        classes: "account",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.account}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "amount",
        text: "Amount",
      },
      {
        dataField: "paymentNotes",
        text: "Notes",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              {row.paymentNotes?.toString()?.length > 0 && (
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id={"EHID-more"}>{row.paymentNotes}</Tooltip>
                  }
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2H9.75V0.5H8.25V2H5.25V0.5H3.75V2H1.5C0.67275 2 0 2.67275 0 3.5V14C0 14.8273 0.67275 15.5 1.5 15.5H12C12.8273 15.5 13.5 14.8273 13.5 14V3.5C13.5 2.67275 12.8273 2 12 2ZM1.5 14V4.25H3.75H5.25H8.25H9.75H12V3.5L12.0015 14H1.5Z"
                      fill="#84888C"
                    />
                    <path
                      d="M3 5.75H10.5V7.25H3V5.75ZM3 8.75H6.75V10.25H3V8.75Z"
                      fill="#84888C"
                    />
                  </svg>
                </OverlayTrigger>
              )}
            </>
          );
        },
      },
    ];

    const ruleToolTip = (item) => {
      return (
        <EllipsisWithTooltip placement="bottom">
          {item.ruleName}
        </EllipsisWithTooltip>
      );
    };

    let { defaultpaymentType, defaultpaymentType2, defaultpaymentType2Change } =
      this.state;
    let checkisACH1 =
      defaultpaymentType.toString().toLocaleLowerCase() === "ach"
        ? "manual ach"
        : defaultpaymentType.toString().toLocaleLowerCase();
    let checkisACH2 =
      defaultpaymentType2.toString().toLocaleLowerCase() === "ach"
        ? "manual ach"
        : defaultpaymentType2.toString().toLocaleLowerCase();
    let isDiffrentPtype =
      defaultpaymentType !== "Select Type" && defaultpaymentType2Change
        ? checkisACH1 !== checkisACH2
        : false;

    return (
      <>
        <div className="transaction-slideout invoice-entry pos-fxd index-1000">
          {this.state.showChangeLogModal && (
            <TransactionLogHistory
              payPeriodStartDate={""}
              payPeriodEndDate={""}
              showChangeLogModal={this.state.showChangeLogModal}
              showHideChangeLogModal={this.showHideChangeLogModal}
              hotelName={""}
              hotelId={0}
              hideCrossAndClearFilters={false}
              shiftId={this.state.invoiceUniqueNo}
              shiftDate={""}
              accType={"Invoice"}
            />
          )}
          {/* <ToastContainer
            autoClose={3000}
            containerId={"InvoiceSlideout"}
            enableMultiContainer
          /> */}
          <div className="d-flex">
            {!this.state.isOpenViewer && (
              <div
                className="back-drop  viewer-panel opacity"
                onClick={() => this.closeSlideOut(this.state.invoiceUniqueNo)}
              ></div>
            )}
            {this.state.isOpenViewer && (
              <div className="back-drop viewer-panel">
                <div className="header-panel update-header">
                  <div className="d-flex justify-content-between align-items-center height-88">
                    <div className="page-ttl">Invoice Attachments</div>
                    <div className="toggle-button">
                      <ButtonGroup aria-label="Basic example">
                        <ToggleButtonGroup
                          type="radio"
                          name="options"
                          value={this.state.defaultView}
                          onChange={toggleSwitch}
                        >
                          <ToggleButton value={"doc-view"}>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                              <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                            </svg>
                          </ToggleButton>
                          <ToggleButton value={"grid-view"}>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                            </svg>
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </ButtonGroup>
                    </div>
                    <div className="action d-flex padding-update">
                      {currentView === "doc-view" && isPdfFile && (
                        <button
                          type="button"
                          className="btn wht-bg cross width-24"
                          onClick={(e) => this.handleZoom("zoomIn")}
                          disabled={
                            this.state.currentZoom >= 3.375 ? true : false
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.2944 15.2954H16.241L15.8677 14.9354C17.4677 13.0688 18.2944 10.5221 17.841 7.81543C17.2144 4.10876 14.121 1.14876 10.3877 0.69543C4.74771 0.00209719 0.0143773 4.74876 0.694377 10.3888C1.14771 14.1221 4.10771 17.2154 7.81438 17.8421C10.521 18.2954 13.0677 17.4688 14.9344 15.8688L15.2944 16.2421V17.2954L20.9744 22.9621C21.521 23.5088 22.401 23.5088 22.9477 22.9621L22.961 22.9488C23.5077 22.4021 23.5077 21.5221 22.961 20.9754L17.2944 15.2954ZM9.29438 15.2954C5.97438 15.2954 3.29438 12.6154 3.29438 9.29543C3.29438 5.97543 5.97438 3.29543 9.29438 3.29543C12.6144 3.29543 15.2944 5.97543 15.2944 9.29543C15.2944 12.6154 12.6144 15.2954 9.29438 15.2954ZM9.29438 5.9621C8.92104 5.9621 8.62771 6.25543 8.62771 6.62876V8.62876H6.62771C6.25438 8.62876 5.96104 8.9221 5.96104 9.29543C5.96104 9.66876 6.25438 9.9621 6.62771 9.9621H8.62771V11.9621C8.62771 12.3354 8.92104 12.6288 9.29438 12.6288C9.66771 12.6288 9.96104 12.3354 9.96104 11.9621V9.9621H11.961C12.3344 9.9621 12.6277 9.66876 12.6277 9.29543C12.6277 8.9221 12.3344 8.62876 11.961 8.62876H9.96104V6.62876C9.96104 6.25543 9.66771 5.9621 9.29438 5.9621Z" />
                          </svg>
                        </button>
                      )}
                      {currentView === "doc-view" && isPdfFile && (
                        <button
                          type="button"
                          className="btn wht-bg cross width-24"
                          onClick={(e) => this.handleZoom("zoomOut")}
                          disabled={
                            this.state.currentZoom <= 0.44 ? true : false
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.2954 15.2954H16.2421L15.8688 14.9354C17.4688 13.0688 18.2954 10.5221 17.8421 7.81543C17.2154 4.10876 14.1221 1.14876 10.3888 0.69543C4.74876 0.00209719 0.00209719 4.74876 0.69543 10.3888C1.14876 14.1221 4.10876 17.2154 7.81543 17.8421C10.5221 18.2954 13.0688 17.4688 14.9354 15.8688L15.2954 16.2421V17.2954L20.9754 22.9621C21.5221 23.5088 22.4021 23.5088 22.9488 22.9621L22.9621 22.9488C23.5088 22.4021 23.5088 21.5221 22.9621 20.9754L17.2954 15.2954ZM9.29543 15.2954C5.97543 15.2954 3.29543 12.6154 3.29543 9.29543C3.29543 5.97543 5.97543 3.29543 9.29543 3.29543C12.6154 3.29543 15.2954 5.97543 15.2954 9.29543C15.2954 12.6154 12.6154 15.2954 9.29543 15.2954ZM6.62876 8.62876H11.9621C12.3354 8.62876 12.6288 8.9221 12.6288 9.29543C12.6288 9.66876 12.3354 9.9621 11.9621 9.9621H6.62876C6.25543 9.9621 5.9621 9.66876 5.9621 9.29543C5.9621 8.9221 6.25543 8.62876 6.62876 8.62876Z" />
                          </svg>
                        </button>
                      )}
                      {isPdfFile && (
                        <button
                          type="button"
                          className="btn wht-bg cross width-24"
                          onClick={(e) => this.DownloadBulkInvoice()}
                        >
                          <svg
                            width="20"
                            height="24"
                            viewBox="0 0 20 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.1201 8.66675H14.0001V2.00008C14.0001 1.26675 13.4001 0.666748 12.6667 0.666748H7.33342C6.60008 0.666748 6.00008 1.26675 6.00008 2.00008V8.66675H3.88008C2.69341 8.66675 2.09341 10.1067 2.93341 10.9467L9.05342 17.0667C9.57341 17.5867 10.4134 17.5867 10.9334 17.0667L17.0534 10.9467C17.8934 10.1067 17.3067 8.66675 16.1201 8.66675ZM0.666748 22.0001C0.666748 22.7334 1.26675 23.3334 2.00008 23.3334H18.0001C18.7334 23.3334 19.3334 22.7334 19.3334 22.0001C19.3334 21.2667 18.7334 20.6667 18.0001 20.6667H2.00008C1.26675 20.6667 0.666748 21.2667 0.666748 22.0001Z" />
                          </svg>
                        </button>
                      )}
                      {this.state.isGearicoSettingbuttonNew &&
                        this.state.isMapped.toString().toLowerCase() ===
                          "Yes".toString().toLowerCase() && (
                          <button
                            type="button"
                            className="btn wht-bg cross width-20"
                            onClick={() => this.adjustMapping()}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10.0003 13.3333C11.8387 13.3333 13.3337 11.8383 13.3337 9.99996C13.3337 8.16163 11.8387 6.66663 10.0003 6.66663C8.16199 6.66663 6.66699 8.16163 6.66699 9.99996C6.66699 11.8383 8.16199 13.3333 10.0003 13.3333ZM10.0003 8.33329C10.9037 8.33329 11.667 9.09663 11.667 9.99996C11.667 10.9033 10.9037 11.6666 10.0003 11.6666C9.09699 11.6666 8.33366 10.9033 8.33366 9.99996C8.33366 9.09663 9.09699 8.33329 10.0003 8.33329Z" />
                              <path d="M2.37086 13.4466L3.20419 14.8883C3.64669 15.6525 4.71169 15.9391 5.47919 15.4966L5.92003 15.2416C6.40503 15.6225 6.93753 15.935 7.50003 16.1683V16.6666C7.50003 17.5858 8.24753 18.3333 9.16669 18.3333H10.8334C11.7525 18.3333 12.5 17.5858 12.5 16.6666V16.1683C13.0625 15.935 13.595 15.6225 14.08 15.2425L14.5209 15.4975C15.29 15.9391 16.3525 15.6541 16.7967 14.8883L17.6292 13.4475C18.0892 12.6516 17.8159 11.63 17.02 11.1708L16.5992 10.9275C16.6442 10.6183 16.6667 10.3091 16.6667 9.99996C16.6667 9.69079 16.6442 9.38079 16.5992 9.07413L17.02 8.83079C17.8159 8.37079 18.0892 7.34996 17.6292 6.55413L16.7967 5.11329C16.3542 4.34663 15.29 4.05913 14.5209 4.50329L14.08 4.75829C13.595 4.37746 13.0625 4.06496 12.5 3.83163V3.33329C12.5 2.41413 11.7525 1.66663 10.8334 1.66663H9.16669C8.24753 1.66663 7.50003 2.41413 7.50003 3.33329V3.83163C6.93753 4.06496 6.40503 4.37746 5.92003 4.75746L5.47919 4.50246C4.70919 4.05996 3.64586 4.34663 3.20336 5.11246L2.37086 6.55329C1.91086 7.34913 2.18419 8.37079 2.98003 8.82996L3.40086 9.07329C3.35586 9.38079 3.33336 9.69079 3.33336 9.99996C3.33336 10.3091 3.35586 10.6183 3.40086 10.9258L2.98003 11.1691C2.18419 11.6291 1.91086 12.6508 2.37086 13.4466ZM5.14253 11.1483C5.04836 10.7708 5.00003 10.3841 5.00003 9.99996C5.00003 9.61496 5.04836 9.22829 5.14169 8.85163C5.23169 8.49079 5.07253 8.11413 4.75003 7.92829L3.81419 7.38663L4.64586 5.94579L5.60003 6.49746C5.92003 6.68163 6.32253 6.63496 6.59003 6.37913C7.15919 5.83996 7.84586 5.43663 8.57669 5.21329C8.92753 5.10663 9.16669 4.78246 9.16669 4.41663V3.33329H10.8334V4.41663C10.8334 4.78246 11.0725 5.10663 11.4234 5.21329C12.1542 5.43746 12.8409 5.83996 13.41 6.37913C13.6775 6.63496 14.0817 6.68079 14.4 6.49746L15.3534 5.94663L16.1867 7.38746L15.25 7.92829C14.9275 8.11496 14.7684 8.49163 14.8584 8.85163C14.9517 9.22829 15 9.61496 15 9.99996C15 10.3841 14.9517 10.7708 14.8575 11.1483C14.7684 11.5091 14.9275 11.8858 15.25 12.0716L16.1859 12.6125L15.3542 14.0533L14.4 13.5025C14.0809 13.3183 13.6775 13.3641 13.41 13.6208C12.8409 14.16 12.1542 14.5633 11.4234 14.7866C11.0725 14.8933 10.8334 15.2175 10.8334 15.5833L10.835 16.6666H9.16669V15.5833C9.16669 15.2175 8.92753 14.8933 8.57669 14.7866C7.84586 14.5625 7.15919 14.16 6.59003 13.6208C6.43169 13.4691 6.22503 13.3916 6.01669 13.3916C5.87336 13.3916 5.73003 13.4283 5.60003 13.5033L4.64669 14.055L3.81336 12.6141L4.75003 12.0716C5.07253 11.8858 5.23169 11.5091 5.14253 11.1483Z" />
                            </svg>
                          </button>
                        )}

                      {!this.state.isExtractOption &&
                        this.state.isextractShowbuttonNew &&
                        this.state.ispdfExtract === "Yes" &&
                        this.state.formData.vendorID > 0 &&
                        this.state.isMapped.toString().toLowerCase() !==
                          "Yes".toString().toLowerCase() &&
                        isPdfFile &&
                        this.state.formData.uniqueno === 0 &&
                        this.state.formData.incompleteUniqueno > 0 && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.pdfExtract}
                          >
                            Extract
                          </button>
                        )}
                      <button
                        type="button"
                        className="btn wht-bg cross width-12"
                        onClick={this.OpenViewer}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="all-file-selector">
                    <Form.Check
                      custom
                      type="checkbox"
                      key={"all-file-selector"}
                      id={"all-file-selector"}
                      label={"Select All Pages"}
                      onChange={(e: any) => this.handleAllCheckbox(e)}
                      ref={this.footerchk}
                      disabled={!isPdfFile}
                    />
                  </div>
                </div>

                <ScrollContainer
                  className={`scroll-area update-scroll ${
                    this.state.modalOpen === "yes" ? "modal-open" : ""
                  } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"} ${
                    this.state.chkIds.length > 0 ? "footer-show" : ""
                  }`}
                  ref={this.scrollheight}
                  hideScrollbars={false}
                >
                  <>
                    {this.state.savedfiles.map((file: any, i: any) => {
                      return (
                        <div
                          id={`sec_${file.fileUniqueno}`}
                          className={
                            this.state.bulkSelect ? "footer-enable" : ""
                          }
                        >
                          <div
                            className={
                              currentView !== "doc-view"
                                ? "grid-sec"
                                : "doc-sec"
                            }
                          >
                            {this.state.defaultView == "grid-view" && (
                              <div className="custom-grid-header d-flex align-items-center">
                                <div className="page-ttl">{file.name}</div>
                              </div>
                            )}

                            <PDFViewer
                              //ref={childViewerref}
                              ref={this["myRef" + i]}
                              scrollAreaHeight={this.state.scrollAreaHeight}
                              isModalOpen={this["isModalOpen"]}
                              uniqueno={this.state.invoiceUniqueNo}
                              filePreview={file.fileCode}
                              defaultView={currentView}
                              fileNo={file.fileUniqueno}
                              fileCount={savedfilesCount}
                              fileName={file.name}
                              // docFile={docViewerFiles}
                              docFile={allsavedfiles}
                              updateState={handleUpdate}
                              updateFiles={handleUpdateFiles}
                              showBulkSelect={showBulkSelect}
                              checkBulkSelect={checkBulkSelect}
                              handleFileCheckBox={this["handleFileCheckBox"]}
                              handleUpdatedFile={this["handleUpdatedFile"]}
                              handleincompleteFile={
                                this["handleincompleteFile"]
                              }
                              saveSplitFile={this["saveSplitFile"]}
                              pageType={this.state.pageType}
                              handleRotate={this["handleRotate"]}
                              handlePageRemove={this["handlePageRemove"]}
                              selectedChk={this.state.selectedChk}
                              selectedZoom={this.state.currentZoom}
                              setTotalPages={this["setTotalPages"]}
                              isEditPermission={!isEditPermission}
                            />
                          </div>
                        </div>
                      );
                    })}
                    {this.state.isHtmlBody === "Show" &&
                      this.state.formData.actionType.length === 0 && (
                        <div
                          className={
                            currentView !== "doc-view"
                              ? "email-attachement grid-view"
                              : "email-attachement doc-view"
                          }
                        >
                          <button
                            type="button"
                            className="btn wht-bg link-btn mr-auto"
                            onClick={this.loadFileFromMailBody}
                          >
                            Add Email Body as Attachment
                          </button>

                          <div className="info">{this.state.emailLink}</div>
                        </div>
                      )}
                  </>
                </ScrollContainer>
                {this.state.chkIds.length > 0 && (
                  <div className="footer-section padding-update d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="ttl-page-selected">{`${
                        this.state.chkIds.length
                      } ${
                        this.state.chkIds.length === 1 ? "Page" : "Pages"
                      } Selected`}</div>
                      {this.state.isPermission === "Yes" &&
                        !(
                          this.state.formData.actionType === "copy" ||
                          this.state.isError === "NotEdit"
                        ) && (
                          <button
                            type="button"
                            onClick={this.showAttachmentRemoveConfirmation}
                            className="btn-outline-primary btn btn-primary delete"
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.5 5.25C4.08525 5.25 3.75 5.25 3.75 5.25V15C3.75 15.828 4.422 16.5 5.25 16.5H12.75C13.578 16.5 14.25 15.828 14.25 15V5.25C14.25 5.25 13.9148 5.25 13.5 5.25H4.5ZM7.5 14.25H6V7.5H7.5V14.25ZM12 14.25H10.5V7.5H12V14.25ZM12.4635 3L11.25 1.5H6.75L5.5365 3H2.25V4.5H6H12H15.75V3H12.4635Z"
                                fill="#D3412E"
                              />
                            </svg>
                          </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center rotate-sec">
                      <button
                        type="button"
                        onClick={() => this.handleBulkRotate("left")}
                        className="btn-outline-primary btn btn-primary margin-right-10"
                      >
                        Rotate Left
                        <svg
                          width="14"
                          height="16"
                          viewBox="0 0 14 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M2.89582 6.38755L1.72082 5.20422C0.970821 6.17088 0.504154 7.28755 0.362488 8.44588H2.04582C2.16249 7.72088 2.45415 7.01255 2.89582 6.38755ZM2.04582 10.1125H0.362488C0.504154 11.2709 0.962488 12.3875 1.71249 13.3542L2.88749 12.1709C2.45415 11.5459 2.16249 10.8459 2.04582 10.1125ZM2.88749 14.5459C3.85415 15.2959 4.97915 15.7459 6.13749 15.8875V14.1959C5.41249 14.0709 4.71249 13.7875 4.08749 13.3376L2.88749 14.5459ZM7.80415 2.67088V0.112549L4.01249 3.90422L7.80415 7.61255V4.35422C10.1708 4.75422 11.9708 6.80422 11.9708 9.27922C11.9708 11.7542 10.1708 13.8042 7.80415 14.2042V15.8875C11.0958 15.4792 13.6375 12.6792 13.6375 9.27922C13.6375 5.87922 11.0958 3.07922 7.80415 2.67088Z" />
                        </svg>
                      </button>
                      <button
                        type="button"
                        onClick={() => this.handleBulkRotate("right")}
                        className="btn-outline-primary btn btn-primary"
                      >
                        Rotate Right
                        <svg
                          width="14"
                          height="16"
                          viewBox="0 0 14 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M9.98749 3.90422L6.19582 0.112549V2.67088C2.91249 3.07922 0.362488 5.87922 0.362488 9.27922C0.362488 12.6792 2.90415 15.4792 6.19582 15.8875V14.2042C3.82915 13.8042 2.02915 11.7542 2.02915 9.27922C2.02915 6.80422 3.82915 4.75422 6.19582 4.35422V7.61255L9.98749 3.90422ZM13.6375 8.44588C13.4958 7.28755 13.0375 6.17088 12.2875 5.20422L11.1042 6.38755C11.5542 7.01255 11.8375 7.72088 11.9542 8.44588H13.6375ZM7.86249 14.1959V15.8792C9.02082 15.7375 10.1458 15.2875 11.1125 14.5375L9.91249 13.3376C9.28749 13.7875 8.58749 14.0792 7.86249 14.1959ZM11.1042 12.1792L12.2875 13.3542C13.0375 12.3875 13.4958 11.2709 13.6375 10.1125H11.9542C11.8375 10.8375 11.5542 11.5459 11.1042 12.1792Z" />
                        </svg>
                      </button>
                    </div>
                    <div className="d-flex align-items-center move-sec">
                      {this.state.pageType.toLowerCase() ===
                        "INCOMPLETEINVOICE".toLowerCase() && (
                        <Dropdown
                          className={
                            this.state.isShowAttchmntInvLstMdl
                              ? "more-action show"
                              : "more-action"
                          }
                          alignRight
                        >
                          <Dropdown.Toggle
                            className="btn btn-primary margin-right-16"
                            id="footerMoveList"
                          >
                            Move
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.6667 1.99992H8.99999L7.33332 0.333252H2.33332C1.41666 0.333252 0.666656 1.08325 0.666656 1.99992V11.9999C0.666656 12.9166 1.41666 13.6666 2.33332 13.6666H15.6667C16.5833 13.6666 17.3333 12.9166 17.3333 11.9999V3.66659C17.3333 2.74992 16.5833 1.99992 15.6667 1.99992ZM15.6667 11.9999H2.33332V1.99992H6.64166L8.30832 3.66659H15.6667V11.9999ZM9.13332 6.99992H5.66666V8.66658H9.13332L7.80832 9.99158L8.99166 11.1666L12.3333 7.84159L8.99166 4.49992L7.81666 5.67492L9.13332 6.99992Z"
                                fill="white"
                              />
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              eventKey="move-new"
                              onClick={() =>
                                this.moveAttachment("MoveToNewInvoice", {})
                              }
                            >
                              Move to New Invoice
                            </Dropdown.Item>
                            <Dropdown.Item
                              eventKey="move-existing"
                              onClick={() =>
                                this.handleMoveAttachmentInvoiceListModal(
                                  "show"
                                )
                              }
                            >
                              Move to Existing Invoice
                            </Dropdown.Item>
                            <Dropdown.Item
                              eventKey="move-each-new"
                              onClick={() =>
                                this.moveAttachment("MoveEachPage", {})
                              }
                            >
                              <div className="d-flex info-icn">
                                <div>Move Each Page to New Invoice</div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id={"move-existing"}>
                                      {
                                        "This creates a new invoice for each page."
                                      }
                                    </Tooltip>
                                  }
                                >
                                  <div className="alert-icn">
                                    <svg
                                      stroke="currentColor"
                                      fill="#6a6e73"
                                      stroke-width="0"
                                      version="1.1"
                                      viewBox="0 0 16 16"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="postingToolTip"
                                    >
                                      <path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"></path>
                                      <path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path>
                                      <path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path>
                                    </svg>
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                          {this.state.isShowAttchmntInvLstMdl && (
                            <>
                              <div className="backDrop-dropdown"></div>
                              <div className="attach-invoice-modal">
                                <div className="header d-flex align-items-center">
                                  <button
                                    type="button"
                                    className="btn wht-bg cross back"
                                    onClick={() =>
                                      this.handleMovedropDown("back")
                                    }
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.0776 5.24414L6.32178 9.99997L11.0776 14.7558L12.2559 13.5775L8.67844 9.99997L12.2559 6.42247L11.0776 5.24414Z"
                                        fill="#2CAF92"
                                      />
                                    </svg>
                                  </button>
                                  <div className="title mr-auto">
                                    Select Invoice to Attach to
                                  </div>
                                  <button
                                    type="button"
                                    className="btn wht-bg cross"
                                    onClick={() =>
                                      this.handleMoveAttachmentInvoiceListModal(
                                        "hide"
                                      )
                                    }
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.4933 5.28662L9.95747 8.82162L6.42247 5.28662L5.24414 6.46495L8.77914 9.99995L5.24414 13.535L6.42247 14.7133L9.95747 11.1783L13.4933 14.7133L14.6716 13.535L11.1366 9.99995L14.6716 6.46495L13.4933 5.28662Z"
                                        fill="#84888C"
                                      />
                                    </svg>
                                  </button>
                                </div>
                                <div className="search">
                                  <Form.Control
                                    type="text"
                                    placeholder="Filter Invoices"
                                    onChange={this.handleFilterInvoiceChange}
                                    value={this.state.filterInvoiceInput}
                                  />
                                </div>
                                <div className="list">
                                  <ul>
                                    {this.state.incompleteFiles.map(
                                      (items, index) => (
                                        <li
                                          onClick={(event: any) =>
                                            this.moveAttachment(
                                              "MoveToExistingInvoice",
                                              items
                                            )
                                          }
                                        >
                                          <div className="date">
                                            {items.createDate}
                                          </div>
                                          <div className="name">
                                            Uploaded by {items.userName}
                                          </div>
                                          <div className="name">
                                            {items.vendor}
                                          </div>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </Dropdown>
                      )}
                      <button
                        type="button"
                        className="btn wht-bg cross"
                        onClick={this.hideBulkselect}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
            <Container
              fluid
              className={
                this.state.formData.vendorID === 0 ||
                this.state.isStateChanged ||
                this.state.formData.incompleteUniqueno > 0 ||
                (this.state.formData.approved.toLowerCase() !==
                  "App".toLowerCase() &&
                  this.state.approveInvoiceStatus?.filter(
                    (e) => e.statusType === "Waiting on Me" && e.status === 0
                  ).length > 0 &&
                  this.state.vendorApproval.toLowerCase() === "app")
                  ? "body-sec viewer-panel"
                  : "body-sec viewer-panel footer-disable"
              }
              ref={this.parentScroll}
            >
              <div className="page-heading pos-sticky underline d-flex">
                <div className="hid-set d-flex align-items-center">
                  {this.state.hotelName}
                </div>
                <div style={{ display: "none" }}>
                  <Button id="btntemp"></Button>
                </div>
                <div className="mr-auto align-items-center">
                  <div className="ttl-status d-flex">
                    <div>
                      {this.state.invoiceUniqueNo > 0 ? "Invoice " : "Invoice "}{" "}
                    </div>
                    {this.state.formData.approved.toLowerCase() !==
                      "App".toLowerCase() &&
                      this.state.formData.uniqueno > 0 && (
                        <div className="invoice-no">
                          <EllipsisWithTooltip placement="bottom">
                            {this.state.formData.invoiceno}
                          </EllipsisWithTooltip>
                        </div>
                      )}
                    {this.state.invoiceBedge.length > 0 && (
                      <>
                        {" "}
                        {
                          <div
                            className={
                              this.state.invoiceUniqueNo > 0 &&
                              this.state.uploadedBy.length > 0
                                ? "edit status-tag " + bedgeClass
                                : "status-tag " + bedgeClass
                            }
                          >
                            {this.state.invoiceBedge}
                          </div>
                        }
                      </>
                    )}
                  </div>

                  <div className="tag-line">
                    {this.state.invoiceUniqueNo > 0 &&
                      this.state.uploadedBy.length > 0 &&
                      this.state.formData.actionType !== "copy" && (
                        <>
                          {"Created on "} {this.state.uploadedDate} {" by "}{" "}
                          {this.state.uploadedBy}
                        </>
                      )}
                  </div>
                </div>

                {this.state.formData.paymenttype.toString().toLowerCase() ===
                  "epay" &&
                  this.state.epayCheckNo !== "" && (
                    <button
                      type="button"
                      className="btn-outline-primary btn btn-primary"
                      onClick={() => this.getEpayCheckImageURL()}
                    >
                      View Check Image
                    </button>
                  )}
                <div className="action-group d-flex">
                  {(this.state.formData.uniqueno > 0 ||
                    this.state.formData.incompleteUniqueno > 0) &&
                    btnlist && (
                      <Dropdown
                        id="btnlist"
                        className="more-action"
                        alignRight
                        onSelect={(e: any) => this.handleSelect(e)}
                      >
                        <Dropdown.Toggle
                          className="btn-outline-primary btn btn-primary more"
                          id="dropdown-more"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                            <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                            <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                          </svg>
                        </Dropdown.Toggle>

                        {this.state.isUnapproveModal && (
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.hideUnApprovalModal(false)
                            }
                          >
                            <div className="PaymentUnApproveModal">
                              <UnApproveModal
                                modalUniqueNos={this.state.invoiceUniqueNo}
                                modalClose={this.hideUnApprovalModal}
                              />
                            </div>
                          </OutsideClickHandler>
                        )}

                        <Dropdown.Menu
                          className={
                            this.state.isPermission !== "Yes"
                              ? "noChild-item"
                              : ""
                          }
                        >
                          {this.state.canFlag === "Yes" &&
                            (this.state.selectedReviewStatus === "" ||
                              this.state.selectedReviewStatus ===
                                "Review Complete") && (
                              <Dropdown.Item
                                eventKey={"Flag for Review"}
                                key={"FlagforReview1"}
                              >
                                {" "}
                                {"Flag for Review"}
                              </Dropdown.Item>
                            )}
                          {this.state.canFlag === "Yes" &&
                            this.state.selectedReviewStatus === "Reviewed" && (
                              <Dropdown.Item
                                eventKey={"Needs Review"}
                                key={"NeedsReview1"}
                              >
                                {" "}
                                {"Needs Review"}
                              </Dropdown.Item>
                            )}

                          {this.state.canReview === "Yes" &&
                            (this.state.selectedReviewStatus ===
                              "Flag for Review" ||
                              this.state.selectedReviewStatus ===
                                "Needs Review") &&
                            (this.state.pageType === "Invoice"
                              ? this.state.formData.uniqueno
                              : this.state.formData.incompleteUniqueno > 0) && (
                              <Dropdown.Item
                                eventKey={"Reviewed"}
                                key={"Reviewed1"}
                              >
                                {" "}
                                {"Reviewed"}
                              </Dropdown.Item>
                            )}

                          {this.state.canFlag === "Yes" &&
                            (this.state.selectedReviewStatus ===
                              "Flag for Review" ||
                              this.state.selectedReviewStatus ===
                                "Needs Review" ||
                              this.state.selectedReviewStatus === "Reviewed") &&
                            (this.state.pageType === "Invoice"
                              ? this.state.formData.uniqueno
                              : this.state.formData.incompleteUniqueno > 0) && (
                              <Dropdown.Item
                                eventKey={"Review Complete"}
                                key={"CompleteReview1"}
                              >
                                {" "}
                                {"Review Complete"}
                              </Dropdown.Item>
                            )}

                          {this.props?.loadFrom !== undefined &&
                            (this.props?.loadFrom.toLowerCase() ===
                              "PaymentPage".toLowerCase() ||
                              this.props?.loadFrom.toLowerCase() ===
                                "invoicecomments") && (
                              <>
                                {this.state.hasUnApproved
                                  .toString()
                                  .toLocaleLowerCase() === "yes" && (
                                  <>
                                    {this.state.approveInvoiceStatus.some(
                                      (item) => item.status === 1
                                    ) && (
                                      <>
                                        {this.state.formData.accPeriodstatus
                                          .toString()
                                          .toLowerCase() === "active" && (
                                          <>
                                            {this.state.formData.actionType ===
                                            "move" ? (
                                              ""
                                            ) : (
                                              <span
                                                className="dropdown-item"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  this.showUnApproveModal()
                                                }
                                              >
                                                {this.state
                                                  .isUnapproveModal && (
                                                  <Spinner
                                                    size="sm"
                                                    className="disabled-area"
                                                    animation="border"
                                                  />
                                                )}{" "}
                                                {"Unapprove"}
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}

                          {this.state.pageType !== "INCOMPLETEINVOICE" &&
                            this.state.invoiceUniqueNo > 0 && (
                              <Dropdown.Item
                                onClick={() => this.showHideChangeLogModal()}
                                eventKey={"changelog"}
                                key={"changelog"}
                              >
                                {" "}
                                {"Change Log"}{" "}
                              </Dropdown.Item>
                            )}

                          {this.state.invoiceUniqueNo > 0 &&
                            this.state.CopyisPermission === "Yes" &&
                            this.state.formData.actionType.length === 0 &&
                            this.state.formData.vendorStatus
                              .toString()
                              .toLowerCase() === "active" &&
                            this.state.formData.ispayment !== "Yes" &&
                            !this.state.isExtractionBtnClicked && (
                              <Dropdown.Item eventKey={"copy"} key={"copy"}>
                                {" "}
                                {"Copy"}{" "}
                              </Dropdown.Item>
                            )}

                          {!isBedgeProcessing &&
                            this.state.invoiceUniqueNo > 0 &&
                            this.state.formData.uniqueno > 0 &&
                            this.state.formData.accPeriodstatus
                              .toString()
                              .toLowerCase() === "active" &&
                            this.state.formData.adj.toString() !== "Y" &&
                            this.state.formData.concilestatus
                              .toString()
                              .toLowerCase() !== "yes" &&
                            this.state.isDelete.toString() === "Yes" &&
                            this.state.formData.checkNo === "" &&
                            this.state.digitalAchStatus != "Yes" &&
                            this.state.formData.actionType.length === 0 &&
                            this.state.formData.readyForPayment !== "Paid" && (
                              <>
                                <Dropdown.Item
                                  className={
                                    this.state.isError === "NotEdit"
                                      ? "isHide"
                                      : ""
                                  }
                                  eventKey={"delete"}
                                  key={"delete"}
                                >
                                  {"Delete"}
                                </Dropdown.Item>
                              </>
                            )}

                          {!isBedgeProcessing &&
                            this.state.invoiceUniqueNo > 0 &&
                            this.state.isPermission === "Yes" &&
                            this.state.formData.incompleteUniqueno > 0 &&
                            this.state.formData.actionType.length === 0 && (
                              <Dropdown.Item
                                className={
                                  this.state.isError === "NotEdit"
                                    ? "isHide"
                                    : ""
                                }
                                eventKey={"delete"}
                                key={"delete"}
                              >
                                {" "}
                                {"Delete"}{" "}
                              </Dropdown.Item>
                            )}
                          <React.Fragment>
                            {!isBedgeProcessing &&
                              this.state.invoiceUniqueNo > 0 &&
                              this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y" &&
                              this.state.formData.concilestatus
                                .toString()
                                .toLowerCase() === "no" &&
                              this.state.formData.ispayment !== "Yes" &&
                              this.state.isMovePermission.toString() ===
                                "Yes" &&
                              this.state.formData.vendorStatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.checkNo === "" &&
                              this.state.digitalAchStatus != "Yes" &&
                              this.state.formData.actionType.length === 0 &&
                              this.state.formData.readyForPayment !== "Paid" &&
                              !this.state.isExtractionBtnClicked && (
                                <Dropdown.Item
                                  className={
                                    this.state.isError === "NotEdit"
                                      ? "isHide"
                                      : this.state.formData.paymenttype
                                          .toString()
                                          .toLowerCase() ===
                                          "Digital ACH".toLowerCase() &&
                                        this.state.formData.approved.toLowerCase() ===
                                          "App".toLowerCase()
                                      ? "isHide"
                                      : ""
                                  }
                                  eventKey={"move"}
                                  key={"move"}
                                >
                                  {" "}
                                  {"Move"}{" "}
                                </Dropdown.Item>
                              )}
                          </React.Fragment>
                          {/* )} */}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  {Number(this.state.formData.vendorID) > 0 &&
                    (this.state.invoiceUniqueNo === 0 ||
                      this.state.formData.actionType === "copy") &&
                    this.state.statusTypeList.length > 0 && (
                      <Dropdown
                        className={
                          this.state.isError === "NotEdit"
                            ? "disabled-area more-action"
                            : "more-action"
                        }
                        alignRight
                        onSelect={(e: any) => this.handleSelect(e)}
                      >
                        <Dropdown.Toggle
                          className="btn-outline-primary btn btn-primary more"
                          id="dropdown-more"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                            <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                            <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                          </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {this.state.canFlag === "Yes" &&
                            (this.state.selectedReviewStatus === "" ||
                              this.state.selectedReviewStatus ===
                                "Review Complete") && (
                              <Dropdown.Item
                                eventKey={"Flag for Review"}
                                key={"FlagforReview2"}
                              >
                                {" "}
                                {"Flag for Review"}
                              </Dropdown.Item>
                            )}
                          {this.state.canFlag === "Yes" &&
                            this.state.formData.actionType != "copy" &&
                            this.state.selectedReviewStatus === "Reviewed" && (
                              <Dropdown.Item
                                eventKey={"Needs Review"}
                                key={"NeedsReview2"}
                              >
                                {" "}
                                {"Needs Review"}
                              </Dropdown.Item>
                            )}

                          {this.state.canReview === "Yes" &&
                            this.state.formData.actionType != "copy" &&
                            (this.state.selectedReviewStatus ===
                              "Flag for Review" ||
                              this.state.selectedReviewStatus ===
                                "Needs Review") &&
                            (this.state.pageType === "Invoice"
                              ? this.state.formData.uniqueno
                              : this.state.formData.incompleteUniqueno > 0) && (
                              <Dropdown.Item
                                eventKey={"Reviewed"}
                                key={"Reviewed2"}
                              >
                                {" "}
                                {"Reviewed"}
                              </Dropdown.Item>
                            )}

                          {this.state.canFlag === "Yes" &&
                            this.state.formData.actionType != "copy" &&
                            (this.state.selectedReviewStatus ===
                              "Flag for Review" ||
                              this.state.selectedReviewStatus ===
                                "Needs Review" ||
                              this.state.selectedReviewStatus === "Reviewed") &&
                            (this.state.pageType === "Invoice"
                              ? this.state.formData.uniqueno
                              : this.state.formData.incompleteUniqueno > 0) && (
                              <Dropdown.Item
                                eventKey={"Review Complete"}
                                key={"CompleteReview2"}
                              >
                                {" "}
                                {"Review Complete"}
                              </Dropdown.Item>
                            )}
                          {this.state.isCCImportPermission.toString() ===
                            "Yes" &&
                            this.state.formData.actionType != "copy" && (
                              <Dropdown.Item eventKey="ImportStatement">
                                Import Statement
                              </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                    
                  <button
                    type="button"
                    className="btn wht-bg cross"
                    onClick={() =>
                      this.closeSlideOut(this.state.invoiceUniqueNo)
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                        fill="#84888C"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              {/* Start Banner Section */}
              <div className="top-banner-sec pos-sticky">
                {this.state.showReviewBanner && (
                  <div
                    className={`banner margin d-flex align-items-center ${
                      this.state.isReviewed ? "reviewed orange-bg" : "blue-bg"
                    }`}
                  >
                    <div className="flag-icon">
                      <svg
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
                      </svg>
                    </div>
                    {/* <div>{this.state.isReviewed ? `Reviewed by ${'Todd.Book'}` : `Flagged for Review by ${'Meghan.Dunhagan'}`}</div> */}
                    <div>{this.state.reviewCurrentDescription}</div>
                    {this.state.statusTypeList.length > 0 && (
                      <Dropdown className="custom-selectbox ml-auto" alignRight>
                        <Dropdown.Toggle
                          id="dropdownStatusList"
                          className="d-flex align-items-center"
                        >
                          <div className="value">
                            <EllipsisWithTooltip placement="bottom">
                              {" "}
                              {"Change Status"}
                            </EllipsisWithTooltip>
                          </div>

                          <div className="arrow ml-auto">
                            <svg
                              width="10"
                              height="7"
                              viewBox="0 0 10 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z"
                                fill="#84888C"
                              />
                            </svg>
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {this.state.statusTypeList.map(
                            (item: any, index: any) => (
                              <Dropdown.Item
                                className={`d-flex align-items-center ${
                                  item.eventName == "Flag for Review"
                                    ? "flgForReview"
                                    : ""
                                } ${
                                  item.eventName == "delete" ? "delete" : ""
                                }`}
                                key={item.eventName}
                                eventKey={item.name}
                                onClick={() =>
                                  this.handleReviewStatus(item.eventName)
                                }
                              >
                                <EllipsisWithTooltip placement="bottom">
                                  {item.name}
                                </EllipsisWithTooltip>
                                {item.eventName == "Flag for Review" && (
                                  <div className="flag-icon ml-auto">
                                    <svg
                                      width="16"
                                      height="18"
                                      viewBox="0 0 16 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
                                    </svg>
                                  </div>
                                )}
                              </Dropdown.Item>
                            )
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                )}

                {this.state.formData.uniqueno > 0 &&
                  this.state.vendorApproval.toLowerCase() !== "app" && (
                    <div className="banner orange-bg margin">
                      <div className="mr-auto">
                        This invoice is{" "}
                        <span className="bold">pending vendor approval.</span>{" "}
                      </div>
                    </div>
                  )}

                {this.state.LinemapData.length > 0 &&
                  this.state.mapData.length > 0 && (
                    <>
                      {(this.state.LinemapData.filter(
                        (x) => x.mappedField === ""
                      ).length > 0 ||
                        this.state.mapData.filter((x) => x.mappedField === "")
                          .length > 0) && (
                        <>
                          {this.state.isOpenViewer && (
                            <div className="banner blue-bg margin d-flex align-items-center">
                              <div className="mr-auto">
                                We were not able to extract one or more fields
                                from the attachment.
                              </div>
                              {this.state.isMappingSettingBanner && (
                                <Button
                                  variant="primary"
                                  type="button"
                                  className="btn-ghost"
                                  onClick={() => this.adjustMapping()}
                                >
                                  Mapping Settings
                                </Button>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
              </div>
              <div>
                <div className="filter-sec">
                  <div className="vendor-type-sec d-flex">
                    <div className="d-flex flex-wrap mr-auto">
                      <Form.Group controlId="vendorName">
                        <div
                          className={
                            (this.state.isPermission === "No" &&
                              this.state.isInvoiceEntry === "No") ||
                            this.state.isError === "NotEdit"
                              ? "parent"
                              : ""
                          }
                        >
                          <Form.Label
                            className={
                              this.state.isInvoiceEntry === "Yes" &&
                              this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y" &&
                              this.state.formData.ispayment === "No" &&
                              this.state.formData.concilestatus
                                .toString()
                                .toLowerCase() === "no"
                                ? ""
                                : "disabled-area"
                            }
                          >
                            Vendor
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className={`${
                              iSePayEntry && isStatusPaidSent && isePayMethod
                                ? "setVendorW"
                                : ""
                            } type-head`}
                          >
                            {this.state.hotelValue !== -1 && (
                              <>
                                {this.state.isvendorShow && (
                                  <VendorSearch
                                    ref={this.vendorSearch}
                                    updateVendorList={this.updateVendorList}
                                    HID={this.state.hotelValue}
                                    handleVendorChange={
                                      this.showVendorChangeAlert
                                    }
                                    pageName={this.pageName}
                                    disabled={
                                      isBedgeProcessing
                                        ? true
                                        : this.state.isInvoiceEntry === "Yes" &&
                                          this.state.formData.accPeriodstatus
                                            .toString()
                                            .toLowerCase() === "active" &&
                                          this.state.formData.adj.toString() !==
                                            "Y" &&
                                          this.state.formData.concilestatus
                                            .toString()
                                            .toLowerCase() === "no"
                                        ? this.state.formData
                                            .readyForPayment === "Paid" ||
                                          this.state.formData.checkNo !== "" ||
                                          this.state.digitalAchStatus ===
                                            "Yes" ||
                                          this.state.formData.concilestatus
                                            .toString()
                                            .toLowerCase() === "yes" ||
                                          this.state.formData.ispayment ===
                                            "Yes" ||
                                          this.state.isError === "NotEdit"
                                          ? true
                                          : false
                                        : true
                                    }
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                        {this.state.formData.vendorID > 0 &&
                          this.state.isPerviousPermission === "Yes" && (
                            <div
                              className="transactionsLinks"
                              onClick={this.Previoustransactions}
                            >
                              {this.state.isPreviousTransactions
                                ? "Hide Previous Transactions"
                                : "Previous Transactions"}
                            </div>
                          )}
                      </Form.Group>
                      <div
                        className={
                          (this.state.isPermission === "No" &&
                            this.state.isInvoiceEntry === "No") ||
                          this.state.isError === "NotEdit"
                            ? "disabled-area parent"
                            : ""
                        }
                      >
                        <div
                          className={
                            this.state.isPermission === "Yes" &&
                            this.state.formData.vendorID > 0
                              ? "d-flex mr-auto"
                              : "disabled-area d-flex"
                          }
                        >
                          <div className="d-flex">
                            <Form.Group
                              controlId="type"
                              className={
                                this.state.formData.vendorID === 0
                                  ? "disabled-area"
                                  : (this.state.formData.checkNo.length > 0 &&
                                      this.state.pageType !==
                                        "IncompleteInvoice" &&
                                      this.state.invoiceUniqueNo > 0) ||
                                    this.state.digitalAchStatus === "Yes" ||
                                    this.state.formData.readyForPayment ===
                                      "Paid"
                                  ? "disabled-area"
                                  : this.state.formData.adj.toString() !==
                                      "Y" &&
                                    this.state.formData.concilestatus
                                      .toString()
                                      .toLowerCase() === "no"
                                  ? ""
                                  : "disabled-area"
                              }
                            >
                              <Form.Label>Type</Form.Label>
                              <div className="single-select type">
                                {this.state.paymentType.length > 0 && (
                                  <>
                                    <SingleDropdownListWithoutSearch
                                      id={"paymentType"}
                                      itemList={this.state.paymentType}
                                      handleSelectedItem={this.showTypeChangeAlert.bind(
                                        this,
                                        5 + "_" + 0
                                      )}
                                      defaultItem={
                                        iSePayEntry &&
                                        isStatusPaidSent &&
                                        isePayMethod
                                          ? this.state.defaultpaymentType +
                                            " - " +
                                            this.state.ePayMethod
                                          : this.state.defaultpaymentType.toLowerCase() ===
                                            "ach"
                                          ? "Manual ACH"
                                          : this.state.defaultpaymentType
                                      }
                                      defaultText={"Type"}
                                      defaultName={
                                        iSePayEntry &&
                                        isStatusPaidSent &&
                                        isePayMethod
                                          ? this.state.defaultpaymentType +
                                            " - " +
                                            this.state.ePayMethod
                                          : this.state.defaultpaymentType.toLowerCase() ===
                                            "ach"
                                          ? "Manual ACH"
                                          : this.state.defaultpaymentType
                                      }
                                      controlID="5"
                                      isbank={this.state.isbank}
                                      disabled={
                                        isBedgeProcessing || isBankSyncInvoice
                                          ? true
                                          : this.state.formData
                                              .readyForPayment === "Paid"
                                          ? true
                                          : (this.state.formData.checkNo
                                              .length > 0 &&
                                              this.props.pageType !==
                                                "IncompleteInvoice" &&
                                              this.state.invoiceUniqueNo > 0) ||
                                            this.state.digitalAchStatus ===
                                              "Yes"
                                          ? true
                                          : this.state.formData.adj.toString() !==
                                              "Y" &&
                                            this.state.formData.concilestatus
                                              .toString()
                                              .toLowerCase() === "no"
                                          ? false
                                          : true
                                      }
                                    />
                                    {iSePayEntry &&
                                      isStatusPaidSent &&
                                      isePayMethod && (
                                        <div className="forPaymentSent">
                                          Payment Sent:{" "}
                                          {this.state.paymentSentDT}
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                              {isDiffrentPtype && (
                                <div
                                  className="transactionsLinks"
                                  onClick={this.handlePaymentSave}
                                >
                                  Update Default Method
                                </div>
                              )}
                            </Form.Group>

                            {this.state.formData.readyForPayment !== "Paid" &&
                              (this.state.formData.uniqueno > 0 ||
                                (this.state.formData.incompleteUniqueno == 0 &&
                                  this.state.formData.vendorID > 0) ||
                                this.state.formData.incompleteUniqueno >= 0) &&
                              this.state.isPermission === "Yes" &&
                              (this.state.formData.paymenttype.toLowerCase() ===
                                "ACH".toLowerCase() ||
                                this.state.formData.paymenttype.toLowerCase() ===
                                  "manual ach" ||
                                this.state.formData.paymenttype.toLowerCase() ===
                                  "Credit Card".toLowerCase()) && (
                                <React.Fragment>
                                  {this.state.vendorApproval.toLowerCase() ===
                                    "app" && (
                                    <Form.Group
                                      className="switchWithLabel"
                                      controlId="markAsPaid"
                                    >
                                      <Form.Label>Mark as Paid</Form.Label>
                                      <Form.Check
                                        type="switch"
                                        id="mark-as-paid"
                                        label=""
                                        checked={
                                          this.state.formData.isPaid.toLowerCase() ===
                                          "paid"
                                        }
                                        onChange={(e: any) =>
                                          this.onChangeMarkAsPaidtoggle(e)
                                        }
                                        disabled={
                                          isBankSyncInvoice
                                            ? true
                                            : this.state.formData.vendorID === 0
                                        }
                                      />
                                    </Form.Group>
                                  )}

                                  {/* {this.state.formData.isPaid.toLowerCase() ===
                                    "Paid".toLowerCase() &&
                                    this.state.isError !== "NotEdit" && (
                                      <Button
                                        variant="primary"
                                        type="button"
                                        className="mark-paid btn btn-primary btn-discard"
                                        onClick={() =>
                                          this.handleSelect("unpaid")
                                        }
                                      >
                                        Mark as Unpaid
                                      </Button>
                                    )} */}
                                </React.Fragment>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        (this.state.isPermission === "No" &&
                          this.state.isInvoiceEntry === "No") ||
                        this.state.formData.vendorID === 0 ||
                        this.state.isError === "NotEdit"
                          ? "disabled-area parent"
                          : ""
                      }
                    >
                      <div className="total-amount inpute">
                        <Form.Group controlId="totalAmt">
                          <div className="single-select">
                            <div
                              className={
                                (this.state.formData.checkNo.length > 0 &&
                                  this.state.pageType !== "IncompleteInvoice" &&
                                  this.state.invoiceUniqueNo > 0) ||
                                (this.state.digitalAchStatus === "Yes" &&
                                  this.state.formData.readyForPayment ===
                                    "Paid") ||
                                (this.state.formData.checkNo.length > 0 &&
                                  this.state.formData.readyForPayment ===
                                    "Paid")
                                  ? "label disabled-area"
                                  : this.state.formData.accPeriodstatus
                                      .toString()
                                      .toLowerCase() === "active" &&
                                    this.state.formData.adj.toString() !==
                                      "Y" &&
                                    this.state.formData.concilestatus
                                      .toString()
                                      .toLowerCase() === "no"
                                  ? "label margin-Bottom"
                                  : "label margin-Bottom disabled-area"
                              }
                            >
                              Amount
                            </div>
                            <Form.Control
                              type="text"
                              placeholder="0.00"
                              id="txttotalAmt"
                              value={this.state.formData.transactionTotal}
                              onChange={(event: any) =>
                                this.handleChange(event, "totalAmt")
                              }
                              onBlur={this.handleTotalAmount}
                              onFocus={this.onAmountFocus}
                              pattern="[+-]?\d+(?:[.,]\d+)?"
                              maxLength={20}
                              disabled={
                                isBankSyncInvoice
                                  ? true
                                  : isBedgeProcessing
                                  ? true
                                  : (this.state.formData.paymenttype
                                      .toString()
                                      .toLowerCase() === "epay" &&
                                      this.state.formData.readyForPayment
                                        .toString()
                                        .toLowerCase() === "paid") ||
                                    (this.state.formData.checkNo.length > 0 &&
                                      this.state.pageType !==
                                        "IncompleteInvoice" &&
                                      this.state.invoiceUniqueNo > 0) ||
                                    this.state.digitalAchStatus === "Yes" ||
                                    (this.state.formData.checkNo.length > 0 &&
                                      this.state.formData.readyForPayment ===
                                        "Paid") ||
                                    this.state.formData.ispayment === "Yes"
                                  ? true
                                  : this.state.formData.accPeriodstatus
                                      .toString()
                                      .toLowerCase() === "active" &&
                                    this.state.formData.adj.toString() !==
                                      "Y" &&
                                    this.state.formData.concilestatus
                                      .toString()
                                      .toLowerCase() === "no"
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  {this.state.isPreviousTransactions && (
                    <div className="PreviousTransactions">
                      <BootstrapTable
                        keyField="uniqueNo"
                        data={this.state.previousTransactionsData.filter(
                          (x) =>
                            x.mainType === 1 &&
                            x.uniqueNo !=
                              (this.state.formData.actionType === "copy"
                                ? 0
                                : this.state.formData.uniqueno)
                        )}
                        columns={previousTransactionsColumns}
                        expandRow={expandSplitRow}
                      />
                      <button
                        type="button"
                        className="btn wht-bg link-btn"
                        onClick={this.loadPreviousData}
                      >
                        Show More
                      </button>
                    </div>
                  )}
                  <div
                    className={
                      (this.state.isPermission === "No" &&
                        this.state.isInvoiceEntry === "No") ||
                      this.state.isError === "NotEdit"
                        ? "disabled-area parent"
                        : ""
                    }
                  >
                    <div
                      className={
                        this.state.isPermission === "No" &&
                        this.state.isInvoiceEntry === "No"
                          ? "disabled-area d-flex flex-wrap"
                          : "d-flex flex-wrap"
                      }
                    >
                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y"
                              ? this.state.digitalAchStatus === "Yes"
                                ? "disabled-area"
                                : ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        <Form.Group
                          className="rm-bottom-margin"
                          controlId="invoiceno"
                        >
                          <Form.Label>Invoice Number</Form.Label>
                          <div className="date-picker calender-picker">
                            <Form.Control
                              type="text"
                              placeholder="Enter Invoice Number"
                              id="txtInvoice"
                              className={
                                this.state.isduplicateInvoice ||
                                this.state.isduplicateEHIDInvoice
                                  ? "invalid-Invoice"
                                  : ""
                              }
                              value={this.state.formData.invoiceno}
                              onChange={(event: any) =>
                                this.handleChange(event, "invoiceno")
                              }
                              onBlur={(e: any) =>
                                this.handleDuplicateInvoice(e, 0)
                              }
                              maxLength={60}
                              autoComplete="off"
                              disabled={isBedgeProcessing}
                            />
                          </div>
                        </Form.Group>
                      </div>

                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y"
                              ? this.state.digitalAchStatus === "Yes"
                                ? "disabled-area"
                                : ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        {isMrkPdTgglOn && (isCC || isMach) && (
                          <Form.Group
                            controlId="account"
                            className={
                              this.state.formData.vendorID === 0
                                ? "disabled-area"
                                : (this.state.formData.checkNo.length > 0 &&
                                    this.state.pageType !==
                                      "IncompleteInvoice" &&
                                    this.state.invoiceUniqueNo > 0) ||
                                  this.state.digitalAchStatus === "Yes" ||
                                  this.state.formData.readyForPayment === "Paid"
                                ? "disabled-area"
                                : this.state.formData.adj.toString() !== "Y" &&
                                  this.state.formData.concilestatus
                                    .toString()
                                    .toLowerCase() === "no"
                                ? ""
                                : "disabled-area"
                            }
                          >
                            <Form.Label>Account</Form.Label>
                            {this.state.isAccount && (
                              <div className="single-select">
                                <SingleDropdownListWithoutSearch
                                  id={"accoutlistmodal"}
                                  itemList={this.state.accountlist}
                                  handleSelectedItem={this.handleSelectedItem.bind(
                                    this,
                                    7 + "_" + 0
                                  )}
                                  defaultItem={this.state.defaultaccountType}
                                  defaultText={"Account"}
                                  defaultName={this.state.defaultaccountType}
                                  controlID="7"
                                  disabled={
                                    isBankSyncInvoice
                                      ? true
                                      : this.state.accountlist.length === 0 ||
                                        this.state.formData.readyForPayment ==
                                          "Paid" ||
                                        this.state.formData.accPeriodstatus
                                          .toString()
                                          .toLowerCase() !== "active"
                                  }
                                />
                              </div>
                            )}
                            {!this.state.isAccount && (
                              <div className="single-select">
                                <Dropdown className="more-action bg-blue single-select-image">
                                  <Dropdown.Toggle
                                    id="static-account"
                                    className="filter-btn"
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="txt-area">
                                        <EllipsisWithTooltip placement="bottom">
                                          {"Select Account"}
                                        </EllipsisWithTooltip>
                                      </div>
                                      <div className="drop-arrow ml-0 d-flex">
                                        <FiChevronDown />
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                </Dropdown>
                              </div>
                            )}
                          </Form.Group>
                        )}
                      </div>

                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y"
                              ? ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        <Form.Group
                          className="rm-bottom-margin"
                          controlId="amount"
                        >
                          <Form.Label>Invoice Date</Form.Label>
                          <div className="date-picker calender-picker">
                            <div
                              className="drop-arrow"
                              onClick={(event: any) =>
                                this.handleDatePicker(event, this.trDate)
                              }
                            >
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                  fill="#3F4347"
                                />
                              </svg>
                            </div>
                            <DatePicker
                              ref={this.trDate}
                              id="txttrDate"
                              tabIndex={this.state.tabEnable}
                              className="form-control"
                              placeholderText={"MM/DD/YY"}
                              dateFormat="MM/dd/yy"
                              highlightDates={
                                this.state.formData.transcationDate === null &&
                                highlightDates
                              }
                              selected={
                                this.state.formData.transcationDate === null
                                  ? ""
                                  : new Date(
                                      this.state.formData.transcationDate
                                    )
                              }
                              onChange={(event: any) =>
                                this.handleChange(event, "trDate")
                              }
                              onKeyDown={(e: any) =>
                                this.onTAB("txttrDate-1", 0, e)
                              }
                              autoComplete="off"
                              disabled={isBedgeProcessing}
                            />
                          </div>
                        </Form.Group>
                      </div>
                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y"
                              ? ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        <Form.Group
                          className="rm-bottom-margin"
                          controlId="amount"
                        >
                          <Form.Label>Due Date</Form.Label>
                          <div className="date-picker calender-picker right-align-due-date">
                            <div
                              className="drop-arrow"
                              onClick={(event: any) =>
                                this.handleDatePicker(event, this.trdueDate)
                              }
                            >
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                  fill="#3F4347"
                                />
                              </svg>
                            </div>
                            <DatePicker
                              id="txtdueDate"
                              ref={this.trdueDate}
                              tabIndex={this.state.tabEnable}
                              className="form-control"
                              placeholderText={"MM/DD/YY"}
                              dateFormat="MM/dd/yy"
                              selected={
                                this.state.formData.dueDate === null
                                  ? ""
                                  : new Date(this.state.formData.dueDate)
                              }
                              onChange={(event: any) =>
                                this.handleChange(event, "dueDate")
                              }
                              onKeyDown={(e: any) =>
                                this.onTAB("txtdueDate-1", 0, e)
                              }
                              // preventOpenOnFocus={true}
                              shouldCloseOnSelect={true}
                              autoComplete="off"
                              disabled={isBedgeProcessing}
                            />
                          </div>
                        </Form.Group>
                      </div>

                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0 &&
                          (this.state.formData.readyForPayment == "Paid" ||
                            this.state.formData.isPaid.toLowerCase() ===
                              "Paid".toLowerCase())
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active" &&
                              this.state.formData.adj.toString() !== "Y" &&
                              this.state.formData.concilestatus
                                .toString()
                                .toLowerCase() === "no"
                              ? ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        {(isMach || isCC) &&
                          (this.state.formData.readyForPayment == "Paid" ||
                            this.state.formData.isPaid.toLowerCase() ===
                              "Paid".toLowerCase()) && (
                            <Form.Group
                              className="rm-bottom-margin"
                              controlId="amount"
                            >
                              <Form.Label>Transaction Date</Form.Label>
                              <div className="date-picker calender-picker right-align">
                                <div
                                  className="drop-arrow"
                                  onClick={(event: any) =>
                                    this.handleDatePicker(
                                      event,
                                      this.trpaymentdate
                                    )
                                  }
                                >
                                  <svg
                                    width="8"
                                    height="6"
                                    viewBox="0 0 8 6"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                      fill="#3F4347"
                                    />
                                  </svg>
                                </div>
                                <DatePicker
                                  id="paymentdate"
                                  ref={this.trpaymentdate}
                                  tabIndex={this.state.tabEnable}
                                  className="form-control"
                                  placeholderText={"MM/DD/YY"}
                                  dateFormat="MM/dd/yy"
                                  selected={
                                    this.state.formData.gDate === null
                                      ? ""
                                      : new Date(this.state.formData.gDate)
                                  }
                                  onChange={(event: any) =>
                                    this.handleChange(event, "gDate")
                                  }
                                  onKeyDown={(e: any) =>
                                    this.onTAB("paymentdate-1", 0, e)
                                  }
                                  autoComplete="off"
                                  disabled={
                                    this.state.formData.readyForPayment ==
                                    "Paid"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Form.Group>
                          )}
                      </div>
                      <div
                        className={
                          this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                            ? this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() === "active"
                              ? isBedgeProcessing
                                ? "disabled-area"
                                : ""
                              : "disabled-area"
                            : "disabled-area"
                        }
                      >
                        {this.state.accPeriodList.length > 0 && (
                          <div
                            className={
                              this.state.isPermission === "No" ||
                              this.state.isError === "NotEdit" ||
                              this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() !== "active"
                                ? //  || this.state.formData.adj
                                  // .toString()
                                  // .toLowerCase() === "y"
                                  "disabled-area"
                                : ""
                            }
                          >
                            <Form.Group
                              className="rm-bottom-margin"
                              controlId="vendorName"
                            >
                              <Form.Label>Accounting Period</Form.Label>
                              <div className="single-select">
                                <SingleDropdownListWithoutSearch
                                  id={"accountingPeriod"}
                                  tabIndex={this.state.tabEnable}
                                  itemList={this.state.accPeriodList}
                                  handleSelectedItem={this.handleSelectedItem.bind(
                                    this,
                                    6 + "_" + 0
                                  )}
                                  defaultItem={
                                    this.state.defaultaccountingPeriod
                                  }
                                  defaultText={"Accouting Period"}
                                  defaultName={
                                    this.state.defaultaccountingPeriod
                                  }
                                  controlID="6"
                                  disabled={
                                    this.state.isPermission === "No" ||
                                    this.state.isError === "NotEdit" ||
                                    this.state.formData.accPeriodstatus
                                      .toString()
                                      .toLowerCase() !== "active"
                                      ? // || this.state.formData.adj
                                        // .toString()
                                        // .toLowerCase() === "y"
                                        true
                                      : false
                                  }
                                />
                              </div>
                            </Form.Group>
                          </div>
                        )}

                        {this.state.accPeriodList.length === 0 && (
                          <Form.Group
                            className="rm-bottom-margin"
                            controlId="vendorName"
                          >
                            <Form.Label>Accounting Period</Form.Label>
                            <div className="single-select">
                              <SingleDropdownListWithoutSearch
                                id={"accountingPeriod"}
                                tabIndex={this.state.tabEnable}
                                itemList={this.state.accPeriodList}
                                handleSelectedItem={this.handleSelectedItem.bind(
                                  this,
                                  6 + "_" + 0
                                )}
                                defaultItem={this.state.defaultaccountingPeriod}
                                defaultText={"Accouting Period"}
                                defaultName={this.state.defaultaccountingPeriod}
                                controlID="6"
                              />
                            </div>
                          </Form.Group>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      this.state.isPermission === "No" ||
                      this.state.formData.vendorID <= 0 ||
                      this.state.isError === "NotEdit"
                        ? "disabled-area notes-section"
                        : "notes-section"
                    }
                  >
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        className={"notes-form-control"}
                        ref={this.notesTextAreaRef}
                        id="txtNotes"
                        as="textarea"
                        // rows={3}
                        value={this.state.formData.internalNotes}
                        maxLength={99}
                        onChange={(event: any) =>
                          this.handleChange(event, "notes")
                        }
                        disabled={
                          isBedgeProcessing
                            ? true
                            : this.state.formData.adj.toString() === "Y" ||
                              this.state.isPermission === "No" ||
                              this.state.formData.vendorID <= 0 ||
                              this.state.isError === "NotEdit" ||
                              this.state.formData.accPeriodstatus
                                .toString()
                                .toLowerCase() != "active"
                            ? true
                            : false
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="invoice-approval">
                  {this.state.formData.entryType.toLowerCase() ===
                    "INVOICE".toLowerCase() &&
                    this.state.formData.uniqueno > 0 &&
                    this.state.formData.actionType !== "copy" && (
                      <>
                        {this.state.approveInvoiceStatus.length > 0 && (
                          <Accordion
                            defaultActiveKey={
                              this.state.formData.approved.toLowerCase() !==
                              "App".toLowerCase()
                                ? "0"
                                : ""
                            }
                          >
                            <Card>
                              <Card.Header>
                                <Accordion.Toggle
                                  className={
                                    this.state.activeToggle
                                      ? "activeToggle"
                                      : ""
                                  }
                                  onClick={this.toggleClass}
                                  as={Button}
                                  variant="link"
                                  eventKey="0"
                                >
                                  <div className="d-flex">
                                    <div className="mr-auto">Approvals</div>
                                    <div>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M6.29297 10.707L12 16.414L17.707 10.707L16.293 9.293L12 13.586L7.70697 9.293L6.29297 10.707Z"
                                          fill="#84888C"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </Accordion.Toggle>
                              </Card.Header>
                              <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                  <ul>
                                    {this.state.approveInvoiceStatus?.map(
                                      (item: any, index: any) => {
                                        return (
                                          <li
                                            className="d-flex align-items-center"
                                            key={index}
                                          >
                                            <div
                                              className={`badge
                                                ${
                                                  item.statusType1 ===
                                                  "Waiting on Me"
                                                    ? "orange"
                                                    : ""
                                                }
                                                ${
                                                  item.status === 1
                                                    ? "green"
                                                    : ""
                                                }`}
                                            >
                                              {item.status === 0
                                                ? item.statusType1 ===
                                                  "Waiting on Me"
                                                  ? "Waiting on Me"
                                                  : "Waiting on Others"
                                                : "Completed"}
                                            </div>
                                            <div
                                              className={
                                                item.status === 1
                                                  ? "completed"
                                                  : ""
                                              }
                                            >
                                              {item.ruleName}
                                            </div>
                                          </li>
                                        );
                                      }
                                    )}
                                  </ul>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        )}
                      </>
                    )}
                </div>

                {this.state.associatedPayments.length > 0 &&
                  this.state.formData.uniqueno > 0 &&
                  (isCC || isMach) &&
                  this.state.formData.readyForPayment !== "Paid" &&
                  this.state.formData.isPaid === "Paid" &&
                  this.state.formData.actionType !== "copy" &&
                  this.state.isPaidDB.toLowerCase() === "paid" && (
                    <div className="transactions-list associated-invoices">
                      <div className="sec-ttl">Associated Payments</div>
                      <BootstrapTable
                        keyField="paidid"
                        data={this.state.associatedPayments}
                        columns={associatedPaymentsColumns}
                      />
                    </div>
                  )}

                {this.state.associatedInvoice.length > 0 &&
                  this.state.formData.readyForPayment == "Paid" &&
                  this.state.formData.actionType !== "copy" && (
                    <div className="transactions-list associated-invoices">
                      <div className="sec-ttl">Associated Payments</div>
                      <BootstrapTable
                        keyField="id"
                        data={this.state.associatedInvoice}
                        columns={associatedInvoicesColumns}
                        rowEvents={this.rowEvents}
                      />
                    </div>
                  )}

                <div>
                  <div
                    className={
                      this.state.isError === "NotEdit" ||
                      this.state.formData.ispayment === "Yes"
                        ? "disabled-area"
                        : this.state.isPermission === "Yes" &&
                          this.state.formData.vendorID > 0
                        ? ""
                        : "disabled-area"
                    }
                  >
                    <>
                      <div className="transactions-list inpute">
                        {this.state.isAllIncomplete && (
                          <div className="toggle-button entry">
                            <ButtonGroup aria-label="Basic example">
                              <ToggleButtonGroup
                                type="radio"
                                name="options"
                                value={this.state.defaultEntry}
                                onChange={toggleEntrySwitch}
                              >
                                <ToggleButton value={"all-entry"}>
                                  All
                                </ToggleButton>
                                {!isIncompleteDisabled && (
                                  <ToggleButton value={"incomplete-entry"}>
                                    Incomplete
                                  </ToggleButton>
                                )}
                                {isIncompleteDisabled && (
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={"incompleteSplitRows"}>
                                        {"There are no incomplete split rows."}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      type="button"
                                      className="btn-outline-primary disabled"
                                    >
                                      Incomplete
                                    </Button>
                                  </OverlayTrigger>
                                )}
                              </ToggleButtonGroup>
                            </ButtonGroup>
                          </div>
                        )}
                        {this.state.transactionsColumns.length > 0 && (
                          <div className="split-assign-coa">
                            <BootstrapTable
                              id="tblSplit"
                              keyField="rno"
                              data={this.state.splitData}
                              rowClasses={this.hideRowClass}
                              columns={this.state.transactionsColumns}
                              selectRow={selectRow}
                              headerClasses={
                                this.state.showAssignCOABtn
                                  ? "assignCoaHeader"
                                  : ""
                              }
                            />
                            {this.state.showAssignCOABtn && (
                              <div className="d-flex assignCoa action-grp align-items-center">
                                <Button
                                  type="button"
                                  className="btn-outline-primary more"
                                  onClick={this.showBulkSelectCoaModal}
                                >
                                  Assign COA
                                </Button>
                                <Button
                                  type="button"
                                  className="btn-outline-primary more"
                                  onClick={this.deleteBulkSelectedSplitRows}
                                >
                                  Delete
                                </Button>
                              </div>
                            )}
                          </div>
                        )}
                        <div className="d-flex action-btn align-items-center">
                          <Button
                            type="button"
                            className="btn-ghost mr-auto"
                            onClick={this.handleNewRow}
                            disabled={
                              isBedgeProcessing
                                ? true
                                : this.state.formData.accPeriodstatus
                                    .toString()
                                    .toLowerCase() === "active" &&
                                  this.state.formData.adj.toString() !== "Y" &&
                                  this.state.formData.ispayment !== "Yes"
                                ? false
                                : this.state.formData.vendorID === 0
                                ? false
                                : true
                            }
                          >
                            Add Row
                          </Button>

                          <div className="total-amount">
                            Total: {this.state.totalAmount}
                            {this.state.isAmountDiff === "Yes" && (
                              <span className="text-danger">
                                {" "}
                                {`(${this.state.totalAmountdiff})`}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  </div>

                  <div className="filter-sec upload-section">
                    {!this.state.isRepeat && (
                      <Form.Group controlId="exampleForm.ControlTextarea1">
                        <div className="d-flex">
                          <Form.Label className="mr-auto">
                            Attachments
                          </Form.Label>
                          {this.state.savedfiles.length > 0 && (
                            <div className="upload-link">
                              <button
                                type="button"
                                className="btn wht-bg link-btn mr-auto"
                                onClick={this.OpenViewer}
                              >
                                {this.state.isOpenViewer
                                  ? "Close Viewer"
                                  : "Open Viewer"}
                              </button>
                            </div>
                          )}
                        </div>
                        <div>
                          <Dropzone
                            onDrop={this.onDrop}
                            // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                          >
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                              isDragReject,
                            }) => (
                              <>
                                <section
                                  className={
                                    isDragActive
                                      ? "container upload-area default drag-active "
                                      : "container upload-area default"
                                  }
                                >
                                  {!this.state.bulkSelect && (
                                    <div
                                      {...getRootProps({
                                        className:
                                          "dropzone d-flex align-items-center",
                                        onClick:
                                          this.state.newSelectfiles.length >
                                            0 ||
                                          this.state.savedfiles.length > 0
                                            ? (event) => event.stopPropagation()
                                            : (event) => event,
                                      })}
                                    >
                                      <input {...getInputProps()} />
                                      {this.state.newSelectfiles.length < 1 &&
                                        this.state.savedfiles.length < 1 && (
                                          <p>
                                            Drag and drop transactions or{" "}
                                            <span>browse files</span> to upload.
                                          </p>
                                        )}
                                      {(this.state.newSelectfiles.length > 0 ||
                                        this.state.savedfiles.length > 0) &&
                                        isDragActive && (
                                          <p>
                                            Drag and drop transactions here to
                                            upload.
                                          </p>
                                        )}
                                    </div>
                                  )}
                                  {(this.state.newSelectfiles.length > 0 ||
                                    this.state.savedfiles.length > 0) && (
                                    <aside className="d-flex flex-column">
                                      <ul>{files}</ul>
                                      <ul>{files1}</ul>
                                    </aside>
                                  )}
                                </section>
                                {!this.state.bulkSelect &&
                                  (this.state.newSelectfiles.length > 0 ||
                                    this.state.savedfiles.length > 0) && (
                                    <div className="upload-link mrgn-top">
                                      <button
                                        type="button"
                                        className="btn wht-bg link-btn mr-auto"
                                      >
                                        Add Attachment
                                      </button>
                                      <Form.Control
                                        id="formControlsFile"
                                        type="file"
                                        multiple
                                        onChange={(event: any) =>
                                          this.onFileChange(event, "1")
                                        }
                                        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                      />
                                    </div>
                                  )}
                              </>
                            )}
                          </Dropzone>
                        </div>
                      </Form.Group>
                    )}
                  </div>

                  {this.state.isComment && (
                    <div
                      className={
                        this.state.formData.vendorID === 0 ||
                        this.state.isStateChanged ||
                        this.state.formData.incompleteUniqueno > 0 ||
                        (this.state.formData.approved.toLowerCase() !==
                          "App".toLowerCase() &&
                          this.state.approveInvoiceStatus?.filter(
                            (e) =>
                              e.statusType === "Waiting on Me" && e.status === 0
                          ).length > 0 &&
                          this.state.vendorApproval.toLowerCase() === "app")
                          ? "footer-show"
                          : ""
                      }
                    >
                      <CommentBox
                        ref={this.ChildComment}
                        hotelid={this.state.hotelValue}
                        entryType={this.state.pageType}
                        uniqueNo={
                          this.state.formData.actionType === "copy"
                            ? 0
                            : this.state.pageType === "Invoice"
                            ? this.state.formData.uniqueno
                            : this.state.formData.incompleteUniqueno
                        }
                        precommentlist={this.state.htmlcomment}
                        callBackCommentLoad={this.callBackCommentLoad}
                        parentScrollMethod={this.scrollToBottom}
                        updatedCommentItem={this.updatedCommentItem}
                        commentModalClose={this.CommentModalClose}
                        canReview={this.state.canReview}
                        canFlag={this.state.canFlag}
                        showbanner={this.showbanner}
                        currentReviewStatus={this.state.selectedReviewStatus}

                        // addCommentDisabled={this.state.isError === "NotEdit" ? true : false}
                      />
                    </div>
                  )}

                  {this.state.vendorApproval.toLowerCase() === "app" &&
                  this.state.formData.accPeriodstatus
                    .toString()
                    .toLowerCase() === "active" &&
                  this.state.formData.approved.toLowerCase() !==
                    "App".toLowerCase() &&
                  this.state.formData.actionType !== "copy" &&
                  this.state.formData.actionType !== "move" &&
                  this.state.formData.uniqueno > 0 ? (
                    <>
                      {(this.state.approveInvoiceStatus?.filter(
                        (e) =>
                          e.statusType === "Waiting on Me" && e.status === 0
                      ).length > 0 ||
                        this.state.isStateChanged) && (
                        <div className={"footer-section viewer-panel"}>
                          <div>
                            <div className="d-flex align-items-center justify-content-end height-72">
                              <div className="d-flex align-items-center">
                                {this.state.approveInvoiceStatus?.filter(
                                  (e) =>
                                    e.statusType === "Waiting on Me" &&
                                    e.status === 0
                                ).length > 0 && !this.state.isStateChanged ? (
                                  <>
                                    {this.state.isNextInvoice && (
                                      <Form.Group
                                        className="space"
                                        controlId="formBasicCheckbox"
                                      >
                                        <Form.Check
                                          type="checkbox"
                                          label="Proceed to Next Invoice"
                                          checked={this.state.createOther}
                                          disabled={
                                            this.state.formData.vendorID === 0
                                              ? true
                                              : false
                                          }
                                          onChange={(event: any) =>
                                            this.handleChangeNext(event)
                                          }
                                          custom
                                        />
                                      </Form.Group>
                                    )}
                                    <Dropdown
                                      className="more-action hasDropShadow wom_hasDropShadow"
                                      alignRight
                                    >
                                      <Dropdown.Toggle
                                        className="isNoBtn"
                                        variant="success"
                                        id="dropdown-split-basic"
                                        disabled={this.state.isApproveClicked}
                                      >
                                        <Button
                                          id="btnruleApp"
                                          disabled={this.state.isApproveClicked}
                                          onClick={(e: any) => this.showRules()}
                                        >
                                          {" "}
                                          Approve
                                        </Button>
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        className={
                                          this.state.showRuleModal
                                            ? "wom_setToRight"
                                            : "d-none wom_setToRight"
                                        }
                                      >
                                        {this.state.showRuleModal && (
                                          <OutsideClickHandler
                                            onOutsideClick={
                                              this.hideApprovalModal
                                            }
                                          >
                                            <div className="confirmModal wom_confirmModal">
                                              <div className="title">
                                                Mark Approvals to Complete
                                              </div>
                                              <div className="description wom_description">
                                                <div className="wom_ApprovalsList">
                                                  <ul>
                                                    {this.state.rulesArray.map(
                                                      (
                                                        item: any,
                                                        index: any
                                                      ) => {
                                                        let id =
                                                          "idal_" + index;
                                                        return (
                                                          <li key={index}>
                                                            <Form.Check
                                                              className={
                                                                item.key ===
                                                                "primary"
                                                                  ? "wom_formCheck isPrimary"
                                                                  : "wom_formCheck"
                                                              }
                                                              type="checkbox"
                                                              label={ruleToolTip(
                                                                item
                                                              )}
                                                              id={id}
                                                              checked={
                                                                item.isCheck
                                                              }
                                                              onClick={(
                                                                e: any
                                                              ) =>
                                                                this.approvalcheckChange(
                                                                  e,
                                                                  item
                                                                )
                                                              }
                                                            />
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                </div>
                                              </div>
                                              <div className="action-link">
                                                <Button
                                                  className="btn btnCancel"
                                                  onClick={
                                                    this.hideApprovalModal
                                                  }
                                                >
                                                  Cancel
                                                </Button>
                                                <Button
                                                  variant="primary"
                                                  className="btn btnApprove"
                                                  onClick={() =>
                                                    this.invoiceToApprove()
                                                  }
                                                  disabled={appDisabled || this.state.isApproveClicked}
                                                >
                                                  {" "}
                                                  Approve
                                                </Button>
                                              </div>
                                            </div>
                                          </OutsideClickHandler>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </>
                                ) : (
                                  <>
                                    {this.state.isStateChanged && (
                                      <>
                                        <Button
                                          variant="primary"
                                          type="button"
                                          className="space btn btn-primary btn-discard"
                                          onClick={() =>
                                            this.handleDiscard(
                                              this.state.invoiceUniqueNo
                                            )
                                          }
                                        >
                                          Discard
                                        </Button>
                                        <Button
                                          id="btnInvoice"
                                          variant="primary"
                                          type="button"
                                          className={
                                            this.state.isPermission === "Yes"
                                              ? ""
                                              : "disabled-area"
                                          }
                                          onClick={() =>
                                            this.saveInvoice("INVOICES", false)
                                          }
                                          disabled={
                                            this.state.formData.vendorID === 0
                                              ? true
                                              : this.state.isDisabled
                                          }
                                          onKeyDown={(e: any) =>
                                            this.onTAB("btnInvoice-1", 0, e)
                                          }
                                        >
                                          {"Save"}
                                        </Button>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className={
                        this.state.pageType !== "Invoice" ||
                        this.state.isStateChanged
                          ? "footer-section viewer-panel"
                          : "footer-section viewer-panel isHide"
                      }
                    >
                      <div
                        className={
                          (this.state.formData.vendorID === 0 &&
                            this.state.isInvoiceEntry === "No") ||
                          this.state.isError === "NotEdit"
                            ? "disabled-area"
                            : ""
                        }
                      >
                        <div className="d-flex align-items-center justify-content-end height-72">
                          <div className="d-flex align-items-center">
                            {this.state.invoiceUniqueNo === 0 && (
                              <Form.Group controlId="formBasicCheckbox">
                                <Form.Check
                                  type="checkbox"
                                  label="Proceed to Next"
                                  checked={this.state.createOther}
                                  disabled={
                                    isBankSyncInvoice
                                      ? true
                                      : this.state.formData.vendorID === 0
                                      ? true
                                      : false
                                  }
                                  onChange={(event: any) =>
                                    this.handleChangeNext(event)
                                  }
                                  custom
                                />
                              </Form.Group>
                            )}

                            <Button
                              variant="primary"
                              type="button"
                              className="space btn btn-primary btn-discard"
                              onClick={() =>
                                this.handleDiscard(this.state.invoiceUniqueNo)
                              }
                            >
                              Discard
                            </Button>

                            {(this.state.formData.uniqueno === 0 ||
                              this.state.formData.actionType === "copy") &&
                              this.state.isStateChanged && (
                                <Button
                                  id="btnIncompleteInvoice"
                                  variant="primary"
                                  className="btn-outline-primary"
                                  type="button"
                                  onClick={() =>
                                    this.saveInvoice("INCOMPLETEINVOICE", false)
                                  }
                                  disabled={
                                    this.state.formData.actionType === "move"
                                      ? this.state.formData.vendorID > 0 ||
                                        this.state.savedfiles.length > 0 ||
                                        this.state.isAccount
                                        ? false
                                        : true
                                      : this.state.formData.vendorID === 0 ||
                                        !this.state.isAccount
                                      ? true
                                      : this.state.isDisabled
                                  }
                                  onKeyDown={(e: any) =>
                                    this.onTAB("btnIncompleteInvoice-1", 0, e)
                                  }
                                >
                                  {isBankSyncInvoice
                                    ? "Save Draft"
                                    : "Save Changes"}
                                </Button>
                              )}
                            {(this.state.pageType !== "Invoice" ||
                              this.state.isStateChanged) &&
                              !isBypassRules && (
                                <Button
                                  id="btnInvoice"
                                  variant="primary"
                                  type="button"
                                  className={
                                    !isEditPermission1 ? "" : "disabled-area"
                                  }
                                  onClick={() =>
                                    this.saveInvoice("INVOICES", false)
                                  }
                                  disabled={
                                    this.state.formData.vendorID === 0 ||
                                    !this.state.isAccount
                                      ? true
                                      : this.state.isDisabled
                                  }
                                  onKeyDown={(e: any) =>
                                    this.onTAB("btnInvoice-1", 0, e)
                                  }
                                >
                                  {this.state.formData.uniqueno > 0 &&
                                  this.state.formData.actionType != "copy"
                                    ? "Save"
                                    : "Send to Approval"}
                                </Button>
                              )}

                            {isBypassRules && (
                              <Button
                                id="btnInvoice"
                                variant="primary"
                                type="button"
                                className={
                                  !isEditPermission1 ? "" : "disabled-area"
                                }
                                onClick={() => this.postTransaction()}
                                disabled={
                                  this.state.formData.vendorID === 0 ||
                                  !this.state.isAccount
                                    ? true
                                    : this.state.isDisabled
                                }
                                onKeyDown={(e: any) =>
                                  this.onTAB("btnInvoice-1", 0, e)
                                }
                              >
                                {bypassBtnName}
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Container>

            {this.state.ispopupshow && !this.state.isMarkAsPaidClicked && (
              <div className="react-confirm-alert-overlay confirm-modal undefined">
                <div className="react-confirm-alert">
                  <div className="react-confirm-alert-body">
                    <h1>Upload Confirmation</h1>
                    Do you need to attach an invoice?
                    <div className="react-confirm-alert-button-group">
                      <button
                        type="button"
                        className="btn"
                        onClick={this.isHandleAction}
                      >
                        No
                      </button>
                      <div className="upload-link">
                        <button type="button" className="btn">
                          Yes
                        </button>
                        <Form.Control
                          id="formControlsFile"
                          type="file"
                          multiple
                          onChange={(event: any) => this.onFileChange(event, 2)}
                          accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(this.state.isSpinner || this.state.isSaveSpinner) && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}
            {this.state.showInvoiceModal && (
              <Modal
                className="move-invoice-modal"
                show={this.state.showInvoiceModal}
              >
                <Modal.Header>
                  <Modal.Title>Move invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group
                    className="rm-bottom-margin"
                    controlId="vendorName"
                  >
                    <Form.Label>EHID</Form.Label>
                    <SingleSelectSearchDDL
                      ref={this.singleSerch}
                      returnData={this.returnEHIDList}
                      moduleName={"Invoice"}
                      defaultText={"EHID"}
                      selectedHID={this.state.hotelValue}
                      pageType={"Invoice"}
                    ></SingleSelectSearchDDL>
                  </Form.Group>
                  {/* {isMrkPdTgglOn && (isCC || isMach) && (
                    <Form.Group
                      className={
                        this.state.accountlist.length === 0
                          ? "rm-bottom-margin disabled-area"
                          : this.state.moveHID.hidValue === -1
                            ? "rm-bottom-margin disabled-area"
                            : "rm-bottom-margin"
                      }
                      controlId="vendorName"
                    >
                      <Form.Label>Account</Form.Label>
                      {this.state.isAccount && (
                        <SingleDropdownListWithoutSearch
                          id={"accoutlistmodal"}
                          itemList={this.state.accountlist}
                          handleSelectedItem={this.handleSelectedItem.bind(
                            this,
                            7 + "_" + 0
                          )}
                          defaultItem={this.state.defaultaccountType}
                          defaultText={"Account"}
                          defaultName={this.state.defaultaccountType}
                          controlID="7"
                        // disabled={!this.state.moveselected}
                        />
                      )}
                    </Form.Group>
                  )} */}

                  <Form.Group
                    className={
                      this.state.moveHID.hidValue === -1
                        ? "rm-bottom-margin disabled-area"
                        : "rm-bottom-margin"
                    }
                    controlId="vendorName"
                  >
                    <Form.Label>Accounting Period</Form.Label>
                    <SingleDropdownListWithoutSearch
                      id={"accountingPeriod1"}
                      itemList={this.state.PeriodList}
                      handleSelectedItem={this.handleSelectedItem.bind(
                        this,
                        10 + "_" + 0
                      )}
                      defaultItem={this.state.defaultPeriod}
                      defaultText={"Accouting Period"}
                      defaultName={this.state.defaultPeriod}
                      controlID="6"
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="btn-outline-primary"
                    onClick={this.hideMoveInvoiceModal}
                  >
                    Close
                  </Button>
                  <Button
                    className="btn-primary"
                    disabled={this.state.movebuttonDisable}
                    onClick={this.moveInvoiceEHID}
                  >
                    Move
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </div>

          {this.state.creditCardStatementModal && (
            <>
              <CreditCardStatementImport
                pageName="InvoiceEntrySlideout"
                hidValue={this.state.hotelValue}
                hotelName={this.state.hotelName}
                oprId={this.state.formData.oprID}
                hideCreditCardModal={this.hideCreditCardModal.bind(this)}
                importedStatementData={this.importedStatementData}
              />
            </>
          )}
        </div>
        {this.state.textractMap === true && (
          <TextractMapping
            PdfExtractList={this.state.PdfExtractList}
            selectedExtractFile={this.state.selectedExtractFile}
            mapData={this.state.mapData}
            LinemapData={this.state.LinemapData}
            closeTextract={this.closeTextract.bind(this)}
            invoiceMapDate={this.invoiceMapData.bind(this)}
            isMapped={this.state.isMapped}
            updateParentMapping={this.updateMappingFromChild.bind(this)}
            tableItemList={this.state.selectedTableItemList}
          />
        )}

        <Modal
          className="move-invoice-modal invoice-approval-modal"
          show={this.state.isApproveButton}
          onHide={this.retunToInvoice}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>New Approval Required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.approveInvoiceStatus?.filter(
              (e) => e.statusType === "Waiting on Me" && e.status === 0
            ).length === 0 && (
              <div className="info">
                <div>
                  Because of invoice changes, a new approval is required:
                </div>
                <div className="bold">
                  You are not able to complete the approval.
                </div>
              </div>
            )}
            {this.state.approveInvoiceStatus?.filter(
              (e) => e.statusType === "Waiting on Me" && e.status === 0
            ).length > 0 && (
              <div className="info">
                Because of invoice changes, a new approval is required:
              </div>
            )}
            <div className="invoice-approval">
              <div className="card">
                <div className="card-body">
                  <ul>
                    {this.state.approveInvoiceStatus?.map(
                      (item: any, index: any) => {
                        return (
                          <>
                            {item.status === 0 && (
                              <li
                                className="d-flex align-items-center"
                                key={index}
                              >
                                <div
                                  className={`badge
                                                        ${
                                                          item.statusType1 ===
                                                          "Waiting on Me"
                                                            ? "orange"
                                                            : ""
                                                        }
                                                        ${
                                                          item.status === 1
                                                            ? "green"
                                                            : ""
                                                        }`}
                                >
                                  {item.status === 0
                                    ? item.statusType1 === "Waiting on Me"
                                      ? "Waiting on Me"
                                      : "Waiting on Others"
                                    : "Completed"}
                                </div>
                                <div
                                  className={
                                    item.status === 1 ? "completed" : ""
                                  }
                                >
                                  {item.ruleName}
                                </div>
                              </li>
                            )}
                          </>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-discard"
              onClick={() => this.retunToInvoice()}
            >
              Return to Invoice
            </Button>
            {this.state.approveInvoiceStatus?.filter(
              (e) => e.statusType === "Waiting on Me" && e.status === 0
            ).length > 0 && (
              <Dropdown
                className="more-action hasDropShadow wom_hasDropShadow"
                alignRight
              >
                <Dropdown.Toggle
                  className="isNoBtn"
                  variant="success"
                  id="dropdown-split-basic"
                  disabled={this.state.isApproveClicked}
                >
                  <Button disabled={this.state.isApproveClicked} onClick={(e: any) => this.showRules()}>
                    {" "}
                    Approve
                  </Button>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className={
                    this.state.showRuleModal
                      ? "wom_setToRight"
                      : "d-none wom_setToRight"
                  }
                >
                  {this.state.showRuleModal && (
                    <OutsideClickHandler
                      onOutsideClick={this.hideApprovalModal}
                    >
                      <div className="confirmModal wom_confirmModal">
                        <div className="title">Mark Approvals to Complete</div>
                        <div className="description wom_description">
                          <div className="wom_ApprovalsList">
                            <ul>
                              {this.state.rulesArray.map(
                                (item: any, index: any) => {
                                  let id = "idal_" + index;
                                  return (
                                    <li key={index}>
                                      <Form.Check
                                        className={
                                          item.key === "primary"
                                            ? "wom_formCheck isPrimary"
                                            : "wom_formCheck"
                                        }
                                        type="checkbox"
                                        label={ruleToolTip(item)}
                                        id={id}
                                        checked={item.isCheck}
                                        onClick={(e: any) =>
                                          this.approvalcheckChange(e, item)
                                        }
                                      />
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="action-link">
                          <Button
                            className="btn btnCancel"
                            onClick={this.hideApprovalModal}
                          >
                            Cancel
                          </Button>
                          {this.state.approveInvoiceStatus?.filter(
                            (e) =>
                              e.statusType === "Waiting on Me" && e.status === 0
                          ).length > 0 && (
                            <Button
                              variant="primary"
                              className="btn btnApprove"
                              onClick={() => this.invoiceToApprove()}
                              disabled={appDisabled || this.state.isApproveClicked}
                            >
                              {" "}
                              Approve
                            </Button>
                          )}
                        </div>
                      </div>
                    </OutsideClickHandler>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Modal.Footer>
        </Modal>

        {this.state.paymentModal && false && (
          <Modal
            className="move-invoice-modal mark-invoice-as-paid"
            show={this.state.paymentModal}
            onHide={this.hidePaymentModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Mark Invoice as Paid</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <Form.Group
                    className={
                      this.state.accountlist.length === 0
                        ? "rm-bottom-margin event-disabled account-dropdown"
                        : "rm-bottom-margin account-dropdown"
                    }
                    controlId="vendorName"
                  >
                    <Form.Label>Account</Form.Label>
                    {this.state.isAccount && (
                      <SingleDropdownListWithoutSearch
                        id={"accoutlistmodal"}
                        itemList={this.state.accountlist}
                        handleSelectedItem={this.handleSelectedItem.bind(
                          this,
                          7 + "_" + 0
                        )}
                        defaultItem={this.state.defaultaccountType}
                        defaultText={"Account"}
                        defaultName={this.state.defaultaccountType}
                        controlID="7"
                      />
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    className="rm-bottom-margin"
                    controlId="vendorName"
                  >
                    <Form.Label>Amount Paid</Form.Label>
                    <Form.Control
                      placeholder="Amount Paid"
                      value={this.state.formData.transactionTotal}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="rm-bottom-margin" controlId="amount">
                    <Form.Label>Payment Date</Form.Label>
                    <div className="date-picker calender-picker">
                      <div
                        className="drop-arrow"
                        onClick={(event: any) =>
                          this.handleDatePicker(event, this.trpaymentdate)
                        }
                      >
                        <svg
                          width="8"
                          height="6"
                          viewBox="0 0 8 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                            fill="#3F4347"
                          />
                        </svg>
                      </div>
                      <DatePicker
                        id="paymentdate"
                        ref={this.trpaymentdate}
                        tabIndex={this.state.tabEnable}
                        className="form-control"
                        placeholderText={"MM/DD/YY"}
                        dateFormat="MM/dd/yy"
                        selected={
                          this.state.formData.gDate === null
                            ? ""
                            : new Date(this.state.formData.gDate)
                        }
                        onChange={(event: any) =>
                          this.handleChange(event, "gDate")
                        }
                        onKeyDown={(e: any) =>
                          this.onTAB("paymentdate-1", 0, e)
                        }
                        autoComplete="off"
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group
                    className="rm-bottom-margin"
                    controlId="vendorName"
                  >
                    <Form.Label>Type</Form.Label>
                    <SingleDropdownListWithoutSearch
                      id={"paymentTypemodal"}
                      itemList={
                        this.state.formData.ispayment !== "Yes"
                          ? this.state.paymentTypePaid
                          : this.state.paymentTypePaid.filter(
                              (x) => x.id === "ACH"
                            )
                      }
                      handleSelectedItem={this.handleSelectedItem.bind(
                        this,
                        15 + "_" + 0
                      )}
                      defaultItem={
                        this.state.defaultpaymentType.toLowerCase() === "ach"
                          ? "Manual ACH"
                          : this.state.defaultpaymentType
                      }
                      defaultText={"Type"}
                      defaultName={
                        this.state.defaultpaymentType.toLowerCase() === "ach"
                          ? "Manual ACH"
                          : this.state.defaultpaymentType
                      }
                      controlID="5"
                      isbank={this.state.isbank}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group
                className="remove-btm-space"
                controlId="markInvoiceAsPaid.ControlTextarea1"
              >
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  id="txtNotes"
                  as="textarea"
                  placeholder="Add notes"
                  wrap="hard"
                  rows={3}
                  value={this.state.formData.paymentNotes}
                  maxLength={99}
                  onChange={(event: any) =>
                    this.handleChange(event, "paymentNotes")
                  }
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-outline-primary"
                onClick={this.hidePaymentModal}
              >
                Close
              </Button>
              <Button
                className="btn-primary"
                disabled={this.state.isPaidButtonDisabled}
                onClick={() => {
                  this.markAsPaidUnpaid("Paid");
                }}
              >
                Mark as Paid
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <Modal
          className="move-invoice-modal mark-invoice-as-paid"
          show={this.state.showBulkSelectCoa}
          onHide={this.hideBulkSelectCoaModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Select COA </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group
                  controlId="COA"
                  className="more-action single-select-image dropdown coa-select"
                >
                  <Form.Label>COA</Form.Label>
                  <Typeahead
                    id="bulkSelectCoa"
                    onChange={(selected) => {
                      this.handleBulkSelectedCoa(selected);
                    }}
                    options={this.state.coaList}
                    placeholder="Enter COA"
                    selected={this.state.bulkSelectedCOA}
                    renderMenu={(results: any, menuProps) => (
                      <Menu {...menuProps}>
                        {results.map((result: any, index: any) => (
                          <>
                            {result.label !== "" && (
                              <MenuItem option={result} position={index}>
                                <EllipsisWithTooltip placement="bottom">
                                  {result.label}
                                </EllipsisWithTooltip>
                              </MenuItem>
                            )}
                            {result.label === "" && (
                              <MenuItem
                                className="load-more"
                                option={result}
                                position={index}
                              >
                                Load More
                              </MenuItem>
                            )}
                          </>
                        ))}
                      </Menu>
                    )}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-outline-primary"
              onClick={this.hideBulkSelectCoaModal}
            >
              Close
            </Button>
            <Button
              className="btn-primary"
              disabled={this.state.bulkSelectedCOA.length === 0}
              onClick={this.saveBulkSelectedCOA}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        {this.state.showCommentModal && (
          <CommentWithoutList
            hotelid={this.state.hotelValue}
            closeCommentModal={this.closeCommentModal}
            addReviewComment={this.addReviewComment}
            title={this.state.commentModalTitle}
          />
        )}
      </>
    );
  }
}
